'use es6';

/**
 * IMPORTANT: This package was built to be vendor'd into this app until it is
 * vetted as a good long-term solution. If you need to update the version of
 * this library, you can use this repackage setup to generate it:
 * HubSpot/bender-repackages/compare/banderson/swagger-client-v1
 */

/* eslint-disable */
// declare regeneratorRuntime in global scope to avoid CSP issues:
// https://github.com/swagger-api/swagger-ui/issues/5817
window.regeneratorRuntime = null;
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function getAugmentedNamespace(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function () {
        return e[r];
      }
    });
  }), t;
}
function createCommonjsModule(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}
function commonjsRequire(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets option of @rollup/plugin-commonjs appropriately for this require call to behave properly.');
}
var runtime_1 = createCommonjsModule(function (e) {
    var t = function (e) {
      var t,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        a = o.iterator || "@@iterator",
        i = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";
      function c(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        c({}, "");
      } catch (e) {
        c = function (e, t, r) {
          return e[t] = r;
        };
      }
      function u(e, t, r, n) {
        var o = t && t.prototype instanceof g ? t : g,
          a = Object.create(o.prototype),
          i = new P(n || []);
        return a._invoke = function (e, t, r) {
          var n = f;
          return function (o, a) {
            if (n === h) throw new Error("Generator is already running");
            if (n === y) {
              if ("throw" === o) throw a;
              return C();
            }
            for (r.method = o, r.arg = a;;) {
              var i = r.delegate;
              if (i) {
                var s = S(i, r);
                if (s) {
                  if (s === d) continue;
                  return s;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === f) throw n = y, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = h;
              var c = l(e, t, r);
              if ("normal" === c.type) {
                if (n = r.done ? y : p, c.arg === d) continue;
                return {
                  value: c.arg,
                  done: r.done
                };
              }
              "throw" === c.type && (n = y, r.method = "throw", r.arg = c.arg);
            }
          };
        }(e, r, i), a;
      }
      function l(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = u;
      var f = "suspendedStart",
        p = "suspendedYield",
        h = "executing",
        y = "completed",
        d = {};
      function g() {}
      function m() {}
      function b() {}
      var v = {};
      v[a] = function () {
        return this;
      };
      var _ = Object.getPrototypeOf,
        A = _ && _(_(I([])));
      A && A !== r && n.call(A, a) && (v = A);
      var E = b.prototype = g.prototype = Object.create(v);
      function $(e) {
        ["next", "throw", "return"].forEach(function (t) {
          c(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function O(e, t) {
        function r(o, a, i, s) {
          var c = l(e[o], e, a);
          if ("throw" !== c.type) {
            var u = c.arg,
              f = u.value;
            return f && "object" == typeof f && n.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
              r("next", e, i, s);
            }, function (e) {
              r("throw", e, i, s);
            }) : t.resolve(f).then(function (e) {
              u.value = e, i(u);
            }, function (e) {
              return r("throw", e, i, s);
            });
          }
          s(c.arg);
        }
        var o;
        this._invoke = function (e, n) {
          function a() {
            return new t(function (t, o) {
              r(e, n, t, o);
            });
          }
          return o = o ? o.then(a, a) : a();
        };
      }
      function S(e, r) {
        var n = e.iterator[r.method];
        if (n === t) {
          if (r.delegate = null, "throw" === r.method) {
            if (e.iterator.return && (r.method = "return", r.arg = t, S(e, r), "throw" === r.method)) return d;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return d;
        }
        var o = l(n, e.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, d;
        var a = o.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, d) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
      }
      function T(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function w(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function P(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(T, this), this.reset(!0);
      }
      function I(e) {
        if (e) {
          var r = e[a];
          if (r) return r.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function r() {
                for (; ++o < e.length;) if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
                return r.value = t, r.done = !0, r;
              };
            return i.next = i;
          }
        }
        return {
          next: C
        };
      }
      function C() {
        return {
          value: t,
          done: !0
        };
      }
      return m.prototype = E.constructor = b, b.constructor = m, m.displayName = c(b, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, b) : (e.__proto__ = b, c(e, s, "GeneratorFunction")), e.prototype = Object.create(E), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, $(O.prototype), O.prototype[i] = function () {
        return this;
      }, e.AsyncIterator = O, e.async = function (t, r, n, o, a) {
        void 0 === a && (a = Promise);
        var i = new O(u(t, r, n, o), a);
        return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, $(E), c(E, s, "Generator"), E[a] = function () {
        return this;
      }, E.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];
        for (var r in e) t.push(r);
        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }
          return r.done = !0, r;
        };
      }, e.values = I, P.prototype = {
        constructor: P,
        reset: function (e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(w), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var r = this;
          function o(n, o) {
            return s.type = "throw", s.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }
          for (var a = this.tryEntries.length - 1; a >= 0; --a) {
            var i = this.tryEntries[a],
              s = i.completion;
            if ("root" === i.tryLoc) return o("end");
            if (i.tryLoc <= this.prev) {
              var c = n.call(i, "catchLoc"),
                u = n.call(i, "finallyLoc");
              if (c && u) {
                if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return o(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return o(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var a = o;
              break;
            }
          }
          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var i = a ? a.completion : {};
          return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, d) : this.complete(i);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), w(r), d;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.tryLoc === e) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                w(r);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (e, r, n) {
          return this.delegate = {
            iterator: I(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), d;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  }),
  check = function check(e) {
    return e && e.Math == Math && e;
  },
  global$1 = check("object" == typeof globalThis && globalThis) || check("object" == typeof window && window) || check("object" == typeof self && self) || check("object" == typeof commonjsGlobal && commonjsGlobal) || function () {
    return this;
  }() || Function("return this")(),
  fails = function fails(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  },
  descriptors = !fails(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function () {
        return 7;
      }
    })[1];
  }),
  nativePropertyIsEnumerable = {}.propertyIsEnumerable,
  getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
  NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
    1: 2
  }, 1),
  f = NASHORN_BUG ? function (e) {
    var t = getOwnPropertyDescriptor(this, e);
    return !!t && t.enumerable;
  } : nativePropertyIsEnumerable,
  objectPropertyIsEnumerable = {
    f: f
  },
  createPropertyDescriptor = function createPropertyDescriptor(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  },
  toString = {}.toString,
  classofRaw = function classofRaw(e) {
    return toString.call(e).slice(8, -1);
  },
  split = "".split,
  indexedObject = fails(function () {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == classofRaw(e) ? split.call(e, "") : Object(e);
  } : Object,
  requireObjectCoercible = function requireObjectCoercible(e) {
    if (null == e) throw TypeError("Can't call method on " + e);
    return e;
  },
  toIndexedObject = function toIndexedObject(e) {
    return indexedObject(requireObjectCoercible(e));
  },
  isObject = function isObject(e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  },
  toPrimitive = function toPrimitive(e, t) {
    if (!isObject(e)) return e;
    var r, n;
    if (t && "function" == typeof (r = e.toString) && !isObject(n = r.call(e))) return n;
    if ("function" == typeof (r = e.valueOf) && !isObject(n = r.call(e))) return n;
    if (!t && "function" == typeof (r = e.toString) && !isObject(n = r.call(e))) return n;
    throw TypeError("Can't convert object to primitive value");
  },
  hasOwnProperty = {}.hasOwnProperty,
  has = function has(e, t) {
    return hasOwnProperty.call(e, t);
  },
  document$1 = global$1.document,
  EXISTS = isObject(document$1) && isObject(document$1.createElement),
  documentCreateElement = function documentCreateElement(e) {
    return EXISTS ? document$1.createElement(e) : {};
  },
  ie8DomDefine = !descriptors && !fails(function () {
    return 7 != Object.defineProperty(documentCreateElement("div"), "a", {
      get: function () {
        return 7;
      }
    }).a;
  }),
  nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
  f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function (e, t) {
    if (e = toIndexedObject(e), t = toPrimitive(t, !0), ie8DomDefine) try {
      return nativeGetOwnPropertyDescriptor(e, t);
    } catch (e) {}
    if (has(e, t)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(e, t), e[t]);
  },
  objectGetOwnPropertyDescriptor = {
    f: f$1
  },
  replacement = /#|\.prototype\./,
  isForced = function isForced(e, t) {
    var r = data[normalize(e)];
    return r == POLYFILL || r != NATIVE && ("function" == typeof t ? fails(t) : !!t);
  },
  normalize = isForced.normalize = function (e) {
    return String(e).replace(replacement, ".").toLowerCase();
  },
  data = isForced.data = {},
  NATIVE = isForced.NATIVE = "N",
  POLYFILL = isForced.POLYFILL = "P",
  isForced_1 = isForced,
  path = {},
  aFunction = function aFunction(e) {
    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
    return e;
  },
  functionBindContext = function functionBindContext(e, t, r) {
    if (aFunction(e), void 0 === t) return e;
    switch (r) {
      case 0:
        return function () {
          return e.call(t);
        };
      case 1:
        return function (r) {
          return e.call(t, r);
        };
      case 2:
        return function (r, n) {
          return e.call(t, r, n);
        };
      case 3:
        return function (r, n, o) {
          return e.call(t, r, n, o);
        };
    }
    return function () {
      return e.apply(t, arguments);
    };
  },
  anObject = function anObject(e) {
    if (!isObject(e)) throw TypeError(String(e) + " is not an object");
    return e;
  },
  nativeDefineProperty = Object.defineProperty,
  f$2 = descriptors ? nativeDefineProperty : function (e, t, r) {
    if (anObject(e), t = toPrimitive(t, !0), anObject(r), ie8DomDefine) try {
      return nativeDefineProperty(e, t, r);
    } catch (e) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
    return "value" in r && (e[t] = r.value), e;
  },
  objectDefineProperty = {
    f: f$2
  },
  createNonEnumerableProperty = descriptors ? function (e, t, r) {
    return objectDefineProperty.f(e, t, createPropertyDescriptor(1, r));
  } : function (e, t, r) {
    return e[t] = r, e;
  },
  getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f,
  wrapConstructor = function wrapConstructor(e) {
    var t = function t(t, r, n) {
      if (this instanceof e) {
        switch (arguments.length) {
          case 0:
            return new e();
          case 1:
            return new e(t);
          case 2:
            return new e(t, r);
        }
        return new e(t, r, n);
      }
      return e.apply(this, arguments);
    };
    return t.prototype = e.prototype, t;
  },
  _export = function _export(e, t) {
    var r,
      n,
      o,
      a,
      i,
      s,
      c,
      u,
      l = e.target,
      f = e.global,
      p = e.stat,
      h = e.proto,
      y = f ? global$1 : p ? global$1[l] : (global$1[l] || {}).prototype,
      d = f ? path : path[l] || (path[l] = {}),
      g = d.prototype;
    for (o in t) r = !isForced_1(f ? o : l + (p ? "." : "#") + o, e.forced) && y && has(y, o), i = d[o], r && (s = e.noTargetGet ? (u = getOwnPropertyDescriptor$1(y, o)) && u.value : y[o]), a = r && s ? s : t[o], r && typeof i == typeof a || (c = e.bind && r ? functionBindContext(a, global$1) : e.wrap && r ? wrapConstructor(a) : h && "function" == typeof a ? functionBindContext(Function.call, a) : a, (e.sham || a && a.sham || i && i.sham) && createNonEnumerableProperty(c, "sham", !0), d[o] = c, h && (has(path, n = l + "Prototype") || createNonEnumerableProperty(path, n, {}), path[n][o] = a, e.real && g && !g[o] && createNonEnumerableProperty(g, o, a)));
  };
_export({
  target: "Object",
  stat: !0,
  forced: !descriptors,
  sham: !descriptors
}, {
  defineProperty: objectDefineProperty.f
});
var defineProperty_1 = createCommonjsModule(function (e) {
    var t = path.Object,
      r = e.exports = function (e, r, n) {
        return t.defineProperty(e, r, n);
      };
    t.defineProperty.sham && (r.sham = !0);
  }),
  defineProperty = defineProperty_1,
  defineProperty$1 = defineProperty,
  ceil = Math.ceil,
  floor = Math.floor,
  toInteger = function toInteger(e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? floor : ceil)(e);
  },
  min = Math.min,
  toLength = function toLength(e) {
    return e > 0 ? min(toInteger(e), 9007199254740991) : 0;
  },
  max = Math.max,
  min$1 = Math.min,
  toAbsoluteIndex = function toAbsoluteIndex(e, t) {
    var r = toInteger(e);
    return r < 0 ? max(r + t, 0) : min$1(r, t);
  },
  createMethod = function createMethod(e) {
    return function (t, r, n) {
      var o,
        a = toIndexedObject(t),
        i = toLength(a.length),
        s = toAbsoluteIndex(n, i);
      if (e && r != r) {
        for (; i > s;) if ((o = a[s++]) != o) return !0;
      } else for (; i > s; s++) if ((e || s in a) && a[s] === r) return e || s || 0;
      return !e && -1;
    };
  },
  arrayIncludes = {
    includes: createMethod(!0),
    indexOf: createMethod(!1)
  },
  hiddenKeys = {},
  indexOf = arrayIncludes.indexOf,
  objectKeysInternal = function objectKeysInternal(e, t) {
    var r,
      n = toIndexedObject(e),
      o = 0,
      a = [];
    for (r in n) !has(hiddenKeys, r) && has(n, r) && a.push(r);
    for (; t.length > o;) has(n, r = t[o++]) && (~indexOf(a, r) || a.push(r));
    return a;
  },
  enumBugKeys = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
  objectKeys = Object.keys || function (e) {
    return objectKeysInternal(e, enumBugKeys);
  },
  objectDefineProperties = descriptors ? Object.defineProperties : function (e, t) {
    anObject(e);
    for (var r, n = objectKeys(t), o = n.length, a = 0; o > a;) objectDefineProperty.f(e, r = n[a++], t[r]);
    return e;
  };
_export({
  target: "Object",
  stat: !0,
  forced: !descriptors,
  sham: !descriptors
}, {
  defineProperties: objectDefineProperties
});
var defineProperties_1 = createCommonjsModule(function (e) {
    var t = path.Object,
      r = e.exports = function (e, r) {
        return t.defineProperties(e, r);
      };
    t.defineProperties.sham && (r.sham = !0);
  }),
  defineProperties = defineProperties_1,
  defineProperties$1 = defineProperties,
  aFunction$1 = function aFunction$1(e) {
    return "function" == typeof e ? e : void 0;
  },
  getBuiltIn = function getBuiltIn(e, t) {
    return arguments.length < 2 ? aFunction$1(path[e]) || aFunction$1(global$1[e]) : path[e] && path[e][t] || global$1[e] && global$1[e][t];
  },
  hiddenKeys$1 = enumBugKeys.concat("length", "prototype"),
  f$3 = Object.getOwnPropertyNames || function (e) {
    return objectKeysInternal(e, hiddenKeys$1);
  },
  objectGetOwnPropertyNames = {
    f: f$3
  },
  f$4 = Object.getOwnPropertySymbols,
  objectGetOwnPropertySymbols = {
    f: f$4
  },
  ownKeys = getBuiltIn("Reflect", "ownKeys") || function (e) {
    var t = objectGetOwnPropertyNames.f(anObject(e)),
      r = objectGetOwnPropertySymbols.f;
    return r ? t.concat(r(e)) : t;
  },
  createProperty = function createProperty(e, t, r) {
    var n = toPrimitive(t);
    n in e ? objectDefineProperty.f(e, n, createPropertyDescriptor(0, r)) : e[n] = r;
  };
_export({
  target: "Object",
  stat: !0,
  sham: !descriptors
}, {
  getOwnPropertyDescriptors: function (e) {
    for (var t, r, n = toIndexedObject(e), o = objectGetOwnPropertyDescriptor.f, a = ownKeys(n), i = {}, s = 0; a.length > s;) void 0 !== (r = o(n, t = a[s++])) && createProperty(i, t, r);
    return i;
  }
});
var getOwnPropertyDescriptors = path.Object.getOwnPropertyDescriptors,
  getOwnPropertyDescriptors$1 = getOwnPropertyDescriptors,
  getOwnPropertyDescriptors$2 = getOwnPropertyDescriptors$1,
  iterators = {},
  setGlobal = function setGlobal(e, t) {
    try {
      createNonEnumerableProperty(global$1, e, t);
    } catch (r) {
      global$1[e] = t;
    }
    return t;
  },
  SHARED = "__core-js_shared__",
  store = global$1[SHARED] || setGlobal(SHARED, {}),
  sharedStore = store,
  functionToString = Function.toString;
"function" != typeof sharedStore.inspectSource && (sharedStore.inspectSource = function (e) {
  return functionToString.call(e);
});
var set,
  get,
  has$1,
  inspectSource = sharedStore.inspectSource,
  WeakMap$1 = global$1.WeakMap,
  nativeWeakMap = "function" == typeof WeakMap$1 && /native code/.test(inspectSource(WeakMap$1)),
  isPure = !0,
  shared = createCommonjsModule(function (e) {
    (e.exports = function (e, t) {
      return sharedStore[e] || (sharedStore[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.8.3",
      mode: "pure",
      copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
    });
  }),
  id = 0,
  postfix = Math.random(),
  uid = function uid(e) {
    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++id + postfix).toString(36);
  },
  keys = shared("keys"),
  sharedKey = function sharedKey(e) {
    return keys[e] || (keys[e] = uid(e));
  },
  WeakMap$2 = global$1.WeakMap,
  enforce = function enforce(e) {
    return has$1(e) ? get(e) : set(e, {});
  },
  getterFor = function getterFor(e) {
    return function (t) {
      var r;
      if (!isObject(t) || (r = get(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
      return r;
    };
  };
if (nativeWeakMap) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2()),
    wmget = store$1.get,
    wmhas = store$1.has,
    wmset = store$1.set;
  set = function (e, t) {
    return t.facade = e, wmset.call(store$1, e, t), t;
  }, get = function (e) {
    return wmget.call(store$1, e) || {};
  }, has$1 = function (e) {
    return wmhas.call(store$1, e);
  };
} else {
  var STATE = sharedKey("state");
  hiddenKeys[STATE] = !0, set = function (e, t) {
    return t.facade = e, createNonEnumerableProperty(e, STATE, t), t;
  }, get = function (e) {
    return has(e, STATE) ? e[STATE] : {};
  }, has$1 = function (e) {
    return has(e, STATE);
  };
}
var IteratorPrototype,
  PrototypeOfArrayIteratorPrototype,
  arrayIterator,
  internalState = {
    set: set,
    get: get,
    has: has$1,
    enforce: enforce,
    getterFor: getterFor
  },
  toObject = function toObject(e) {
    return Object(requireObjectCoercible(e));
  },
  correctPrototypeGetter = !fails(function () {
    function e() {}
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }),
  IE_PROTO = sharedKey("IE_PROTO"),
  ObjectPrototype = Object.prototype,
  objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (e) {
    return e = toObject(e), has(e, IE_PROTO) ? e[IE_PROTO] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? ObjectPrototype : null;
  },
  nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
    return !String(Symbol());
  }),
  useSymbolAsUid = nativeSymbol && !Symbol.sham && "symbol" == typeof Symbol.iterator,
  WellKnownSymbolsStore = shared("wks"),
  Symbol$1 = global$1.Symbol,
  createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid,
  wellKnownSymbol = function wellKnownSymbol(e) {
    return has(WellKnownSymbolsStore, e) || (nativeSymbol && has(Symbol$1, e) ? WellKnownSymbolsStore[e] = Symbol$1[e] : WellKnownSymbolsStore[e] = createWellKnownSymbol("Symbol." + e)), WellKnownSymbolsStore[e];
  },
  ITERATOR = wellKnownSymbol("iterator"),
  BUGGY_SAFARI_ITERATORS = !1,
  returnThis = function returnThis() {
    return this;
  };
[].keys && ("next" in (arrayIterator = [].keys()) ? (PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator))) !== Object.prototype && (IteratorPrototype = PrototypeOfArrayIteratorPrototype) : BUGGY_SAFARI_ITERATORS = !0);
var NEW_ITERATOR_PROTOTYPE = null == IteratorPrototype || fails(function () {
  var e = {};
  return IteratorPrototype[ITERATOR].call(e) !== e;
});
NEW_ITERATOR_PROTOTYPE && (IteratorPrototype = {}), NEW_ITERATOR_PROTOTYPE && !has(IteratorPrototype, ITERATOR) && createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
var activeXDocument,
  iteratorsCore = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
  },
  html = getBuiltIn("document", "documentElement"),
  GT = ">",
  LT = "<",
  PROTOTYPE = "prototype",
  SCRIPT = "script",
  IE_PROTO$1 = sharedKey("IE_PROTO"),
  EmptyConstructor = function EmptyConstructor() {},
  scriptTag = function scriptTag(e) {
    return LT + SCRIPT + GT + e + LT + "/" + SCRIPT + GT;
  },
  NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(e) {
    e.write(scriptTag("")), e.close();
    var t = e.parentWindow.Object;
    return e = null, t;
  },
  NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    var e,
      t = documentCreateElement("iframe"),
      r = "java" + SCRIPT + ":";
    return t.style.display = "none", html.appendChild(t), t.src = String(r), (e = t.contentWindow.document).open(), e.write(scriptTag("document.F=Object")), e.close(), e.F;
  },
  _NullProtoObject2 = function _NullProtoObject() {
    try {
      activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (e) {}
    _NullProtoObject2 = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
    for (var e = enumBugKeys.length; e--;) delete _NullProtoObject2[PROTOTYPE][enumBugKeys[e]];
    return _NullProtoObject2();
  };
hiddenKeys[IE_PROTO$1] = !0;
var objectCreate = Object.create || function (e, t) {
    var r;
    return null !== e ? (EmptyConstructor[PROTOTYPE] = anObject(e), r = new EmptyConstructor(), EmptyConstructor[PROTOTYPE] = null, r[IE_PROTO$1] = e) : r = _NullProtoObject2(), void 0 === t ? r : objectDefineProperties(r, t);
  },
  TO_STRING_TAG = wellKnownSymbol("toStringTag"),
  test = {};
test[TO_STRING_TAG] = "z";
var toStringTagSupport = "[object z]" === String(test),
  TO_STRING_TAG$1 = wellKnownSymbol("toStringTag"),
  CORRECT_ARGUMENTS = "Arguments" == classofRaw(function () {
    return arguments;
  }()),
  tryGet = function tryGet(e, t) {
    try {
      return e[t];
    } catch (e) {}
  },
  classof = toStringTagSupport ? classofRaw : function (e) {
    var t, r, n;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = tryGet(t = Object(e), TO_STRING_TAG$1)) ? r : CORRECT_ARGUMENTS ? classofRaw(t) : "Object" == (n = classofRaw(t)) && "function" == typeof t.callee ? "Arguments" : n;
  },
  objectToString = toStringTagSupport ? {}.toString : function () {
    return "[object " + classof(this) + "]";
  },
  defineProperty$2 = objectDefineProperty.f,
  TO_STRING_TAG$2 = wellKnownSymbol("toStringTag"),
  setToStringTag = function setToStringTag(e, t, r, n) {
    if (e) {
      var o = r ? e : e.prototype;
      has(o, TO_STRING_TAG$2) || defineProperty$2(o, TO_STRING_TAG$2, {
        configurable: !0,
        value: t
      }), n && !toStringTagSupport && createNonEnumerableProperty(o, "toString", objectToString);
    }
  },
  IteratorPrototype$1 = iteratorsCore.IteratorPrototype,
  returnThis$1 = function returnThis$1() {
    return this;
  },
  createIteratorConstructor = function createIteratorConstructor(e, t, r) {
    var n = t + " Iterator";
    return e.prototype = objectCreate(IteratorPrototype$1, {
      next: createPropertyDescriptor(1, r)
    }), setToStringTag(e, n, !1, !0), iterators[n] = returnThis$1, e;
  },
  aPossiblePrototype = function aPossiblePrototype(e) {
    if (!isObject(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
    return e;
  },
  objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var e,
      t = !1,
      r = {};
    try {
      (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), t = r instanceof Array;
    } catch (e) {}
    return function (r, n) {
      return anObject(r), aPossiblePrototype(n), t ? e.call(r, n) : r.__proto__ = n, r;
    };
  }() : void 0),
  redefine = function redefine(e, t, r, n) {
    n && n.enumerable ? e[t] = r : createNonEnumerableProperty(e, t, r);
  },
  IteratorPrototype$2 = iteratorsCore.IteratorPrototype,
  BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS,
  ITERATOR$1 = wellKnownSymbol("iterator"),
  KEYS = "keys",
  VALUES = "values",
  ENTRIES = "entries",
  returnThis$2 = function returnThis$2() {
    return this;
  },
  defineIterator = function defineIterator(e, t, r, n, o, a, i) {
    createIteratorConstructor(r, t, n);
    var s,
      c,
      u,
      l = function l(e) {
        if (e === o && d) return d;
        if (!BUGGY_SAFARI_ITERATORS$1 && e in h) return h[e];
        switch (e) {
          case KEYS:
          case VALUES:
          case ENTRIES:
            return function () {
              return new r(this, e);
            };
        }
        return function () {
          return new r(this);
        };
      },
      f = t + " Iterator",
      p = !1,
      h = e.prototype,
      y = h[ITERATOR$1] || h["@@iterator"] || o && h[o],
      d = !BUGGY_SAFARI_ITERATORS$1 && y || l(o),
      g = "Array" == t && h.entries || y;
    if (g && (s = objectGetPrototypeOf(g.call(new e())), IteratorPrototype$2 !== Object.prototype && s.next && (setToStringTag(s, f, !0, !0), iterators[f] = returnThis$2)), o == VALUES && y && y.name !== VALUES && (p = !0, d = function () {
      return y.call(this);
    }), i && h[ITERATOR$1] !== d && createNonEnumerableProperty(h, ITERATOR$1, d), iterators[t] = d, o) if (c = {
      values: l(VALUES),
      keys: a ? d : l(KEYS),
      entries: l(ENTRIES)
    }, i) for (u in c) (BUGGY_SAFARI_ITERATORS$1 || p || !(u in h)) && redefine(h, u, c[u]);else _export({
      target: t,
      proto: !0,
      forced: BUGGY_SAFARI_ITERATORS$1 || p
    }, c);
    return c;
  },
  ARRAY_ITERATOR = "Array Iterator",
  setInternalState = internalState.set,
  getInternalState = internalState.getterFor(ARRAY_ITERATOR);
defineIterator(Array, "Array", function (e, t) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(e),
    index: 0,
    kind: t
  });
}, function () {
  var e = getInternalState(this),
    t = e.target,
    r = e.kind,
    n = e.index++;
  return !t || n >= t.length ? (e.target = void 0, {
    value: void 0,
    done: !0
  }) : "keys" == r ? {
    value: n,
    done: !1
  } : "values" == r ? {
    value: t[n],
    done: !1
  } : {
    value: [n, t[n]],
    done: !1
  };
}, "values"), iterators.Arguments = iterators.Array;
var domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  },
  TO_STRING_TAG$3 = wellKnownSymbol("toStringTag");
for (var COLLECTION_NAME in domIterables) {
  var Collection = global$1[COLLECTION_NAME],
    CollectionPrototype = Collection && Collection.prototype;
  CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3 && createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME), iterators[COLLECTION_NAME] = iterators.Array;
}
var isArray = Array.isArray || function (e) {
    return "Array" == classofRaw(e);
  },
  SPECIES = wellKnownSymbol("species"),
  arraySpeciesCreate = function arraySpeciesCreate(e, t) {
    var r;
    return isArray(e) && ("function" != typeof (r = e.constructor) || r !== Array && !isArray(r.prototype) ? isObject(r) && null === (r = r[SPECIES]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === t ? 0 : t);
  },
  push = [].push,
  createMethod$1 = function createMethod$1(e) {
    var t = 1 == e,
      r = 2 == e,
      n = 3 == e,
      o = 4 == e,
      a = 6 == e,
      i = 7 == e,
      s = 5 == e || a;
    return function (c, u, l, f) {
      for (var p, h, y = toObject(c), d = indexedObject(y), g = functionBindContext(u, l, 3), m = toLength(d.length), b = 0, v = f || arraySpeciesCreate, _ = t ? v(c, m) : r || i ? v(c, 0) : void 0; m > b; b++) if ((s || b in d) && (h = g(p = d[b], b, y), e)) if (t) _[b] = h;else if (h) switch (e) {
        case 3:
          return !0;
        case 5:
          return p;
        case 6:
          return b;
        case 2:
          push.call(_, p);
      } else switch (e) {
        case 4:
          return !1;
        case 7:
          push.call(_, p);
      }
      return a ? -1 : n || o ? o : _;
    };
  },
  arrayIteration = {
    forEach: createMethod$1(0),
    map: createMethod$1(1),
    filter: createMethod$1(2),
    some: createMethod$1(3),
    every: createMethod$1(4),
    find: createMethod$1(5),
    findIndex: createMethod$1(6),
    filterOut: createMethod$1(7)
  },
  arrayMethodIsStrict = function arrayMethodIsStrict(e, t) {
    var r = [][e];
    return !!r && fails(function () {
      r.call(null, t || function () {
        throw 1;
      }, 1);
    });
  },
  defineProperty$3 = Object.defineProperty,
  cache = {},
  thrower = function thrower(e) {
    throw e;
  },
  arrayMethodUsesToLength = function arrayMethodUsesToLength(e, t) {
    if (has(cache, e)) return cache[e];
    t || (t = {});
    var r = [][e],
      n = !!has(t, "ACCESSORS") && t.ACCESSORS,
      o = has(t, 0) ? t[0] : thrower,
      a = has(t, 1) ? t[1] : void 0;
    return cache[e] = !!r && !fails(function () {
      if (n && !descriptors) return !0;
      var e = {
        length: -1
      };
      n ? defineProperty$3(e, 1, {
        enumerable: !0,
        get: thrower
      }) : e[1] = 1, r.call(e, o, a);
    });
  },
  $forEach = arrayIteration.forEach,
  STRICT_METHOD = arrayMethodIsStrict("forEach"),
  USES_TO_LENGTH = arrayMethodUsesToLength("forEach"),
  arrayForEach = STRICT_METHOD && USES_TO_LENGTH ? [].forEach : function (e) {
    return $forEach(this, e, arguments.length > 1 ? arguments[1] : void 0);
  };
_export({
  target: "Array",
  proto: !0,
  forced: [].forEach != arrayForEach
}, {
  forEach: arrayForEach
});
var entryVirtual = function entryVirtual(e) {
    return path[e + "Prototype"];
  },
  forEach = entryVirtual("Array").forEach,
  forEach$1 = forEach,
  ArrayPrototype = Array.prototype,
  DOMIterables = {
    DOMTokenList: !0,
    NodeList: !0
  },
  forEach_1 = function forEach_1(e) {
    var t = e.forEach;
    return e === ArrayPrototype || e instanceof Array && t === ArrayPrototype.forEach || DOMIterables.hasOwnProperty(classof(e)) ? forEach$1 : t;
  },
  forEach$2 = forEach_1,
  forEach$3 = forEach$2,
  nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f,
  FAILS_ON_PRIMITIVES = fails(function () {
    nativeGetOwnPropertyDescriptor$1(1);
  }),
  FORCED = !descriptors || FAILS_ON_PRIMITIVES;
_export({
  target: "Object",
  stat: !0,
  forced: FORCED,
  sham: !descriptors
}, {
  getOwnPropertyDescriptor: function (e, t) {
    return nativeGetOwnPropertyDescriptor$1(toIndexedObject(e), t);
  }
});
var match,
  version,
  getOwnPropertyDescriptor_1 = createCommonjsModule(function (e) {
    var t = path.Object,
      r = e.exports = function (e, r) {
        return t.getOwnPropertyDescriptor(e, r);
      };
    t.getOwnPropertyDescriptor.sham && (r.sham = !0);
  }),
  getOwnPropertyDescriptor$2 = getOwnPropertyDescriptor_1,
  getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor$2,
  engineUserAgent = getBuiltIn("navigator", "userAgent") || "",
  process = global$1.process,
  versions = process && process.versions,
  v8 = versions && versions.v8;
v8 ? version = (match = v8.split("."))[0] + match[1] : engineUserAgent && (!(match = engineUserAgent.match(/Edge\/(\d+)/)) || match[1] >= 74) && (match = engineUserAgent.match(/Chrome\/(\d+)/)) && (version = match[1]);
var engineV8Version = version && +version,
  SPECIES$1 = wellKnownSymbol("species"),
  arrayMethodHasSpeciesSupport = function arrayMethodHasSpeciesSupport(e) {
    return engineV8Version >= 51 || !fails(function () {
      var t = [];
      return (t.constructor = {})[SPECIES$1] = function () {
        return {
          foo: 1
        };
      }, 1 !== t[e](Boolean).foo;
    });
  },
  $filter = arrayIteration.filter,
  HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter"),
  USES_TO_LENGTH$1 = arrayMethodUsesToLength("filter");
_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH$1
}, {
  filter: function (e) {
    return $filter(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var filter = entryVirtual("Array").filter,
  ArrayPrototype$1 = Array.prototype,
  filter_1 = function filter_1(e) {
    var t = e.filter;
    return e === ArrayPrototype$1 || e instanceof Array && t === ArrayPrototype$1.filter ? filter : t;
  },
  filter$1 = filter_1,
  filter$2 = filter$1,
  nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f,
  toString$1 = {}.toString,
  windowNames = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
  getWindowNames = function getWindowNames(e) {
    try {
      return nativeGetOwnPropertyNames(e);
    } catch (e) {
      return windowNames.slice();
    }
  },
  f$5 = function f$5(e) {
    return windowNames && "[object Window]" == toString$1.call(e) ? getWindowNames(e) : nativeGetOwnPropertyNames(toIndexedObject(e));
  },
  objectGetOwnPropertyNamesExternal = {
    f: f$5
  },
  f$6 = wellKnownSymbol,
  wellKnownSymbolWrapped = {
    f: f$6
  },
  defineProperty$4 = objectDefineProperty.f,
  defineWellKnownSymbol = function defineWellKnownSymbol(e) {
    var t = path.Symbol || (path.Symbol = {});
    has(t, e) || defineProperty$4(t, e, {
      value: wellKnownSymbolWrapped.f(e)
    });
  },
  $forEach$1 = arrayIteration.forEach,
  HIDDEN = sharedKey("hidden"),
  SYMBOL = "Symbol",
  PROTOTYPE$1 = "prototype",
  TO_PRIMITIVE = wellKnownSymbol("toPrimitive"),
  setInternalState$1 = internalState.set,
  getInternalState$1 = internalState.getterFor(SYMBOL),
  ObjectPrototype$1 = Object[PROTOTYPE$1],
  $Symbol = global$1.Symbol,
  $stringify = getBuiltIn("JSON", "stringify"),
  nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f,
  nativeDefineProperty$1 = objectDefineProperty.f,
  nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f,
  nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable.f,
  AllSymbols = shared("symbols"),
  ObjectPrototypeSymbols = shared("op-symbols"),
  StringToSymbolRegistry = shared("string-to-symbol-registry"),
  SymbolToStringRegistry = shared("symbol-to-string-registry"),
  WellKnownSymbolsStore$1 = shared("wks"),
  QObject = global$1.QObject,
  USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild,
  setSymbolDescriptor = descriptors && fails(function () {
    return 7 != objectCreate(nativeDefineProperty$1({}, "a", {
      get: function () {
        return nativeDefineProperty$1(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (e, t, r) {
    var n = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$1, t);
    n && delete ObjectPrototype$1[t], nativeDefineProperty$1(e, t, r), n && e !== ObjectPrototype$1 && nativeDefineProperty$1(ObjectPrototype$1, t, n);
  } : nativeDefineProperty$1,
  wrap = function wrap(e, t) {
    var r = AllSymbols[e] = objectCreate($Symbol[PROTOTYPE$1]);
    return setInternalState$1(r, {
      type: SYMBOL,
      tag: e,
      description: t
    }), descriptors || (r.description = t), r;
  },
  isSymbol = useSymbolAsUid ? function (e) {
    return "symbol" == typeof e;
  } : function (e) {
    return Object(e) instanceof $Symbol;
  },
  $defineProperty = function $defineProperty(e, t, r) {
    e === ObjectPrototype$1 && $defineProperty(ObjectPrototypeSymbols, t, r), anObject(e);
    var n = toPrimitive(t, !0);
    return anObject(r), has(AllSymbols, n) ? (r.enumerable ? (has(e, HIDDEN) && e[HIDDEN][n] && (e[HIDDEN][n] = !1), r = objectCreate(r, {
      enumerable: createPropertyDescriptor(0, !1)
    })) : (has(e, HIDDEN) || nativeDefineProperty$1(e, HIDDEN, createPropertyDescriptor(1, {})), e[HIDDEN][n] = !0), setSymbolDescriptor(e, n, r)) : nativeDefineProperty$1(e, n, r);
  },
  $defineProperties = function $defineProperties(e, t) {
    anObject(e);
    var r = toIndexedObject(t),
      n = objectKeys(r).concat($getOwnPropertySymbols(r));
    return $forEach$1(n, function (t) {
      descriptors && !$propertyIsEnumerable.call(r, t) || $defineProperty(e, t, r[t]);
    }), e;
  },
  $create = function $create(e, t) {
    return void 0 === t ? objectCreate(e) : $defineProperties(objectCreate(e), t);
  },
  $propertyIsEnumerable = function $propertyIsEnumerable(e) {
    var t = toPrimitive(e, !0),
      r = nativePropertyIsEnumerable$1.call(this, t);
    return !(this === ObjectPrototype$1 && has(AllSymbols, t) && !has(ObjectPrototypeSymbols, t)) && (!(r || !has(this, t) || !has(AllSymbols, t) || has(this, HIDDEN) && this[HIDDEN][t]) || r);
  },
  $getOwnPropertyDescriptor = function $getOwnPropertyDescriptor(e, t) {
    var r = toIndexedObject(e),
      n = toPrimitive(t, !0);
    if (r !== ObjectPrototype$1 || !has(AllSymbols, n) || has(ObjectPrototypeSymbols, n)) {
      var o = nativeGetOwnPropertyDescriptor$2(r, n);
      return !o || !has(AllSymbols, n) || has(r, HIDDEN) && r[HIDDEN][n] || (o.enumerable = !0), o;
    }
  },
  $getOwnPropertyNames = function $getOwnPropertyNames(e) {
    var t = nativeGetOwnPropertyNames$1(toIndexedObject(e)),
      r = [];
    return $forEach$1(t, function (e) {
      has(AllSymbols, e) || has(hiddenKeys, e) || r.push(e);
    }), r;
  },
  $getOwnPropertySymbols = function $getOwnPropertySymbols(e) {
    var t = e === ObjectPrototype$1,
      r = nativeGetOwnPropertyNames$1(t ? ObjectPrototypeSymbols : toIndexedObject(e)),
      n = [];
    return $forEach$1(r, function (e) {
      !has(AllSymbols, e) || t && !has(ObjectPrototype$1, e) || n.push(AllSymbols[e]);
    }), n;
  };
if (nativeSymbol || (redefine(($Symbol = function () {
  if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor");
  var e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
    t = uid(e);
  return descriptors && USE_SETTER && setSymbolDescriptor(ObjectPrototype$1, t, {
    configurable: !0,
    set: function e(r) {
      this === ObjectPrototype$1 && e.call(ObjectPrototypeSymbols, r), has(this, HIDDEN) && has(this[HIDDEN], t) && (this[HIDDEN][t] = !1), setSymbolDescriptor(this, t, createPropertyDescriptor(1, r));
    }
  }), wrap(t, e);
})[PROTOTYPE$1], "toString", function () {
  return getInternalState$1(this).tag;
}), redefine($Symbol, "withoutSetter", function (e) {
  return wrap(uid(e), e);
}), objectPropertyIsEnumerable.f = $propertyIsEnumerable, objectDefineProperty.f = $defineProperty, objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor, objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames, objectGetOwnPropertySymbols.f = $getOwnPropertySymbols, wellKnownSymbolWrapped.f = function (e) {
  return wrap(wellKnownSymbol(e), e);
}, descriptors && nativeDefineProperty$1($Symbol[PROTOTYPE$1], "description", {
  configurable: !0,
  get: function () {
    return getInternalState$1(this).description;
  }
})), _export({
  global: !0,
  wrap: !0,
  forced: !nativeSymbol,
  sham: !nativeSymbol
}, {
  Symbol: $Symbol
}), $forEach$1(objectKeys(WellKnownSymbolsStore$1), function (e) {
  defineWellKnownSymbol(e);
}), _export({
  target: SYMBOL,
  stat: !0,
  forced: !nativeSymbol
}, {
  for: function (e) {
    var t = String(e);
    if (has(StringToSymbolRegistry, t)) return StringToSymbolRegistry[t];
    var r = $Symbol(t);
    return StringToSymbolRegistry[t] = r, SymbolToStringRegistry[r] = t, r;
  },
  keyFor: function (e) {
    if (!isSymbol(e)) throw TypeError(e + " is not a symbol");
    if (has(SymbolToStringRegistry, e)) return SymbolToStringRegistry[e];
  },
  useSetter: function () {
    USE_SETTER = !0;
  },
  useSimple: function () {
    USE_SETTER = !1;
  }
}), _export({
  target: "Object",
  stat: !0,
  forced: !nativeSymbol,
  sham: !descriptors
}, {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
}), _export({
  target: "Object",
  stat: !0,
  forced: !nativeSymbol
}, {
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
}), _export({
  target: "Object",
  stat: !0,
  forced: fails(function () {
    objectGetOwnPropertySymbols.f(1);
  })
}, {
  getOwnPropertySymbols: function (e) {
    return objectGetOwnPropertySymbols.f(toObject(e));
  }
}), $stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var e = $Symbol();
    return "[null]" != $stringify([e]) || "{}" != $stringify({
      a: e
    }) || "{}" != $stringify(Object(e));
  });
  _export({
    target: "JSON",
    stat: !0,
    forced: FORCED_JSON_STRINGIFY
  }, {
    stringify: function (e, t, r) {
      for (var n, o = [e], a = 1; arguments.length > a;) o.push(arguments[a++]);
      if (n = t, (isObject(t) || void 0 !== e) && !isSymbol(e)) return isArray(t) || (t = function (e, t) {
        if ("function" == typeof n && (t = n.call(this, e, t)), !isSymbol(t)) return t;
      }), o[1] = t, $stringify.apply(null, o);
    }
  });
}
$Symbol[PROTOTYPE$1][TO_PRIMITIVE] || createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf), setToStringTag($Symbol, SYMBOL), hiddenKeys[HIDDEN] = !0;
var getOwnPropertySymbols = path.Object.getOwnPropertySymbols,
  getOwnPropertySymbols$1 = getOwnPropertySymbols,
  getOwnPropertySymbols$2 = getOwnPropertySymbols$1,
  FAILS_ON_PRIMITIVES$1 = fails(function () {
    objectKeys(1);
  });
_export({
  target: "Object",
  stat: !0,
  forced: FAILS_ON_PRIMITIVES$1
}, {
  keys: function (e) {
    return objectKeys(toObject(e));
  }
});
var keys$1 = path.Object.keys,
  keys$2 = keys$1,
  keys$3 = keys$2;
function _defineProperty(e, t, r) {
  return t in e ? defineProperty$1(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var defineProperty$5 = _defineProperty;
function ownKeys$1(e, t) {
  var r = keys$3(e);
  if (getOwnPropertySymbols$2) {
    var n = getOwnPropertySymbols$2(e);
    t && (n = filter$2(n).call(n, function (t) {
      return getOwnPropertyDescriptor$3(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r,
      n = null != arguments[t] ? arguments[t] : {};
    if (t % 2) forEach$3(r = ownKeys$1(Object(n), !0)).call(r, function (t) {
      defineProperty$5(e, t, n[t]);
    });else if (getOwnPropertyDescriptors$2) defineProperties$1(e, getOwnPropertyDescriptors$2(n));else {
      var o;
      forEach$3(o = ownKeys$1(Object(n))).call(o, function (t) {
        defineProperty$1(e, t, getOwnPropertyDescriptor$3(n, t));
      });
    }
  }
  return e;
}
var objectSpread2 = _objectSpread2,
  slice = [].slice,
  factories = {},
  construct = function construct(e, t, r) {
    if (!(t in factories)) {
      for (var n = [], o = 0; o < t; o++) n[o] = "a[" + o + "]";
      factories[t] = Function("C,a", "return new C(" + n.join(",") + ")");
    }
    return factories[t](e, r);
  },
  functionBind = Function.bind || function (e) {
    var t = aFunction(this),
      r = slice.call(arguments, 1),
      n = function n() {
        var o = r.concat(slice.call(arguments));
        return this instanceof n ? construct(t, o.length, o) : t.apply(e, o);
      };
    return isObject(t.prototype) && (n.prototype = t.prototype), n;
  };
_export({
  target: "Function",
  proto: !0
}, {
  bind: functionBind
});
var bind = entryVirtual("Function").bind,
  FunctionPrototype = Function.prototype,
  bind_1 = function bind_1(e) {
    var t = e.bind;
    return e === FunctionPrototype || e instanceof Function && t === FunctionPrototype.bind ? bind : t;
  },
  bind$1 = bind_1,
  bind$2 = bind$1,
  freeGlobal = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
  _freeGlobal = freeGlobal,
  freeSelf = "object" == typeof self && self && self.Object === Object && self,
  root = _freeGlobal || freeSelf || Function("return this")(),
  _root = root,
  Symbol$2 = _root.Symbol,
  _Symbol = Symbol$2,
  objectProto = Object.prototype,
  hasOwnProperty$1 = objectProto.hasOwnProperty,
  nativeObjectToString = objectProto.toString,
  symToStringTag = _Symbol ? _Symbol.toStringTag : void 0;
function getRawTag(e) {
  var t = hasOwnProperty$1.call(e, symToStringTag),
    r = e[symToStringTag];
  try {
    e[symToStringTag] = void 0;
    var n = !0;
  } catch (e) {}
  var o = nativeObjectToString.call(e);
  return n && (t ? e[symToStringTag] = r : delete e[symToStringTag]), o;
}
var _getRawTag = getRawTag,
  objectProto$1 = Object.prototype,
  nativeObjectToString$1 = objectProto$1.toString;
function objectToString$1(e) {
  return nativeObjectToString$1.call(e);
}
var _objectToString = objectToString$1,
  nullTag = "[object Null]",
  undefinedTag = "[object Undefined]",
  symToStringTag$1 = _Symbol ? _Symbol.toStringTag : void 0;
function baseGetTag(e) {
  return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag$1 && symToStringTag$1 in Object(e) ? _getRawTag(e) : _objectToString(e);
}
var _baseGetTag = baseGetTag;
function isObject$1(e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
}
var isObject_1 = isObject$1,
  asyncTag = "[object AsyncFunction]",
  funcTag = "[object Function]",
  genTag = "[object GeneratorFunction]",
  proxyTag = "[object Proxy]";
function isFunction(e) {
  if (!isObject_1(e)) return !1;
  var t = _baseGetTag(e);
  return t == funcTag || t == genTag || t == asyncTag || t == proxyTag;
}
var isFunction_1 = isFunction,
  coreJsData = _root["__core-js_shared__"],
  _coreJsData = coreJsData,
  maskSrcKey = function () {
    var e = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }();
function isMasked(e) {
  return !!maskSrcKey && maskSrcKey in e;
}
var _isMasked = isMasked,
  funcProto = Function.prototype,
  funcToString = funcProto.toString;
function toSource(e) {
  if (null != e) {
    try {
      return funcToString.call(e);
    } catch (e) {}
    try {
      return e + "";
    } catch (e) {}
  }
  return "";
}
var _toSource = toSource,
  reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
  reIsHostCtor = /^\[object .+?Constructor\]$/,
  funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype,
  funcToString$1 = funcProto$1.toString,
  hasOwnProperty$2 = objectProto$2.hasOwnProperty,
  reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(e) {
  return !(!isObject_1(e) || _isMasked(e)) && (isFunction_1(e) ? reIsNative : reIsHostCtor).test(_toSource(e));
}
var _baseIsNative = baseIsNative;
function getValue(e, t) {
  return null == e ? void 0 : e[t];
}
var _getValue = getValue;
function getNative(e, t) {
  var r = _getValue(e, t);
  return _baseIsNative(r) ? r : void 0;
}
var _getNative = getNative,
  defineProperty$6 = function () {
    try {
      var e = _getNative(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (e) {}
  }(),
  _defineProperty$1 = defineProperty$6;
function baseAssignValue(e, t, r) {
  "__proto__" == t && _defineProperty$1 ? _defineProperty$1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var _baseAssignValue = baseAssignValue;
function eq(e, t) {
  return e === t || e != e && t != t;
}
var eq_1 = eq,
  objectProto$3 = Object.prototype,
  hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function assignValue(e, t, r) {
  var n = e[t];
  hasOwnProperty$3.call(e, t) && eq_1(n, r) && (void 0 !== r || t in e) || _baseAssignValue(e, t, r);
}
var _assignValue = assignValue;
function copyObject(e, t, r, n) {
  var o = !r;
  r || (r = {});
  for (var a = -1, i = t.length; ++a < i;) {
    var s = t[a],
      c = n ? n(r[s], e[s], s, r, e) : void 0;
    void 0 === c && (c = e[s]), o ? _baseAssignValue(r, s, c) : _assignValue(r, s, c);
  }
  return r;
}
var _copyObject = copyObject;
function identity(e) {
  return e;
}
var identity_1 = identity;
function apply(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var _apply = apply,
  nativeMax = Math.max;
function overRest(e, t, r) {
  return t = nativeMax(void 0 === t ? e.length - 1 : t, 0), function () {
    for (var n = arguments, o = -1, a = nativeMax(n.length - t, 0), i = Array(a); ++o < a;) i[o] = n[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t;) s[o] = n[o];
    return s[t] = r(i), _apply(e, this, s);
  };
}
var _overRest = overRest;
function constant(e) {
  return function () {
    return e;
  };
}
var constant_1 = constant,
  baseSetToString = _defineProperty$1 ? function (e, t) {
    return _defineProperty$1(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: constant_1(t),
      writable: !0
    });
  } : identity_1,
  _baseSetToString = baseSetToString,
  HOT_COUNT = 800,
  HOT_SPAN = 16,
  nativeNow = Date.now;
function shortOut(e) {
  var t = 0,
    r = 0;
  return function () {
    var n = nativeNow(),
      o = HOT_SPAN - (n - r);
    if (r = n, o > 0) {
      if (++t >= HOT_COUNT) return arguments[0];
    } else t = 0;
    return e.apply(void 0, arguments);
  };
}
var _shortOut = shortOut,
  setToString = _shortOut(_baseSetToString),
  _setToString = setToString;
function baseRest(e, t) {
  return _setToString(_overRest(e, t, identity_1), e + "");
}
var _baseRest = baseRest,
  MAX_SAFE_INTEGER = 9007199254740991;
function isLength(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength;
function isArrayLike(e) {
  return null != e && isLength_1(e.length) && !isFunction_1(e);
}
var isArrayLike_1 = isArrayLike,
  MAX_SAFE_INTEGER$1 = 9007199254740991,
  reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(e, t) {
  var r = typeof e;
  return !!(t = null == t ? MAX_SAFE_INTEGER$1 : t) && ("number" == r || "symbol" != r && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var _isIndex = isIndex;
function isIterateeCall(e, t, r) {
  if (!isObject_1(r)) return !1;
  var n = typeof t;
  return !!("number" == n ? isArrayLike_1(r) && _isIndex(t, r.length) : "string" == n && t in r) && eq_1(r[t], e);
}
var _isIterateeCall = isIterateeCall;
function createAssigner(e) {
  return _baseRest(function (t, r) {
    var n = -1,
      o = r.length,
      a = o > 1 ? r[o - 1] : void 0,
      i = o > 2 ? r[2] : void 0;
    for (a = e.length > 3 && "function" == typeof a ? (o--, a) : void 0, i && _isIterateeCall(r[0], r[1], i) && (a = o < 3 ? void 0 : a, o = 1), t = Object(t); ++n < o;) {
      var s = r[n];
      s && e(t, s, n, a);
    }
    return t;
  });
}
var _createAssigner = createAssigner,
  objectProto$4 = Object.prototype;
function isPrototype(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || objectProto$4);
}
var _isPrototype = isPrototype;
function baseTimes(e, t) {
  for (var r = -1, n = Array(e); ++r < e;) n[r] = t(r);
  return n;
}
var _baseTimes = baseTimes;
function isObjectLike(e) {
  return null != e && "object" == typeof e;
}
var isObjectLike_1 = isObjectLike,
  argsTag = "[object Arguments]";
function baseIsArguments(e) {
  return isObjectLike_1(e) && _baseGetTag(e) == argsTag;
}
var _baseIsArguments = baseIsArguments,
  objectProto$5 = Object.prototype,
  hasOwnProperty$4 = objectProto$5.hasOwnProperty,
  propertyIsEnumerable = objectProto$5.propertyIsEnumerable,
  isArguments = _baseIsArguments(function () {
    return arguments;
  }()) ? _baseIsArguments : function (e) {
    return isObjectLike_1(e) && hasOwnProperty$4.call(e, "callee") && !propertyIsEnumerable.call(e, "callee");
  },
  isArguments_1 = isArguments,
  isArray$1 = Array.isArray,
  isArray_1 = isArray$1;
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse,
  isBuffer_1 = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
      n = r && e && !e.nodeType && e,
      o = n && n.exports === r ? _root.Buffer : void 0,
      a = (o ? o.isBuffer : void 0) || stubFalse_1;
    e.exports = a;
  }),
  argsTag$1 = "[object Arguments]",
  arrayTag = "[object Array]",
  boolTag = "[object Boolean]",
  dateTag = "[object Date]",
  errorTag = "[object Error]",
  funcTag$1 = "[object Function]",
  mapTag = "[object Map]",
  numberTag = "[object Number]",
  objectTag = "[object Object]",
  regexpTag = "[object RegExp]",
  setTag = "[object Set]",
  stringTag = "[object String]",
  weakMapTag = "[object WeakMap]",
  arrayBufferTag = "[object ArrayBuffer]",
  dataViewTag = "[object DataView]",
  float32Tag = "[object Float32Array]",
  float64Tag = "[object Float64Array]",
  int8Tag = "[object Int8Array]",
  int16Tag = "[object Int16Array]",
  int32Tag = "[object Int32Array]",
  uint8Tag = "[object Uint8Array]",
  uint8ClampedTag = "[object Uint8ClampedArray]",
  uint16Tag = "[object Uint16Array]",
  uint32Tag = "[object Uint32Array]",
  typedArrayTags = {};
function baseIsTypedArray(e) {
  return isObjectLike_1(e) && isLength_1(e.length) && !!typedArrayTags[_baseGetTag(e)];
}
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0, typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = !1;
var _baseIsTypedArray = baseIsTypedArray;
function baseUnary(e) {
  return function (t) {
    return e(t);
  };
}
var _baseUnary = baseUnary,
  _nodeUtil = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
      n = r && e && !e.nodeType && e,
      o = n && n.exports === r && _freeGlobal.process,
      a = function () {
        try {
          var e = n && n.require && n.require("util").types;
          return e || o && o.binding && o.binding("util");
        } catch (e) {}
      }();
    e.exports = a;
  }),
  nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray,
  isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray,
  isTypedArray_1 = isTypedArray,
  objectProto$6 = Object.prototype,
  hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function arrayLikeKeys(e, t) {
  var r = isArray_1(e),
    n = !r && isArguments_1(e),
    o = !r && !n && isBuffer_1(e),
    a = !r && !n && !o && isTypedArray_1(e),
    i = r || n || o || a,
    s = i ? _baseTimes(e.length, String) : [],
    c = s.length;
  for (var u in e) !t && !hasOwnProperty$5.call(e, u) || i && ("length" == u || o && ("offset" == u || "parent" == u) || a && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || _isIndex(u, c)) || s.push(u);
  return s;
}
var _arrayLikeKeys = arrayLikeKeys;
function overArg(e, t) {
  return function (r) {
    return e(t(r));
  };
}
var _overArg = overArg,
  nativeKeys = _overArg(Object.keys, Object),
  _nativeKeys = nativeKeys,
  objectProto$7 = Object.prototype,
  hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeys(e) {
  if (!_isPrototype(e)) return _nativeKeys(e);
  var t = [];
  for (var r in Object(e)) hasOwnProperty$6.call(e, r) && "constructor" != r && t.push(r);
  return t;
}
var _baseKeys = baseKeys;
function keys$4(e) {
  return isArrayLike_1(e) ? _arrayLikeKeys(e) : _baseKeys(e);
}
var keys_1 = keys$4,
  objectProto$8 = Object.prototype,
  hasOwnProperty$7 = objectProto$8.hasOwnProperty,
  assign = _createAssigner(function (e, t) {
    if (_isPrototype(t) || isArrayLike_1(t)) _copyObject(t, keys_1(t), e);else for (var r in t) hasOwnProperty$7.call(t, r) && _assignValue(e, r, t[r]);
  }),
  assign_1 = assign;
function baseClamp(e, t, r) {
  return e == e && (void 0 !== r && (e = e <= r ? e : r), void 0 !== t && (e = e >= t ? e : t)), e;
}
var _baseClamp = baseClamp;
function arrayMap(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) o[r] = t(e[r], r, e);
  return o;
}
var _arrayMap = arrayMap,
  symbolTag = "[object Symbol]";
function isSymbol$1(e) {
  return "symbol" == typeof e || isObjectLike_1(e) && _baseGetTag(e) == symbolTag;
}
var isSymbol_1 = isSymbol$1,
  INFINITY = 1 / 0,
  symbolProto = _Symbol ? _Symbol.prototype : void 0,
  symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(e) {
  if ("string" == typeof e) return e;
  if (isArray_1(e)) return _arrayMap(e, baseToString) + "";
  if (isSymbol_1(e)) return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY ? "-0" : t;
}
var _baseToString = baseToString,
  NAN = NaN,
  reTrim = /^\s+|\s+$/g,
  reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
  reIsBinary = /^0b[01]+$/i,
  reIsOctal = /^0o[0-7]+$/i,
  freeParseInt = parseInt;
function toNumber(e) {
  if ("number" == typeof e) return e;
  if (isSymbol_1(e)) return NAN;
  if (isObject_1(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = isObject_1(t) ? t + "" : t;
  }
  if ("string" != typeof e) return 0 === e ? e : +e;
  e = e.replace(reTrim, "");
  var r = reIsBinary.test(e);
  return r || reIsOctal.test(e) ? freeParseInt(e.slice(2), r ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
}
var toNumber_1 = toNumber,
  INFINITY$1 = 1 / 0,
  MAX_INTEGER = 17976931348623157e292;
function toFinite(e) {
  return e ? (e = toNumber_1(e)) === INFINITY$1 || e === -INFINITY$1 ? (e < 0 ? -1 : 1) * MAX_INTEGER : e == e ? e : 0 : 0 === e ? e : 0;
}
var toFinite_1 = toFinite;
function toInteger$1(e) {
  var t = toFinite_1(e),
    r = t % 1;
  return t == t ? r ? t - r : t : 0;
}
var toInteger_1 = toInteger$1;
function toString$2(e) {
  return null == e ? "" : _baseToString(e);
}
var toString_1 = toString$2;
function startsWith(e, t, r) {
  return e = toString_1(e), r = null == r ? 0 : _baseClamp(toInteger_1(r), 0, e.length), t = _baseToString(t), e.slice(r, r + t.length) == t;
}
var startsWith_1 = startsWith,
  maxInt = 2147483647,
  base = 36,
  tMin = 1,
  tMax = 26,
  skew = 38,
  damp = 700,
  initialBias = 72,
  initialN = 128,
  delimiter = "-",
  regexNonASCII = /[^\x20-\x7E]/,
  regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
  errors = {
    overflow: "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
  },
  baseMinusTMin = base - tMin,
  floor$1 = Math.floor,
  stringFromCharCode = String.fromCharCode;
/*! https://mths.be/punycode v1.4.1 by @mathias */
function error(e) {
  throw new RangeError(errors[e]);
}
function map(e, t) {
  for (var r = e.length, n = []; r--;) n[r] = t(e[r]);
  return n;
}
function mapDomain(e, t) {
  var r = e.split("@"),
    n = "";
  return r.length > 1 && (n = r[0] + "@", e = r[1]), n + map((e = e.replace(regexSeparators, ".")).split("."), t).join(".");
}
function ucs2decode(e) {
  for (var t, r, n = [], o = 0, a = e.length; o < a;) (t = e.charCodeAt(o++)) >= 55296 && t <= 56319 && o < a ? 56320 == (64512 & (r = e.charCodeAt(o++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), o--) : n.push(t);
  return n;
}
function digitToBasic(e, t) {
  return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
}
function adapt(e, t, r) {
  var n = 0;
  for (e = r ? floor$1(e / damp) : e >> 1, e += floor$1(e / t); e > baseMinusTMin * tMax >> 1; n += base) e = floor$1(e / baseMinusTMin);
  return floor$1(n + (baseMinusTMin + 1) * e / (e + skew));
}
function encode(e) {
  var t,
    r,
    n,
    o,
    a,
    i,
    s,
    c,
    u,
    l,
    f,
    p,
    h,
    y,
    d,
    g = [];
  for (p = (e = ucs2decode(e)).length, t = initialN, r = 0, a = initialBias, i = 0; i < p; ++i) (f = e[i]) < 128 && g.push(stringFromCharCode(f));
  for (n = o = g.length, o && g.push(delimiter); n < p;) {
    for (s = maxInt, i = 0; i < p; ++i) (f = e[i]) >= t && f < s && (s = f);
    for (s - t > floor$1((maxInt - r) / (h = n + 1)) && error("overflow"), r += (s - t) * h, t = s, i = 0; i < p; ++i) if ((f = e[i]) < t && ++r > maxInt && error("overflow"), f == t) {
      for (c = r, u = base; !(c < (l = u <= a ? tMin : u >= a + tMax ? tMax : u - a)); u += base) d = c - l, y = base - l, g.push(stringFromCharCode(digitToBasic(l + d % y, 0))), c = floor$1(d / y);
      g.push(stringFromCharCode(digitToBasic(c, 0))), a = adapt(r, h, n == o), r = 0, ++n;
    }
    ++r, ++t;
  }
  return g.join("");
}
function toASCII(e) {
  return mapDomain(e, function (e) {
    return regexNonASCII.test(e) ? "xn--" + encode(e) : e;
  });
}
var global$2 = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {},
  lookup = [],
  revLookup = [],
  Arr = "undefined" != typeof Uint8Array ? Uint8Array : Array,
  inited = !1;
function init() {
  inited = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0; t < 64; ++t) lookup[t] = e[t], revLookup[e.charCodeAt(t)] = t;
  revLookup["-".charCodeAt(0)] = 62, revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(e) {
  var t, r, n, o, a, i;
  inited || init();
  var s = e.length;
  if (s % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  a = "=" === e[s - 2] ? 2 : "=" === e[s - 1] ? 1 : 0, i = new Arr(3 * s / 4 - a), n = a > 0 ? s - 4 : s;
  var c = 0;
  for (t = 0, r = 0; t < n; t += 4, r += 3) o = revLookup[e.charCodeAt(t)] << 18 | revLookup[e.charCodeAt(t + 1)] << 12 | revLookup[e.charCodeAt(t + 2)] << 6 | revLookup[e.charCodeAt(t + 3)], i[c++] = o >> 16 & 255, i[c++] = o >> 8 & 255, i[c++] = 255 & o;
  return 2 === a ? (o = revLookup[e.charCodeAt(t)] << 2 | revLookup[e.charCodeAt(t + 1)] >> 4, i[c++] = 255 & o) : 1 === a && (o = revLookup[e.charCodeAt(t)] << 10 | revLookup[e.charCodeAt(t + 1)] << 4 | revLookup[e.charCodeAt(t + 2)] >> 2, i[c++] = o >> 8 & 255, i[c++] = 255 & o), i;
}
function tripletToBase64(e) {
  return lookup[e >> 18 & 63] + lookup[e >> 12 & 63] + lookup[e >> 6 & 63] + lookup[63 & e];
}
function encodeChunk(e, t, r) {
  for (var n, o = [], a = t; a < r; a += 3) n = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], o.push(tripletToBase64(n));
  return o.join("");
}
function fromByteArray(e) {
  var t;
  inited || init();
  for (var r = e.length, n = r % 3, o = "", a = [], i = 16383, s = 0, c = r - n; s < c; s += i) a.push(encodeChunk(e, s, s + i > c ? c : s + i));
  return 1 === n ? (t = e[r - 1], o += lookup[t >> 2], o += lookup[t << 4 & 63], o += "==") : 2 === n && (t = (e[r - 2] << 8) + e[r - 1], o += lookup[t >> 10], o += lookup[t >> 4 & 63], o += lookup[t << 2 & 63], o += "="), a.push(o), a.join("");
}
function read(e, t, r, n, o) {
  var a,
    i,
    s = 8 * o - n - 1,
    c = (1 << s) - 1,
    u = c >> 1,
    l = -7,
    f = r ? o - 1 : 0,
    p = r ? -1 : 1,
    h = e[t + f];
  for (f += p, a = h & (1 << -l) - 1, h >>= -l, l += s; l > 0; a = 256 * a + e[t + f], f += p, l -= 8);
  for (i = a & (1 << -l) - 1, a >>= -l, l += n; l > 0; i = 256 * i + e[t + f], f += p, l -= 8);
  if (0 === a) a = 1 - u;else {
    if (a === c) return i ? NaN : 1 / 0 * (h ? -1 : 1);
    i += Math.pow(2, n), a -= u;
  }
  return (h ? -1 : 1) * i * Math.pow(2, a - n);
}
function write(e, t, r, n, o, a) {
  var i,
    s,
    c,
    u = 8 * a - o - 1,
    l = (1 << u) - 1,
    f = l >> 1,
    p = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
    h = n ? 0 : a - 1,
    y = n ? 1 : -1,
    d = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, i = l) : (i = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -i)) < 1 && (i--, c *= 2), (t += i + f >= 1 ? p / c : p * Math.pow(2, 1 - f)) * c >= 2 && (i++, c /= 2), i + f >= l ? (s = 0, i = l) : i + f >= 1 ? (s = (t * c - 1) * Math.pow(2, o), i += f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, o), i = 0)); o >= 8; e[r + h] = 255 & s, h += y, s /= 256, o -= 8);
  for (i = i << o | s, u += o; u > 0; e[r + h] = 255 & i, h += y, i /= 256, u -= 8);
  e[r + h - y] |= 128 * d;
}
var toString$3 = {}.toString,
  isArray$2 = Array.isArray || function (e) {
    return "[object Array]" == toString$3.call(e);
  },
  INSPECT_MAX_BYTES = 50;
Buffer.TYPED_ARRAY_SUPPORT = void 0 === global$2.TYPED_ARRAY_SUPPORT || global$2.TYPED_ARRAY_SUPPORT;
var _kMaxLength = kMaxLength();
function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function createBuffer(e, t) {
  if (kMaxLength() < t) throw new RangeError("Invalid typed array length");
  return Buffer.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = Buffer.prototype : (null === e && (e = new Buffer(t)), e.length = t), e;
}
function Buffer(e, t, r) {
  if (!(Buffer.TYPED_ARRAY_SUPPORT || this instanceof Buffer)) return new Buffer(e, t, r);
  if ("number" == typeof e) {
    if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
    return allocUnsafe(this, e);
  }
  return from(this, e, t, r);
}
function from(e, t, r, n) {
  if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
  return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? fromArrayBuffer(e, t, r, n) : "string" == typeof t ? fromString(e, t, r) : fromObject(e, t);
}
function assertSize(e) {
  if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
  if (e < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(e, t, r, n) {
  return assertSize(t), t <= 0 ? createBuffer(e, t) : void 0 !== r ? "string" == typeof n ? createBuffer(e, t).fill(r, n) : createBuffer(e, t).fill(r) : createBuffer(e, t);
}
function allocUnsafe(e, t) {
  if (assertSize(t), e = createBuffer(e, t < 0 ? 0 : 0 | checked(t)), !Buffer.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) e[r] = 0;
  return e;
}
function fromString(e, t, r) {
  if ("string" == typeof r && "" !== r || (r = "utf8"), !Buffer.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
  var n = 0 | byteLength(t, r),
    o = (e = createBuffer(e, n)).write(t, r);
  return o !== n && (e = e.slice(0, o)), e;
}
function fromArrayLike(e, t) {
  var r = t.length < 0 ? 0 : 0 | checked(t.length);
  e = createBuffer(e, r);
  for (var n = 0; n < r; n += 1) e[n] = 255 & t[n];
  return e;
}
function fromArrayBuffer(e, t, r, n) {
  if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
  if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
  return t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n), Buffer.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = Buffer.prototype : e = fromArrayLike(e, t), e;
}
function fromObject(e, t) {
  if (internalIsBuffer(t)) {
    var r = 0 | checked(t.length);
    return 0 === (e = createBuffer(e, r)).length || t.copy(e, 0, 0, r), e;
  }
  if (t) {
    if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || isnan(t.length) ? createBuffer(e, 0) : fromArrayLike(e, t);
    if ("Buffer" === t.type && isArray$2(t.data)) return fromArrayLike(e, t.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(e) {
  if (e >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
  return 0 | e;
}
function SlowBuffer(e) {
  return +e != e && (e = 0), Buffer.alloc(+e);
}
function internalIsBuffer(e) {
  return !(null == e || !e._isBuffer);
}
function byteLength(e, t) {
  if (internalIsBuffer(e)) return e.length;
  if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
  "string" != typeof e && (e = "" + e);
  var r = e.length;
  if (0 === r) return 0;
  for (var n = !1;;) switch (t) {
    case "ascii":
    case "latin1":
    case "binary":
      return r;
    case "utf8":
    case "utf-8":
    case void 0:
      return utf8ToBytes(e).length;
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return 2 * r;
    case "hex":
      return r >>> 1;
    case "base64":
      return base64ToBytes(e).length;
    default:
      if (n) return utf8ToBytes(e).length;
      t = ("" + t).toLowerCase(), n = !0;
  }
}
function slowToString(e, t, r) {
  var n = !1;
  if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
  if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
  if ((r >>>= 0) <= (t >>>= 0)) return "";
  for (e || (e = "utf8");;) switch (e) {
    case "hex":
      return hexSlice(this, t, r);
    case "utf8":
    case "utf-8":
      return utf8Slice(this, t, r);
    case "ascii":
      return asciiSlice(this, t, r);
    case "latin1":
    case "binary":
      return latin1Slice(this, t, r);
    case "base64":
      return base64Slice(this, t, r);
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return utf16leSlice(this, t, r);
    default:
      if (n) throw new TypeError("Unknown encoding: " + e);
      e = (e + "").toLowerCase(), n = !0;
  }
}
function swap(e, t, r) {
  var n = e[t];
  e[t] = e[r], e[r] = n;
}
function bidirectionalIndexOf(e, t, r, n, o) {
  if (0 === e.length) return -1;
  if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
    if (o) return -1;
    r = e.length - 1;
  } else if (r < 0) {
    if (!o) return -1;
    r = 0;
  }
  if ("string" == typeof t && (t = Buffer.from(t, n)), internalIsBuffer(t)) return 0 === t.length ? -1 : arrayIndexOf(e, t, r, n, o);
  if ("number" == typeof t) return t &= 255, Buffer.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : arrayIndexOf(e, [t], r, n, o);
  throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(e, t, r, n, o) {
  var a,
    i = 1,
    s = e.length,
    c = t.length;
  if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
    if (e.length < 2 || t.length < 2) return -1;
    i = 2, s /= 2, c /= 2, r /= 2;
  }
  function u(e, t) {
    return 1 === i ? e[t] : e.readUInt16BE(t * i);
  }
  if (o) {
    var l = -1;
    for (a = r; a < s; a++) if (u(e, a) === u(t, -1 === l ? 0 : a - l)) {
      if (-1 === l && (l = a), a - l + 1 === c) return l * i;
    } else -1 !== l && (a -= a - l), l = -1;
  } else for (r + c > s && (r = s - c), a = r; a >= 0; a--) {
    for (var f = !0, p = 0; p < c; p++) if (u(e, a + p) !== u(t, p)) {
      f = !1;
      break;
    }
    if (f) return a;
  }
  return -1;
}
function hexWrite(e, t, r, n) {
  r = Number(r) || 0;
  var o = e.length - r;
  n ? (n = Number(n)) > o && (n = o) : n = o;
  var a = t.length;
  if (a % 2 != 0) throw new TypeError("Invalid hex string");
  n > a / 2 && (n = a / 2);
  for (var i = 0; i < n; ++i) {
    var s = parseInt(t.substr(2 * i, 2), 16);
    if (isNaN(s)) return i;
    e[r + i] = s;
  }
  return i;
}
function utf8Write(e, t, r, n) {
  return blitBuffer(utf8ToBytes(t, e.length - r), e, r, n);
}
function asciiWrite(e, t, r, n) {
  return blitBuffer(asciiToBytes(t), e, r, n);
}
function latin1Write(e, t, r, n) {
  return asciiWrite(e, t, r, n);
}
function base64Write(e, t, r, n) {
  return blitBuffer(base64ToBytes(t), e, r, n);
}
function ucs2Write(e, t, r, n) {
  return blitBuffer(utf16leToBytes(t, e.length - r), e, r, n);
}
function base64Slice(e, t, r) {
  return 0 === t && r === e.length ? fromByteArray(e) : fromByteArray(e.slice(t, r));
}
function utf8Slice(e, t, r) {
  r = Math.min(e.length, r);
  for (var n = [], o = t; o < r;) {
    var a,
      i,
      s,
      c,
      u = e[o],
      l = null,
      f = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
    if (o + f <= r) switch (f) {
      case 1:
        u < 128 && (l = u);
        break;
      case 2:
        128 == (192 & (a = e[o + 1])) && (c = (31 & u) << 6 | 63 & a) > 127 && (l = c);
        break;
      case 3:
        a = e[o + 1], i = e[o + 2], 128 == (192 & a) && 128 == (192 & i) && (c = (15 & u) << 12 | (63 & a) << 6 | 63 & i) > 2047 && (c < 55296 || c > 57343) && (l = c);
        break;
      case 4:
        a = e[o + 1], i = e[o + 2], s = e[o + 3], 128 == (192 & a) && 128 == (192 & i) && 128 == (192 & s) && (c = (15 & u) << 18 | (63 & a) << 12 | (63 & i) << 6 | 63 & s) > 65535 && c < 1114112 && (l = c);
    }
    null === l ? (l = 65533, f = 1) : l > 65535 && (l -= 65536, n.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n.push(l), o += f;
  }
  return decodeCodePointsArray(n);
}
Buffer.poolSize = 8192, Buffer._augment = function (e) {
  return e.__proto__ = Buffer.prototype, e;
}, Buffer.from = function (e, t, r) {
  return from(null, e, t, r);
}, Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array), Buffer.alloc = function (e, t, r) {
  return alloc(null, e, t, r);
}, Buffer.allocUnsafe = function (e) {
  return allocUnsafe(null, e);
}, Buffer.allocUnsafeSlow = function (e) {
  return allocUnsafe(null, e);
}, Buffer.isBuffer = isBuffer, Buffer.compare = function (e, t) {
  if (!internalIsBuffer(e) || !internalIsBuffer(t)) throw new TypeError("Arguments must be Buffers");
  if (e === t) return 0;
  for (var r = e.length, n = t.length, o = 0, a = Math.min(r, n); o < a; ++o) if (e[o] !== t[o]) {
    r = e[o], n = t[o];
    break;
  }
  return r < n ? -1 : n < r ? 1 : 0;
}, Buffer.isEncoding = function (e) {
  switch (String(e).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
}, Buffer.concat = function (e, t) {
  if (!isArray$2(e)) throw new TypeError('"list" argument must be an Array of Buffers');
  if (0 === e.length) return Buffer.alloc(0);
  var r;
  if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) t += e[r].length;
  var n = Buffer.allocUnsafe(t),
    o = 0;
  for (r = 0; r < e.length; ++r) {
    var a = e[r];
    if (!internalIsBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(n, o), o += a.length;
  }
  return n;
}, Buffer.byteLength = byteLength, Buffer.prototype._isBuffer = !0, Buffer.prototype.swap16 = function () {
  var e = this.length;
  if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var t = 0; t < e; t += 2) swap(this, t, t + 1);
  return this;
}, Buffer.prototype.swap32 = function () {
  var e = this.length;
  if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var t = 0; t < e; t += 4) swap(this, t, t + 3), swap(this, t + 1, t + 2);
  return this;
}, Buffer.prototype.swap64 = function () {
  var e = this.length;
  if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var t = 0; t < e; t += 8) swap(this, t, t + 7), swap(this, t + 1, t + 6), swap(this, t + 2, t + 5), swap(this, t + 3, t + 4);
  return this;
}, Buffer.prototype.toString = function () {
  var e = 0 | this.length;
  return 0 === e ? "" : 0 === arguments.length ? utf8Slice(this, 0, e) : slowToString.apply(this, arguments);
}, Buffer.prototype.equals = function (e) {
  if (!internalIsBuffer(e)) throw new TypeError("Argument must be a Buffer");
  return this === e || 0 === Buffer.compare(this, e);
}, Buffer.prototype.inspect = function () {
  var e = "",
    t = INSPECT_MAX_BYTES;
  return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
}, Buffer.prototype.compare = function (e, t, r, n, o) {
  if (!internalIsBuffer(e)) throw new TypeError("Argument must be a Buffer");
  if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), t < 0 || r > e.length || n < 0 || o > this.length) throw new RangeError("out of range index");
  if (n >= o && t >= r) return 0;
  if (n >= o) return -1;
  if (t >= r) return 1;
  if (this === e) return 0;
  for (var a = (o >>>= 0) - (n >>>= 0), i = (r >>>= 0) - (t >>>= 0), s = Math.min(a, i), c = this.slice(n, o), u = e.slice(t, r), l = 0; l < s; ++l) if (c[l] !== u[l]) {
    a = c[l], i = u[l];
    break;
  }
  return a < i ? -1 : i < a ? 1 : 0;
}, Buffer.prototype.includes = function (e, t, r) {
  return -1 !== this.indexOf(e, t, r);
}, Buffer.prototype.indexOf = function (e, t, r) {
  return bidirectionalIndexOf(this, e, t, r, !0);
}, Buffer.prototype.lastIndexOf = function (e, t, r) {
  return bidirectionalIndexOf(this, e, t, r, !1);
}, Buffer.prototype.write = function (e, t, r, n) {
  if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
    if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
  }
  var o = this.length - t;
  if ((void 0 === r || r > o) && (r = o), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
  n || (n = "utf8");
  for (var a = !1;;) switch (n) {
    case "hex":
      return hexWrite(this, e, t, r);
    case "utf8":
    case "utf-8":
      return utf8Write(this, e, t, r);
    case "ascii":
      return asciiWrite(this, e, t, r);
    case "latin1":
    case "binary":
      return latin1Write(this, e, t, r);
    case "base64":
      return base64Write(this, e, t, r);
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return ucs2Write(this, e, t, r);
    default:
      if (a) throw new TypeError("Unknown encoding: " + n);
      n = ("" + n).toLowerCase(), a = !0;
  }
}, Buffer.prototype.toJSON = function () {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
var MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(e) {
  var t = e.length;
  if (t <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, e);
  for (var r = "", n = 0; n < t;) r += String.fromCharCode.apply(String, e.slice(n, n += MAX_ARGUMENTS_LENGTH));
  return r;
}
function asciiSlice(e, t, r) {
  var n = "";
  r = Math.min(e.length, r);
  for (var o = t; o < r; ++o) n += String.fromCharCode(127 & e[o]);
  return n;
}
function latin1Slice(e, t, r) {
  var n = "";
  r = Math.min(e.length, r);
  for (var o = t; o < r; ++o) n += String.fromCharCode(e[o]);
  return n;
}
function hexSlice(e, t, r) {
  var n = e.length;
  (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
  for (var o = "", a = t; a < r; ++a) o += toHex(e[a]);
  return o;
}
function utf16leSlice(e, t, r) {
  for (var n = e.slice(t, r), o = "", a = 0; a < n.length; a += 2) o += String.fromCharCode(n[a] + 256 * n[a + 1]);
  return o;
}
function checkOffset(e, t, r) {
  if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
  if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
}
function checkInt(e, t, r, n, o, a) {
  if (!internalIsBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (t > o || t < a) throw new RangeError('"value" argument is out of bounds');
  if (r + n > e.length) throw new RangeError("Index out of range");
}
function objectWriteUInt16(e, t, r, n) {
  t < 0 && (t = 65535 + t + 1);
  for (var o = 0, a = Math.min(e.length - r, 2); o < a; ++o) e[r + o] = (t & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
}
function objectWriteUInt32(e, t, r, n) {
  t < 0 && (t = 4294967295 + t + 1);
  for (var o = 0, a = Math.min(e.length - r, 4); o < a; ++o) e[r + o] = t >>> 8 * (n ? o : 3 - o) & 255;
}
function checkIEEE754(e, t, r, n, o, a) {
  if (r + n > e.length) throw new RangeError("Index out of range");
  if (r < 0) throw new RangeError("Index out of range");
}
function writeFloat(e, t, r, n, o) {
  return o || checkIEEE754(e, t, r, 4), write(e, t, r, n, 23, 4), r + 4;
}
function writeDouble(e, t, r, n, o) {
  return o || checkIEEE754(e, t, r, 8), write(e, t, r, n, 52, 8), r + 8;
}
Buffer.prototype.slice = function (e, t) {
  var r,
    n = this.length;
  if ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), Buffer.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = Buffer.prototype;else {
    var o = t - e;
    r = new Buffer(o, void 0);
    for (var a = 0; a < o; ++a) r[a] = this[a + e];
  }
  return r;
}, Buffer.prototype.readUIntLE = function (e, t, r) {
  e |= 0, t |= 0, r || checkOffset(e, t, this.length);
  for (var n = this[e], o = 1, a = 0; ++a < t && (o *= 256);) n += this[e + a] * o;
  return n;
}, Buffer.prototype.readUIntBE = function (e, t, r) {
  e |= 0, t |= 0, r || checkOffset(e, t, this.length);
  for (var n = this[e + --t], o = 1; t > 0 && (o *= 256);) n += this[e + --t] * o;
  return n;
}, Buffer.prototype.readUInt8 = function (e, t) {
  return t || checkOffset(e, 1, this.length), this[e];
}, Buffer.prototype.readUInt16LE = function (e, t) {
  return t || checkOffset(e, 2, this.length), this[e] | this[e + 1] << 8;
}, Buffer.prototype.readUInt16BE = function (e, t) {
  return t || checkOffset(e, 2, this.length), this[e] << 8 | this[e + 1];
}, Buffer.prototype.readUInt32LE = function (e, t) {
  return t || checkOffset(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
}, Buffer.prototype.readUInt32BE = function (e, t) {
  return t || checkOffset(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
}, Buffer.prototype.readIntLE = function (e, t, r) {
  e |= 0, t |= 0, r || checkOffset(e, t, this.length);
  for (var n = this[e], o = 1, a = 0; ++a < t && (o *= 256);) n += this[e + a] * o;
  return n >= (o *= 128) && (n -= Math.pow(2, 8 * t)), n;
}, Buffer.prototype.readIntBE = function (e, t, r) {
  e |= 0, t |= 0, r || checkOffset(e, t, this.length);
  for (var n = t, o = 1, a = this[e + --n]; n > 0 && (o *= 256);) a += this[e + --n] * o;
  return a >= (o *= 128) && (a -= Math.pow(2, 8 * t)), a;
}, Buffer.prototype.readInt8 = function (e, t) {
  return t || checkOffset(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
}, Buffer.prototype.readInt16LE = function (e, t) {
  t || checkOffset(e, 2, this.length);
  var r = this[e] | this[e + 1] << 8;
  return 32768 & r ? 4294901760 | r : r;
}, Buffer.prototype.readInt16BE = function (e, t) {
  t || checkOffset(e, 2, this.length);
  var r = this[e + 1] | this[e] << 8;
  return 32768 & r ? 4294901760 | r : r;
}, Buffer.prototype.readInt32LE = function (e, t) {
  return t || checkOffset(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
}, Buffer.prototype.readInt32BE = function (e, t) {
  return t || checkOffset(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
}, Buffer.prototype.readFloatLE = function (e, t) {
  return t || checkOffset(e, 4, this.length), read(this, e, !0, 23, 4);
}, Buffer.prototype.readFloatBE = function (e, t) {
  return t || checkOffset(e, 4, this.length), read(this, e, !1, 23, 4);
}, Buffer.prototype.readDoubleLE = function (e, t) {
  return t || checkOffset(e, 8, this.length), read(this, e, !0, 52, 8);
}, Buffer.prototype.readDoubleBE = function (e, t) {
  return t || checkOffset(e, 8, this.length), read(this, e, !1, 52, 8);
}, Buffer.prototype.writeUIntLE = function (e, t, r, n) {
  (e = +e, t |= 0, r |= 0, n) || checkInt(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
  var o = 1,
    a = 0;
  for (this[t] = 255 & e; ++a < r && (o *= 256);) this[t + a] = e / o & 255;
  return t + r;
}, Buffer.prototype.writeUIntBE = function (e, t, r, n) {
  (e = +e, t |= 0, r |= 0, n) || checkInt(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
  var o = r - 1,
    a = 1;
  for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) this[t + o] = e / a & 255;
  return t + r;
}, Buffer.prototype.writeUInt8 = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
}, Buffer.prototype.writeUInt16LE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : objectWriteUInt16(this, e, t, !0), t + 2;
}, Buffer.prototype.writeUInt16BE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : objectWriteUInt16(this, e, t, !1), t + 2;
}, Buffer.prototype.writeUInt32LE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : objectWriteUInt32(this, e, t, !0), t + 4;
}, Buffer.prototype.writeUInt32BE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : objectWriteUInt32(this, e, t, !1), t + 4;
}, Buffer.prototype.writeIntLE = function (e, t, r, n) {
  if (e = +e, t |= 0, !n) {
    var o = Math.pow(2, 8 * r - 1);
    checkInt(this, e, t, r, o - 1, -o);
  }
  var a = 0,
    i = 1,
    s = 0;
  for (this[t] = 255 & e; ++a < r && (i *= 256);) e < 0 && 0 === s && 0 !== this[t + a - 1] && (s = 1), this[t + a] = (e / i >> 0) - s & 255;
  return t + r;
}, Buffer.prototype.writeIntBE = function (e, t, r, n) {
  if (e = +e, t |= 0, !n) {
    var o = Math.pow(2, 8 * r - 1);
    checkInt(this, e, t, r, o - 1, -o);
  }
  var a = r - 1,
    i = 1,
    s = 0;
  for (this[t + a] = 255 & e; --a >= 0 && (i *= 256);) e < 0 && 0 === s && 0 !== this[t + a + 1] && (s = 1), this[t + a] = (e / i >> 0) - s & 255;
  return t + r;
}, Buffer.prototype.writeInt8 = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
}, Buffer.prototype.writeInt16LE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : objectWriteUInt16(this, e, t, !0), t + 2;
}, Buffer.prototype.writeInt16BE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : objectWriteUInt16(this, e, t, !1), t + 2;
}, Buffer.prototype.writeInt32LE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : objectWriteUInt32(this, e, t, !0), t + 4;
}, Buffer.prototype.writeInt32BE = function (e, t, r) {
  return e = +e, t |= 0, r || checkInt(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : objectWriteUInt32(this, e, t, !1), t + 4;
}, Buffer.prototype.writeFloatLE = function (e, t, r) {
  return writeFloat(this, e, t, !0, r);
}, Buffer.prototype.writeFloatBE = function (e, t, r) {
  return writeFloat(this, e, t, !1, r);
}, Buffer.prototype.writeDoubleLE = function (e, t, r) {
  return writeDouble(this, e, t, !0, r);
}, Buffer.prototype.writeDoubleBE = function (e, t, r) {
  return writeDouble(this, e, t, !1, r);
}, Buffer.prototype.copy = function (e, t, r, n) {
  if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
  if (0 === e.length || 0 === this.length) return 0;
  if (t < 0) throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
  if (n < 0) throw new RangeError("sourceEnd out of bounds");
  n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
  var o,
    a = n - r;
  if (this === e && r < t && t < n) for (o = a - 1; o >= 0; --o) e[o + t] = this[o + r];else if (a < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT) for (o = 0; o < a; ++o) e[o + t] = this[o + r];else Uint8Array.prototype.set.call(e, this.subarray(r, r + a), t);
  return a;
}, Buffer.prototype.fill = function (e, t, r, n) {
  if ("string" == typeof e) {
    if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
      var o = e.charCodeAt(0);
      o < 256 && (e = o);
    }
    if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
    if ("string" == typeof n && !Buffer.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
  } else "number" == typeof e && (e &= 255);
  if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
  if (r <= t) return this;
  var a;
  if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (a = t; a < r; ++a) this[a] = e;else {
    var i = internalIsBuffer(e) ? e : utf8ToBytes(new Buffer(e, n).toString()),
      s = i.length;
    for (a = 0; a < r - t; ++a) this[a + t] = i[a % s];
  }
  return this;
};
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(e) {
  if ((e = stringtrim(e).replace(INVALID_BASE64_RE, "")).length < 2) return "";
  for (; e.length % 4 != 0;) e += "=";
  return e;
}
function stringtrim(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function toHex(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function utf8ToBytes(e, t) {
  var r;
  t = t || 1 / 0;
  for (var n = e.length, o = null, a = [], i = 0; i < n; ++i) {
    if ((r = e.charCodeAt(i)) > 55295 && r < 57344) {
      if (!o) {
        if (r > 56319) {
          (t -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        if (i + 1 === n) {
          (t -= 3) > -1 && a.push(239, 191, 189);
          continue;
        }
        o = r;
        continue;
      }
      if (r < 56320) {
        (t -= 3) > -1 && a.push(239, 191, 189), o = r;
        continue;
      }
      r = 65536 + (o - 55296 << 10 | r - 56320);
    } else o && (t -= 3) > -1 && a.push(239, 191, 189);
    if (o = null, r < 128) {
      if ((t -= 1) < 0) break;
      a.push(r);
    } else if (r < 2048) {
      if ((t -= 2) < 0) break;
      a.push(r >> 6 | 192, 63 & r | 128);
    } else if (r < 65536) {
      if ((t -= 3) < 0) break;
      a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
    } else {
      if (!(r < 1114112)) throw new Error("Invalid code point");
      if ((t -= 4) < 0) break;
      a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
    }
  }
  return a;
}
function asciiToBytes(e) {
  for (var t = [], r = 0; r < e.length; ++r) t.push(255 & e.charCodeAt(r));
  return t;
}
function utf16leToBytes(e, t) {
  for (var r, n, o, a = [], i = 0; i < e.length && !((t -= 2) < 0); ++i) n = (r = e.charCodeAt(i)) >> 8, o = r % 256, a.push(o), a.push(n);
  return a;
}
function base64ToBytes(e) {
  return toByteArray(base64clean(e));
}
function blitBuffer(e, t, r, n) {
  for (var o = 0; o < n && !(o + r >= t.length || o >= e.length); ++o) t[o + r] = e[o];
  return o;
}
function isnan(e) {
  return e != e;
}
function isBuffer(e) {
  return null != e && (!!e._isBuffer || isFastBuffer(e) || isSlowBuffer(e));
}
function isFastBuffer(e) {
  return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
}
function isSlowBuffer(e) {
  return "function" == typeof e.readFloatLE && "function" == typeof e.slice && isFastBuffer(e.slice(0, 0));
}
var bufferEs6 = Object.freeze({
    __proto__: null,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    kMaxLength: _kMaxLength,
    Buffer: Buffer,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer
  }),
  performance = global$2.performance || {};
function isNull(e) {
  return null === e;
}
function isNullOrUndefined(e) {
  return null == e;
}
function isString(e) {
  return "string" == typeof e;
}
function isObject$2(e) {
  return "object" == typeof e && null !== e;
}
function hasOwnProperty$8(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow;
var isArray$3 = Array.isArray || function (e) {
  return "[object Array]" === Object.prototype.toString.call(e);
};
function stringifyPrimitive(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "true" : "false";
    case "number":
      return isFinite(e) ? e : "";
    default:
      return "";
  }
}
function stringify(e, t, r, n) {
  return t = t || "&", r = r || "=", null === e && (e = void 0), "object" == typeof e ? map$1(objectKeys$1(e), function (n) {
    var o = encodeURIComponent(stringifyPrimitive(n)) + r;
    return isArray$3(e[n]) ? map$1(e[n], function (e) {
      return o + encodeURIComponent(stringifyPrimitive(e));
    }).join(t) : o + encodeURIComponent(stringifyPrimitive(e[n]));
  }).join(t) : n ? encodeURIComponent(stringifyPrimitive(n)) + r + encodeURIComponent(stringifyPrimitive(e)) : "";
}
function map$1(e, t) {
  if (e.map) return e.map(t);
  for (var r = [], n = 0; n < e.length; n++) r.push(t(e[n], n));
  return r;
}
var objectKeys$1 = Object.keys || function (e) {
  var t = [];
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
  return t;
};
function parse(e, t, r, n) {
  t = t || "&", r = r || "=";
  var o = {};
  if ("string" != typeof e || 0 === e.length) return o;
  var a = /\+/g;
  e = e.split(t);
  var i = 1e3;
  n && "number" == typeof n.maxKeys && (i = n.maxKeys);
  var s = e.length;
  i > 0 && s > i && (s = i);
  for (var c = 0; c < s; ++c) {
    var u,
      l,
      f,
      p,
      h = e[c].replace(a, "%20"),
      y = h.indexOf(r);
    y >= 0 ? (u = h.substr(0, y), l = h.substr(y + 1)) : (u = h, l = ""), f = decodeURIComponent(u), p = decodeURIComponent(l), hasOwnProperty$8(o, f) ? isArray$3(o[f]) ? o[f].push(p) : o[f] = [o[f], p] : o[f] = p;
  }
  return o;
}
var Url = {
  parse: urlParse,
  resolve: urlResolve,
  resolveObject: urlResolveObject,
  format: urlFormat,
  Url: Url$1
};
function Url$1() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,
  simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
  delims = ["<", ">", '"', "`", " ", "\r", "\n", "\t"],
  unwise = ["{", "}", "|", "\\", "^", "`"].concat(delims),
  autoEscape = ["'"].concat(unwise),
  nonHostChars = ["%", "/", "?", ";", "#"].concat(autoEscape),
  hostEndingChars = ["/", "?", "#"],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  unsafeProtocol = {
    javascript: !0,
    "javascript:": !0
  },
  hostlessProtocol = {
    javascript: !0,
    "javascript:": !0
  },
  slashedProtocol = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  };
function urlParse(e, t, r) {
  if (e && isObject$2(e) && e instanceof Url$1) return e;
  var n = new Url$1();
  return n.parse(e, t, r), n;
}
function parse$1(e, t, r, n) {
  if (!isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
  var o = t.indexOf("?"),
    a = -1 !== o && o < t.indexOf("#") ? "?" : "#",
    i = t.split(a);
  i[0] = i[0].replace(/\\/g, "/");
  var s = t = i.join(a);
  if (s = s.trim(), !n && 1 === t.split("#").length) {
    var c = simplePathPattern.exec(s);
    if (c) return e.path = s, e.href = s, e.pathname = c[1], c[2] ? (e.search = c[2], e.query = r ? parse(e.search.substr(1)) : e.search.substr(1)) : r && (e.search = "", e.query = {}), e;
  }
  var u,
    l,
    f,
    p,
    h = protocolPattern.exec(s);
  if (h) {
    var y = (h = h[0]).toLowerCase();
    e.protocol = y, s = s.substr(h.length);
  }
  if (n || h || s.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var d = "//" === s.substr(0, 2);
    !d || h && hostlessProtocol[h] || (s = s.substr(2), e.slashes = !0);
  }
  if (!hostlessProtocol[h] && (d || h && !slashedProtocol[h])) {
    var g,
      m,
      b = -1;
    for (u = 0; u < hostEndingChars.length; u++) -1 !== (l = s.indexOf(hostEndingChars[u])) && (-1 === b || l < b) && (b = l);
    for (-1 !== (m = -1 === b ? s.lastIndexOf("@") : s.lastIndexOf("@", b)) && (g = s.slice(0, m), s = s.slice(m + 1), e.auth = decodeURIComponent(g)), b = -1, u = 0; u < nonHostChars.length; u++) -1 !== (l = s.indexOf(nonHostChars[u])) && (-1 === b || l < b) && (b = l);
    -1 === b && (b = s.length), e.host = s.slice(0, b), s = s.slice(b), parseHost(e), e.hostname = e.hostname || "";
    var v = "[" === e.hostname[0] && "]" === e.hostname[e.hostname.length - 1];
    if (!v) {
      var _ = e.hostname.split(/\./);
      for (u = 0, f = _.length; u < f; u++) {
        var A = _[u];
        if (A && !A.match(hostnamePartPattern)) {
          for (var E = "", $ = 0, O = A.length; $ < O; $++) A.charCodeAt($) > 127 ? E += "x" : E += A[$];
          if (!E.match(hostnamePartPattern)) {
            var S = _.slice(0, u),
              T = _.slice(u + 1),
              w = A.match(hostnamePartStart);
            w && (S.push(w[1]), T.unshift(w[2])), T.length && (s = "/" + T.join(".") + s), e.hostname = S.join(".");
            break;
          }
        }
      }
    }
    e.hostname.length > hostnameMaxLen ? e.hostname = "" : e.hostname = e.hostname.toLowerCase(), v || (e.hostname = toASCII(e.hostname)), p = e.port ? ":" + e.port : "";
    var P = e.hostname || "";
    e.host = P + p, e.href += e.host, v && (e.hostname = e.hostname.substr(1, e.hostname.length - 2), "/" !== s[0] && (s = "/" + s));
  }
  if (!unsafeProtocol[y]) for (u = 0, f = autoEscape.length; u < f; u++) {
    var I = autoEscape[u];
    if (-1 !== s.indexOf(I)) {
      var C = encodeURIComponent(I);
      C === I && (C = escape(I)), s = s.split(I).join(C);
    }
  }
  var j = s.indexOf("#");
  -1 !== j && (e.hash = s.substr(j), s = s.slice(0, j));
  var R = s.indexOf("?");
  if (-1 !== R ? (e.search = s.substr(R), e.query = s.substr(R + 1), r && (e.query = parse(e.query)), s = s.slice(0, R)) : r && (e.search = "", e.query = {}), s && (e.pathname = s), slashedProtocol[y] && e.hostname && !e.pathname && (e.pathname = "/"), e.pathname || e.search) {
    p = e.pathname || "";
    var x = e.search || "";
    e.path = p + x;
  }
  return e.href = format(e), e;
}
function urlFormat(e) {
  return isString(e) && (e = parse$1({}, e)), format(e);
}
function format(e) {
  var t = e.auth || "";
  t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
  var r = e.protocol || "",
    n = e.pathname || "",
    o = e.hash || "",
    a = !1,
    i = "";
  e.host ? a = t + e.host : e.hostname && (a = t + (-1 === e.hostname.indexOf(":") ? e.hostname : "[" + this.hostname + "]"), e.port && (a += ":" + e.port)), e.query && isObject$2(e.query) && Object.keys(e.query).length && (i = stringify(e.query));
  var s = e.search || i && "?" + i || "";
  return r && ":" !== r.substr(-1) && (r += ":"), e.slashes || (!r || slashedProtocol[r]) && !1 !== a ? (a = "//" + (a || ""), n && "/" !== n.charAt(0) && (n = "/" + n)) : a || (a = ""), o && "#" !== o.charAt(0) && (o = "#" + o), s && "?" !== s.charAt(0) && (s = "?" + s), n = n.replace(/[?#]/g, function (e) {
    return encodeURIComponent(e);
  }), r + a + n + (s = s.replace("#", "%23")) + o;
}
function urlResolve(e, t) {
  return urlParse(e, !1, !0).resolve(t);
}
function urlResolveObject(e, t) {
  return e ? urlParse(e, !1, !0).resolveObject(t) : t;
}
function parseHost(e) {
  var t = e.host,
    r = portPattern.exec(t);
  r && (":" !== (r = r[0]) && (e.port = r.substr(1)), t = t.substr(0, t.length - r.length)), t && (e.hostname = t);
}
Url$1.prototype.parse = function (e, t, r) {
  return parse$1(this, e, t, r);
}, Url$1.prototype.format = function () {
  return format(this);
}, Url$1.prototype.resolve = function (e) {
  return this.resolveObject(urlParse(e, !1, !0)).format();
}, Url$1.prototype.resolveObject = function (e) {
  if (isString(e)) {
    var t = new Url$1();
    t.parse(e, !1, !0), e = t;
  }
  for (var r, n = new Url$1(), o = Object.keys(this), a = 0; a < o.length; a++) {
    var i = o[a];
    n[i] = this[i];
  }
  if (n.hash = e.hash, "" === e.href) return n.href = n.format(), n;
  if (e.slashes && !e.protocol) {
    for (var s = Object.keys(e), c = 0; c < s.length; c++) {
      var u = s[c];
      "protocol" !== u && (n[u] = e[u]);
    }
    return slashedProtocol[n.protocol] && n.hostname && !n.pathname && (n.path = n.pathname = "/"), n.href = n.format(), n;
  }
  if (e.protocol && e.protocol !== n.protocol) {
    if (!slashedProtocol[e.protocol]) {
      for (var l = Object.keys(e), f = 0; f < l.length; f++) {
        var p = l[f];
        n[p] = e[p];
      }
      return n.href = n.format(), n;
    }
    if (n.protocol = e.protocol, e.host || hostlessProtocol[e.protocol]) n.pathname = e.pathname;else {
      for (r = (e.pathname || "").split("/"); r.length && !(e.host = r.shift()););
      e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== r[0] && r.unshift(""), r.length < 2 && r.unshift(""), n.pathname = r.join("/");
    }
    if (n.search = e.search, n.query = e.query, n.host = e.host || "", n.auth = e.auth, n.hostname = e.hostname || e.host, n.port = e.port, n.pathname || n.search) {
      var h = n.pathname || "",
        y = n.search || "";
      n.path = h + y;
    }
    return n.slashes = n.slashes || e.slashes, n.href = n.format(), n;
  }
  var d,
    g = n.pathname && "/" === n.pathname.charAt(0),
    m = e.host || e.pathname && "/" === e.pathname.charAt(0),
    b = m || g || n.host && e.pathname,
    v = b,
    _ = n.pathname && n.pathname.split("/") || [],
    A = n.protocol && !slashedProtocol[n.protocol];
  if (r = e.pathname && e.pathname.split("/") || [], A && (n.hostname = "", n.port = null, n.host && ("" === _[0] ? _[0] = n.host : _.unshift(n.host)), n.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === r[0] ? r[0] = e.host : r.unshift(e.host)), e.host = null), b = b && ("" === r[0] || "" === _[0])), m) n.host = e.host || "" === e.host ? e.host : n.host, n.hostname = e.hostname || "" === e.hostname ? e.hostname : n.hostname, n.search = e.search, n.query = e.query, _ = r;else if (r.length) _ || (_ = []), _.pop(), _ = _.concat(r), n.search = e.search, n.query = e.query;else if (!isNullOrUndefined(e.search)) return A && (n.hostname = n.host = _.shift(), (d = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = d.shift(), n.host = n.hostname = d.shift())), n.search = e.search, n.query = e.query, isNull(n.pathname) && isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.href = n.format(), n;
  if (!_.length) return n.pathname = null, n.search ? n.path = "/" + n.search : n.path = null, n.href = n.format(), n;
  for (var E = _.slice(-1)[0], $ = (n.host || e.host || _.length > 1) && ("." === E || ".." === E) || "" === E, O = 0, S = _.length; S >= 0; S--) "." === (E = _[S]) ? _.splice(S, 1) : ".." === E ? (_.splice(S, 1), O++) : O && (_.splice(S, 1), O--);
  if (!b && !v) for (; O--; O) _.unshift("..");
  !b || "" === _[0] || _[0] && "/" === _[0].charAt(0) || _.unshift(""), $ && "/" !== _.join("/").substr(-1) && _.push("");
  var T = "" === _[0] || _[0] && "/" === _[0].charAt(0);
  return A && (n.hostname = n.host = T ? "" : _.length ? _.shift() : "", (d = !!(n.host && n.host.indexOf("@") > 0) && n.host.split("@")) && (n.auth = d.shift(), n.host = n.hostname = d.shift())), (b = b || n.host && _.length) && !T && _.unshift(""), _.length ? n.pathname = _.join("/") : (n.pathname = null, n.path = null), isNull(n.pathname) && isNull(n.search) || (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.auth = e.auth || n.auth, n.slashes = n.slashes || e.slashes, n.href = n.format(), n;
}, Url$1.prototype.parseHost = function () {
  return parseHost(this);
};
var regenerator = runtime_1,
  forEach$4 = forEach_1,
  filter$3 = filter_1,
  filter$4 = filter$3,
  createMethod$2 = function createMethod$2(e) {
    return function (t, r) {
      var n,
        o,
        a = String(requireObjectCoercible(t)),
        i = toInteger(r),
        s = a.length;
      return i < 0 || i >= s ? e ? "" : void 0 : (n = a.charCodeAt(i)) < 55296 || n > 56319 || i + 1 === s || (o = a.charCodeAt(i + 1)) < 56320 || o > 57343 ? e ? a.charAt(i) : n : e ? a.slice(i, i + 2) : o - 56320 + (n - 55296 << 10) + 65536;
    };
  },
  stringMultibyte = {
    codeAt: createMethod$2(!1),
    charAt: createMethod$2(!0)
  },
  charAt = stringMultibyte.charAt,
  STRING_ITERATOR = "String Iterator",
  setInternalState$2 = internalState.set,
  getInternalState$2 = internalState.getterFor(STRING_ITERATOR);
defineIterator(String, "String", function (e) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: String(e),
    index: 0
  });
}, function () {
  var e,
    t = getInternalState$2(this),
    r = t.string,
    n = t.index;
  return n >= r.length ? {
    value: void 0,
    done: !0
  } : (e = charAt(r, n), t.index += e.length, {
    value: e,
    done: !1
  });
});
var ITERATOR$2 = wellKnownSymbol("iterator"),
  getIteratorMethod = function getIteratorMethod(e) {
    if (null != e) return e[ITERATOR$2] || e["@@iterator"] || iterators[classof(e)];
  },
  getIterator = function getIterator(e) {
    var t = getIteratorMethod(e);
    if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
    return anObject(t.call(e));
  },
  getIterator_1 = getIterator,
  getIterator$1 = getIterator_1;
_export({
  target: "Array",
  stat: !0
}, {
  isArray: isArray
});
var isArray$4 = path.Array.isArray,
  isArray$5 = isArray$4,
  isArray$6 = isArray$5,
  getIteratorMethod_1 = getIteratorMethod,
  getIteratorMethod$1 = getIteratorMethod_1,
  IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable"),
  MAX_SAFE_INTEGER$2 = 9007199254740991,
  MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded",
  IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
    var e = [];
    return e[IS_CONCAT_SPREADABLE] = !1, e.concat()[0] !== e;
  }),
  SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat"),
  isConcatSpreadable = function isConcatSpreadable(e) {
    if (!isObject(e)) return !1;
    var t = e[IS_CONCAT_SPREADABLE];
    return void 0 !== t ? !!t : isArray(e);
  },
  FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
_export({
  target: "Array",
  proto: !0,
  forced: FORCED$1
}, {
  concat: function (e) {
    var t,
      r,
      n,
      o,
      a,
      i = toObject(this),
      s = arraySpeciesCreate(i, 0),
      c = 0;
    for (t = -1, n = arguments.length; t < n; t++) if (isConcatSpreadable(a = -1 === t ? i : arguments[t])) {
      if (c + (o = toLength(a.length)) > MAX_SAFE_INTEGER$2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
      for (r = 0; r < o; r++, c++) r in a && createProperty(s, c, a[r]);
    } else {
      if (c >= MAX_SAFE_INTEGER$2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
      createProperty(s, c++, a);
    }
    return s.length = c, s;
  }
}), defineWellKnownSymbol("asyncIterator"), defineWellKnownSymbol("hasInstance"), defineWellKnownSymbol("isConcatSpreadable"), defineWellKnownSymbol("iterator"), defineWellKnownSymbol("match"), defineWellKnownSymbol("matchAll"), defineWellKnownSymbol("replace"), defineWellKnownSymbol("search"), defineWellKnownSymbol("species"), defineWellKnownSymbol("split"), defineWellKnownSymbol("toPrimitive"), defineWellKnownSymbol("toStringTag"), defineWellKnownSymbol("unscopables"), setToStringTag(global$1.JSON, "JSON", !0);
var symbol = path.Symbol;
defineWellKnownSymbol("asyncDispose"), defineWellKnownSymbol("dispose"), defineWellKnownSymbol("observable"), defineWellKnownSymbol("patternMatch"), defineWellKnownSymbol("replaceAll");
var symbol$1 = symbol,
  symbol$2 = symbol$1,
  iteratorClose = function iteratorClose(e) {
    var t = e.return;
    if (void 0 !== t) return anObject(t.call(e)).value;
  },
  callWithSafeIterationClosing = function callWithSafeIterationClosing(e, t, r, n) {
    try {
      return n ? t(anObject(r)[0], r[1]) : t(r);
    } catch (t) {
      throw iteratorClose(e), t;
    }
  },
  ITERATOR$3 = wellKnownSymbol("iterator"),
  ArrayPrototype$2 = Array.prototype,
  isArrayIteratorMethod = function isArrayIteratorMethod(e) {
    return void 0 !== e && (iterators.Array === e || ArrayPrototype$2[ITERATOR$3] === e);
  },
  arrayFrom = function arrayFrom(e) {
    var t,
      r,
      n,
      o,
      a,
      i,
      s = toObject(e),
      c = "function" == typeof this ? this : Array,
      u = arguments.length,
      l = u > 1 ? arguments[1] : void 0,
      f = void 0 !== l,
      p = getIteratorMethod(s),
      h = 0;
    if (f && (l = functionBindContext(l, u > 2 ? arguments[2] : void 0, 2)), null == p || c == Array && isArrayIteratorMethod(p)) for (r = new c(t = toLength(s.length)); t > h; h++) i = f ? l(s[h], h) : s[h], createProperty(r, h, i);else for (a = (o = p.call(s)).next, r = new c(); !(n = a.call(o)).done; h++) i = f ? callWithSafeIterationClosing(o, l, [n.value, h], !0) : n.value, createProperty(r, h, i);
    return r.length = h, r;
  },
  ITERATOR$4 = wellKnownSymbol("iterator"),
  SAFE_CLOSING = !1;
try {
  var called = 0,
    iteratorWithReturn = {
      next: function () {
        return {
          done: !!called++
        };
      },
      return: function () {
        SAFE_CLOSING = !0;
      }
    };
  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  }, Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {}
var checkCorrectnessOfIteration = function checkCorrectnessOfIteration(e, t) {
    if (!t && !SAFE_CLOSING) return !1;
    var r = !1;
    try {
      var n = {};
      n[ITERATOR$4] = function () {
        return {
          next: function () {
            return {
              done: r = !0
            };
          }
        };
      }, e(n);
    } catch (e) {}
    return r;
  },
  INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (e) {
    Array.from(e);
  });
_export({
  target: "Array",
  stat: !0,
  forced: INCORRECT_ITERATION
}, {
  from: arrayFrom
});
var from$1 = path.Array.from,
  from$2 = from$1,
  from$3 = from$2,
  HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport("slice"),
  USES_TO_LENGTH$2 = arrayMethodUsesToLength("slice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
  SPECIES$2 = wellKnownSymbol("species"),
  nativeSlice = [].slice,
  max$1 = Math.max;
_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$2
}, {
  slice: function (e, t) {
    var r,
      n,
      o,
      a = toIndexedObject(this),
      i = toLength(a.length),
      s = toAbsoluteIndex(e, i),
      c = toAbsoluteIndex(void 0 === t ? i : t, i);
    if (isArray(a) && ("function" != typeof (r = a.constructor) || r !== Array && !isArray(r.prototype) ? isObject(r) && null === (r = r[SPECIES$2]) && (r = void 0) : r = void 0, r === Array || void 0 === r)) return nativeSlice.call(a, s, c);
    for (n = new (void 0 === r ? Array : r)(max$1(c - s, 0)), o = 0; s < c; s++, o++) s in a && createProperty(n, o, a[s]);
    return n.length = o, n;
  }
});
var slice$1 = entryVirtual("Array").slice,
  ArrayPrototype$3 = Array.prototype,
  slice_1 = function slice_1(e) {
    var t = e.slice;
    return e === ArrayPrototype$3 || e instanceof Array && t === ArrayPrototype$3.slice ? slice$1 : t;
  },
  slice$2 = slice_1,
  slice$3 = slice$2;
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var arrayLikeToArray = _arrayLikeToArray;
function _unsupportedIterableToArray(e, t) {
  var r;
  if (e) {
    if ("string" == typeof e) return arrayLikeToArray(e, t);
    var n = slice$3(r = Object.prototype.toString.call(e)).call(r, 8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? from$3(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? arrayLikeToArray(e, t) : void 0;
  }
}
var unsupportedIterableToArray = _unsupportedIterableToArray;
function _createForOfIteratorHelper(e, t) {
  var r;
  if (void 0 === symbol$2 || null == getIteratorMethod$1(e)) {
    if (isArray$6(e) || (r = unsupportedIterableToArray(e)) || t && e && "number" == typeof e.length) {
      r && (e = r);
      var n = 0,
        o = function o() {};
      return {
        s: o,
        n: function () {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var a,
    i = !0,
    s = !1;
  return {
    s: function () {
      r = getIterator$1(e);
    },
    n: function () {
      var e = r.next();
      return i = e.done, e;
    },
    e: function (e) {
      s = !0, a = e;
    },
    f: function () {
      try {
        i || null == r.return || r.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
var createForOfIteratorHelper = _createForOfIteratorHelper,
  propertyIsEnumerable$1 = objectPropertyIsEnumerable.f,
  createMethod$3 = function createMethod$3(e) {
    return function (t) {
      for (var r, n = toIndexedObject(t), o = objectKeys(n), a = o.length, i = 0, s = []; a > i;) r = o[i++], descriptors && !propertyIsEnumerable$1.call(n, r) || s.push(e ? [r, n[r]] : n[r]);
      return s;
    };
  },
  objectToArray = {
    entries: createMethod$3(!0),
    values: createMethod$3(!1)
  },
  $entries = objectToArray.entries;
_export({
  target: "Object",
  stat: !0
}, {
  entries: function (e) {
    return $entries(e);
  }
});
var entries = path.Object.entries,
  entries$1 = entries,
  entries$2 = entries$1,
  concat = entryVirtual("Array").concat,
  ArrayPrototype$4 = Array.prototype,
  concat_1 = function concat_1(e) {
    var t = e.concat;
    return e === ArrayPrototype$4 || e instanceof Array && t === ArrayPrototype$4.concat ? concat : t;
  },
  concat$1 = concat_1,
  concat$2 = concat$1,
  keys$5 = keys$1,
  keys$6 = keys$5,
  $map = arrayIteration.map,
  HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport("map"),
  USES_TO_LENGTH$3 = arrayMethodUsesToLength("map");
_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT$2 || !USES_TO_LENGTH$3
}, {
  map: function (e) {
    return $map(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var map$2 = entryVirtual("Array").map,
  ArrayPrototype$5 = Array.prototype,
  map_1 = function map_1(e) {
    var t = e.map;
    return e === ArrayPrototype$5 || e instanceof Array && t === ArrayPrototype$5.map ? map$2 : t;
  },
  map$3 = map_1,
  map$4 = map$3,
  $every = arrayIteration.every,
  STRICT_METHOD$1 = arrayMethodIsStrict("every"),
  USES_TO_LENGTH$4 = arrayMethodUsesToLength("every");
_export({
  target: "Array",
  proto: !0,
  forced: !STRICT_METHOD$1 || !USES_TO_LENGTH$4
}, {
  every: function (e) {
    return $every(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var every = entryVirtual("Array").every,
  ArrayPrototype$6 = Array.prototype,
  every_1 = function every_1(e) {
    var t = e.every;
    return e === ArrayPrototype$6 || e instanceof Array && t === ArrayPrototype$6.every ? every : t;
  },
  every$1 = every_1,
  every$2 = every$1,
  $stringify$1 = getBuiltIn("JSON", "stringify"),
  re = /[\uD800-\uDFFF]/g,
  low = /^[\uD800-\uDBFF]$/,
  hi = /^[\uDC00-\uDFFF]$/,
  fix = function fix(e, t, r) {
    var n = r.charAt(t - 1),
      o = r.charAt(t + 1);
    return low.test(e) && !hi.test(o) || hi.test(e) && !low.test(n) ? "\\u" + e.charCodeAt(0).toString(16) : e;
  },
  FORCED$2 = fails(function () {
    return '"\\udf06\\ud834"' !== $stringify$1("\udf06\ud834") || '"\\udead"' !== $stringify$1("\udead");
  });
$stringify$1 && _export({
  target: "JSON",
  stat: !0,
  forced: FORCED$2
}, {
  stringify: function (e, t, r) {
    var n = $stringify$1.apply(null, arguments);
    return "string" == typeof n ? n.replace(re, fix) : n;
  }
}), path.JSON || (path.JSON = {
  stringify: JSON.stringify
});
var stringify$1 = function stringify$1(e, t, r) {
    return path.JSON.stringify.apply(null, arguments);
  },
  stringify$2 = stringify$1,
  stringify$3 = stringify$2,
  $some = arrayIteration.some,
  STRICT_METHOD$2 = arrayMethodIsStrict("some"),
  USES_TO_LENGTH$5 = arrayMethodUsesToLength("some");
_export({
  target: "Array",
  proto: !0,
  forced: !STRICT_METHOD$2 || !USES_TO_LENGTH$5
}, {
  some: function (e) {
    return $some(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var some = entryVirtual("Array").some,
  ArrayPrototype$7 = Array.prototype,
  some_1 = function some_1(e) {
    var t = e.some;
    return e === ArrayPrototype$7 || e instanceof Array && t === ArrayPrototype$7.some ? some : t;
  },
  some$1 = some_1,
  some$2 = some$1,
  isArray$7 = isArray$4,
  isArray$8 = isArray$7,
  iterator = wellKnownSymbolWrapped.f("iterator"),
  iterator$1 = iterator,
  iterator$2 = iterator$1,
  _typeof_1 = createCommonjsModule(function (e) {
    function t(r) {
      return e.exports = t = "function" == typeof symbol$2 && "symbol" == typeof iterator$2 ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof symbol$2 && e.constructor === symbol$2 && e !== symbol$2.prototype ? "symbol" : typeof e;
      }, t(r);
    }
    e.exports = t;
  });
function _arrayWithHoles(e) {
  if (isArray$6(e)) return e;
}
var arrayWithHoles = _arrayWithHoles,
  ITERATOR$5 = wellKnownSymbol("iterator"),
  isIterable = function isIterable(e) {
    var t = Object(e);
    return void 0 !== t[ITERATOR$5] || "@@iterator" in t || iterators.hasOwnProperty(classof(t));
  },
  isIterable_1 = isIterable,
  isIterable$1 = isIterable_1;
function _iterableToArrayLimit(e, t) {
  if (void 0 !== symbol$2 && isIterable$1(Object(e))) {
    var r = [],
      n = !0,
      o = !1,
      a = void 0;
    try {
      for (var i, s = getIterator$1(e); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
    } catch (e) {
      o = !0, a = e;
    } finally {
      try {
        n || null == s.return || s.return();
      } finally {
        if (o) throw a;
      }
    }
    return r;
  }
}
var iterableToArrayLimit = _iterableToArrayLimit;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var nonIterableRest = _nonIterableRest;
function _slicedToArray(e, t) {
  return arrayWithHoles(e) || iterableToArrayLimit(e, t) || unsupportedIterableToArray(e, t) || nonIterableRest();
}
var slicedToArray = _slicedToArray,
  from$4 = from$1,
  from$5 = from$4,
  createMethod$4 = function createMethod$4(e) {
    return function (t, r, n, o) {
      aFunction(r);
      var a = toObject(t),
        i = indexedObject(a),
        s = toLength(a.length),
        c = e ? s - 1 : 0,
        u = e ? -1 : 1;
      if (n < 2) for (;;) {
        if (c in i) {
          o = i[c], c += u;
          break;
        }
        if (c += u, e ? c < 0 : s <= c) throw TypeError("Reduce of empty array with no initial value");
      }
      for (; e ? c >= 0 : s > c; c += u) c in i && (o = r(o, i[c], c, a));
      return o;
    };
  },
  arrayReduce = {
    left: createMethod$4(!1),
    right: createMethod$4(!0)
  },
  engineIsNode = "process" == classofRaw(global$1.process),
  $reduce = arrayReduce.left,
  STRICT_METHOD$3 = arrayMethodIsStrict("reduce"),
  USES_TO_LENGTH$6 = arrayMethodUsesToLength("reduce", {
    1: 0
  }),
  CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;
_export({
  target: "Array",
  proto: !0,
  forced: !STRICT_METHOD$3 || !USES_TO_LENGTH$6 || CHROME_BUG
}, {
  reduce: function (e) {
    return $reduce(this, e, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var reduce = entryVirtual("Array").reduce,
  ArrayPrototype$8 = Array.prototype,
  reduce_1 = function reduce_1(e) {
    var t = e.reduce;
    return e === ArrayPrototype$8 || e instanceof Array && t === ArrayPrototype$8.reduce ? reduce : t;
  },
  reduce$1 = reduce_1,
  reduce$2 = reduce$1,
  entries$3 = entryVirtual("Array").entries,
  entries$4 = entries$3,
  ArrayPrototype$9 = Array.prototype,
  DOMIterables$1 = {
    DOMTokenList: !0,
    NodeList: !0
  },
  entries_1 = function entries_1(e) {
    var t = e.entries;
    return e === ArrayPrototype$9 || e instanceof Array && t === ArrayPrototype$9.entries || DOMIterables$1.hasOwnProperty(classof(e)) ? entries$4 : t;
  },
  entries$5 = entries_1,
  $includes = arrayIncludes.includes,
  USES_TO_LENGTH$7 = arrayMethodUsesToLength("indexOf", {
    ACCESSORS: !0,
    1: 0
  });
_export({
  target: "Array",
  proto: !0,
  forced: !USES_TO_LENGTH$7
}, {
  includes: function (e) {
    return $includes(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var includes = entryVirtual("Array").includes,
  MATCH = wellKnownSymbol("match"),
  isRegexp = function isRegexp(e) {
    var t;
    return isObject(e) && (void 0 !== (t = e[MATCH]) ? !!t : "RegExp" == classofRaw(e));
  },
  notARegexp = function notARegexp(e) {
    if (isRegexp(e)) throw TypeError("The method doesn't accept regular expressions");
    return e;
  },
  MATCH$1 = wellKnownSymbol("match"),
  correctIsRegexpLogic = function correctIsRegexpLogic(e) {
    var t = /./;
    try {
      "/./"[e](t);
    } catch (r) {
      try {
        return t[MATCH$1] = !1, "/./"[e](t);
      } catch (e) {}
    }
    return !1;
  };
_export({
  target: "String",
  proto: !0,
  forced: !correctIsRegexpLogic("includes")
}, {
  includes: function (e) {
    return !!~String(requireObjectCoercible(this)).indexOf(notARegexp(e), arguments.length > 1 ? arguments[1] : void 0);
  }
});
var includes$1 = entryVirtual("String").includes,
  ArrayPrototype$a = Array.prototype,
  StringPrototype = String.prototype,
  includes$2 = function includes$2(e) {
    var t = e.includes;
    return e === ArrayPrototype$a || e instanceof Array && t === ArrayPrototype$a.includes ? includes : "string" == typeof e || e === StringPrototype || e instanceof String && t === StringPrototype.includes ? includes$1 : t;
  },
  includes$3 = includes$2,
  includes$4 = includes$3,
  $indexOf = arrayIncludes.indexOf,
  nativeIndexOf = [].indexOf,
  NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0,
  STRICT_METHOD$4 = arrayMethodIsStrict("indexOf"),
  USES_TO_LENGTH$8 = arrayMethodUsesToLength("indexOf", {
    ACCESSORS: !0,
    1: 0
  });
_export({
  target: "Array",
  proto: !0,
  forced: NEGATIVE_ZERO || !STRICT_METHOD$4 || !USES_TO_LENGTH$8
}, {
  indexOf: function (e) {
    return NEGATIVE_ZERO ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var indexOf$1 = entryVirtual("Array").indexOf,
  ArrayPrototype$b = Array.prototype,
  indexOf_1 = function indexOf_1(e) {
    var t = e.indexOf;
    return e === ArrayPrototype$b || e instanceof Array && t === ArrayPrototype$b.indexOf ? indexOf$1 : t;
  },
  indexOf$2 = indexOf_1,
  indexOf$3 = indexOf$2,
  Result = function Result(e, t) {
    this.stopped = e, this.result = t;
  },
  iterate = function iterate(e, t, r) {
    var n,
      o,
      a,
      i,
      s,
      c,
      u,
      l = r && r.that,
      f = !(!r || !r.AS_ENTRIES),
      p = !(!r || !r.IS_ITERATOR),
      h = !(!r || !r.INTERRUPTED),
      y = functionBindContext(t, l, 1 + f + h),
      d = function d(e) {
        return n && iteratorClose(n), new Result(!0, e);
      },
      g = function g(e) {
        return f ? (anObject(e), h ? y(e[0], e[1], d) : y(e[0], e[1])) : h ? y(e, d) : y(e);
      };
    if (p) n = e;else {
      if ("function" != typeof (o = getIteratorMethod(e))) throw TypeError("Target is not iterable");
      if (isArrayIteratorMethod(o)) {
        for (a = 0, i = toLength(e.length); i > a; a++) if ((s = g(e[a])) && s instanceof Result) return s;
        return new Result(!1);
      }
      n = o.call(e);
    }
    for (c = n.next; !(u = c.call(n)).done;) {
      try {
        s = g(u.value);
      } catch (e) {
        throw iteratorClose(n), e;
      }
      if ("object" == typeof s && s && s instanceof Result) return s;
    }
    return new Result(!1);
  },
  $AggregateError = function $AggregateError(e, t) {
    var r = this;
    if (!(r instanceof $AggregateError)) return new $AggregateError(e, t);
    objectSetPrototypeOf && (r = objectSetPrototypeOf(new Error(void 0), objectGetPrototypeOf(r))), void 0 !== t && createNonEnumerableProperty(r, "message", String(t));
    var n = [];
    return iterate(e, n.push, {
      that: n
    }), createNonEnumerableProperty(r, "errors", n), r;
  };
$AggregateError.prototype = objectCreate(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ""),
  name: createPropertyDescriptor(5, "AggregateError")
}), _export({
  global: !0
}, {
  AggregateError: $AggregateError
});
var defer,
  channel,
  port,
  nativePromiseConstructor = global$1.Promise,
  redefineAll = function redefineAll(e, t, r) {
    for (var n in t) r && r.unsafe && e[n] ? e[n] = t[n] : redefine(e, n, t[n], r);
    return e;
  },
  SPECIES$3 = wellKnownSymbol("species"),
  setSpecies = function setSpecies(e) {
    var t = getBuiltIn(e),
      r = objectDefineProperty.f;
    descriptors && t && !t[SPECIES$3] && r(t, SPECIES$3, {
      configurable: !0,
      get: function () {
        return this;
      }
    });
  },
  anInstance = function anInstance(e, t, r) {
    if (!(e instanceof t)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
    return e;
  },
  SPECIES$4 = wellKnownSymbol("species"),
  speciesConstructor = function speciesConstructor(e, t) {
    var r,
      n = anObject(e).constructor;
    return void 0 === n || null == (r = anObject(n)[SPECIES$4]) ? t : aFunction(r);
  },
  engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(engineUserAgent),
  location = global$1.location,
  set$1 = global$1.setImmediate,
  clear = global$1.clearImmediate,
  process$1 = global$1.process,
  MessageChannel = global$1.MessageChannel,
  Dispatch = global$1.Dispatch,
  counter = 0,
  queue = {},
  ONREADYSTATECHANGE = "onreadystatechange",
  run = function run(e) {
    if (queue.hasOwnProperty(e)) {
      var t = queue[e];
      delete queue[e], t();
    }
  },
  runner = function runner(e) {
    return function () {
      run(e);
    };
  },
  listener = function listener(e) {
    run(e.data);
  },
  post = function post(e) {
    global$1.postMessage(e + "", location.protocol + "//" + location.host);
  };
set$1 && clear || (set$1 = function (e) {
  for (var t = [], r = 1; arguments.length > r;) t.push(arguments[r++]);
  return queue[++counter] = function () {
    ("function" == typeof e ? e : Function(e)).apply(void 0, t);
  }, defer(counter), counter;
}, clear = function (e) {
  delete queue[e];
}, engineIsNode ? defer = function (e) {
  process$1.nextTick(runner(e));
} : Dispatch && Dispatch.now ? defer = function (e) {
  Dispatch.now(runner(e));
} : MessageChannel && !engineIsIos ? (port = (channel = new MessageChannel()).port2, channel.port1.onmessage = listener, defer = functionBindContext(port.postMessage, port, 1)) : global$1.addEventListener && "function" == typeof postMessage && !global$1.importScripts && location && "file:" !== location.protocol && !fails(post) ? (defer = post, global$1.addEventListener("message", listener, !1)) : defer = ONREADYSTATECHANGE in documentCreateElement("script") ? function (e) {
  html.appendChild(documentCreateElement("script"))[ONREADYSTATECHANGE] = function () {
    html.removeChild(this), run(e);
  };
} : function (e) {
  setTimeout(runner(e), 0);
});
var flush,
  head,
  last,
  notify,
  toggle,
  node,
  promise,
  then,
  task = {
    set: set$1,
    clear: clear
  },
  engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent),
  getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f,
  macrotask = task.set,
  MutationObserver = global$1.MutationObserver || global$1.WebKitMutationObserver,
  document$2 = global$1.document,
  process$2 = global$1.process,
  Promise$1 = global$1.Promise,
  queueMicrotaskDescriptor = getOwnPropertyDescriptor$4(global$1, "queueMicrotask"),
  queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
queueMicrotask || (flush = function () {
  var e, t;
  for (engineIsNode && (e = process$2.domain) && e.exit(); head;) {
    t = head.fn, head = head.next;
    try {
      t();
    } catch (e) {
      throw head ? notify() : last = void 0, e;
    }
  }
  last = void 0, e && e.enter();
}, engineIsIos || engineIsNode || engineIsWebosWebkit || !MutationObserver || !document$2 ? Promise$1 && Promise$1.resolve ? (promise = Promise$1.resolve(void 0), then = promise.then, notify = function () {
  then.call(promise, flush);
}) : notify = engineIsNode ? function () {
  process$2.nextTick(flush);
} : function () {
  macrotask.call(global$1, flush);
} : (toggle = !0, node = document$2.createTextNode(""), new MutationObserver(flush).observe(node, {
  characterData: !0
}), notify = function () {
  node.data = toggle = !toggle;
}));
var microtask = queueMicrotask || function (e) {
    var t = {
      fn: e,
      next: void 0
    };
    last && (last.next = t), head || (head = t, notify()), last = t;
  },
  PromiseCapability = function PromiseCapability(e) {
    var t, r;
    this.promise = new e(function (e, n) {
      if (void 0 !== t || void 0 !== r) throw TypeError("Bad Promise constructor");
      t = e, r = n;
    }), this.resolve = aFunction(t), this.reject = aFunction(r);
  },
  f$7 = function f$7(e) {
    return new PromiseCapability(e);
  },
  newPromiseCapability = {
    f: f$7
  },
  promiseResolve = function promiseResolve(e, t) {
    if (anObject(e), isObject(t) && t.constructor === e) return t;
    var r = newPromiseCapability.f(e);
    return (0, r.resolve)(t), r.promise;
  },
  hostReportErrors = function hostReportErrors(e, t) {
    var r = global$1.console;
    r && r.error && (1 === arguments.length ? r.error(e) : r.error(e, t));
  },
  perform = function perform(e) {
    try {
      return {
        error: !1,
        value: e()
      };
    } catch (e) {
      return {
        error: !0,
        value: e
      };
    }
  },
  task$1 = task.set,
  SPECIES$5 = wellKnownSymbol("species"),
  PROMISE = "Promise",
  getInternalState$3 = internalState.get,
  setInternalState$3 = internalState.set,
  getInternalPromiseState = internalState.getterFor(PROMISE),
  PromiseConstructor = nativePromiseConstructor,
  TypeError$1 = global$1.TypeError,
  document$3 = global$1.document,
  process$3 = global$1.process;
getBuiltIn("fetch");
var Internal,
  OwnPromiseCapability,
  PromiseWrapper,
  newPromiseCapability$1 = newPromiseCapability.f,
  newGenericPromiseCapability = newPromiseCapability$1,
  DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global$1.dispatchEvent),
  NATIVE_REJECTION_EVENT = "function" == typeof PromiseRejectionEvent,
  UNHANDLED_REJECTION = "unhandledrejection",
  REJECTION_HANDLED = "rejectionhandled",
  PENDING = 0,
  FULFILLED = 1,
  REJECTED = 2,
  HANDLED = 1,
  UNHANDLED = 2,
  FORCED$3 = isForced_1(PROMISE, function () {
    if (!(inspectSource(PromiseConstructor) !== String(PromiseConstructor))) {
      if (66 === engineV8Version) return !0;
      if (!engineIsNode && !NATIVE_REJECTION_EVENT) return !0;
    }
    if (!PromiseConstructor.prototype.finally) return !0;
    if (engineV8Version >= 51 && /native code/.test(PromiseConstructor)) return !1;
    var e = PromiseConstructor.resolve(1),
      t = function t(e) {
        e(function () {}, function () {});
      };
    return (e.constructor = {})[SPECIES$5] = t, !(e.then(function () {}) instanceof t);
  }),
  INCORRECT_ITERATION$1 = FORCED$3 || !checkCorrectnessOfIteration(function (e) {
    PromiseConstructor.all(e).catch(function () {});
  }),
  isThenable = function isThenable(e) {
    var t;
    return !(!isObject(e) || "function" != typeof (t = e.then)) && t;
  },
  notify$1 = function notify$1(e, t) {
    if (!e.notified) {
      e.notified = !0;
      var r = e.reactions;
      microtask(function () {
        for (var n = e.value, o = e.state == FULFILLED, a = 0; r.length > a;) {
          var i,
            s,
            c,
            u = r[a++],
            l = o ? u.ok : u.fail,
            f = u.resolve,
            p = u.reject,
            h = u.domain;
          try {
            l ? (o || (e.rejection === UNHANDLED && onHandleUnhandled(e), e.rejection = HANDLED), !0 === l ? i = n : (h && h.enter(), i = l(n), h && (h.exit(), c = !0)), i === u.promise ? p(TypeError$1("Promise-chain cycle")) : (s = isThenable(i)) ? s.call(i, f, p) : f(i)) : p(n);
          } catch (e) {
            h && !c && h.exit(), p(e);
          }
        }
        e.reactions = [], e.notified = !1, t && !e.rejection && onUnhandled(e);
      });
    }
  },
  dispatchEvent = function dispatchEvent(e, t, r) {
    var n, o;
    DISPATCH_EVENT ? ((n = document$3.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), global$1.dispatchEvent(n)) : n = {
      promise: t,
      reason: r
    }, !NATIVE_REJECTION_EVENT && (o = global$1["on" + e]) ? o(n) : e === UNHANDLED_REJECTION && hostReportErrors("Unhandled promise rejection", r);
  },
  onUnhandled = function onUnhandled(e) {
    task$1.call(global$1, function () {
      var t,
        r = e.facade,
        n = e.value;
      if (isUnhandled(e) && (t = perform(function () {
        engineIsNode ? process$3.emit("unhandledRejection", n, r) : dispatchEvent(UNHANDLED_REJECTION, r, n);
      }), e.rejection = engineIsNode || isUnhandled(e) ? UNHANDLED : HANDLED, t.error)) throw t.value;
    });
  },
  isUnhandled = function isUnhandled(e) {
    return e.rejection !== HANDLED && !e.parent;
  },
  onHandleUnhandled = function onHandleUnhandled(e) {
    task$1.call(global$1, function () {
      var t = e.facade;
      engineIsNode ? process$3.emit("rejectionHandled", t) : dispatchEvent(REJECTION_HANDLED, t, e.value);
    });
  },
  bind$3 = function bind$3(e, t, r) {
    return function (n) {
      e(t, n, r);
    };
  },
  internalReject = function internalReject(e, t, r) {
    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = REJECTED, notify$1(e, !0));
  },
  internalResolve = function e(t, r, n) {
    if (!t.done) {
      t.done = !0, n && (t = n);
      try {
        if (t.facade === r) throw TypeError$1("Promise can't be resolved itself");
        var o = isThenable(r);
        o ? microtask(function () {
          var n = {
            done: !1
          };
          try {
            o.call(r, bind$3(e, n, t), bind$3(internalReject, n, t));
          } catch (e) {
            internalReject(n, e, t);
          }
        }) : (t.value = r, t.state = FULFILLED, notify$1(t, !1));
      } catch (e) {
        internalReject({
          done: !1
        }, e, t);
      }
    }
  };
FORCED$3 && (PromiseConstructor = function (e) {
  anInstance(this, PromiseConstructor, PROMISE), aFunction(e), Internal.call(this);
  var t = getInternalState$3(this);
  try {
    e(bind$3(internalResolve, t), bind$3(internalReject, t));
  } catch (e) {
    internalReject(t, e);
  }
}, (Internal = function (e) {
  setInternalState$3(this, {
    type: PROMISE,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: [],
    rejection: !1,
    state: PENDING,
    value: void 0
  });
}).prototype = redefineAll(PromiseConstructor.prototype, {
  then: function (e, t) {
    var r = getInternalPromiseState(this),
      n = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = engineIsNode ? process$3.domain : void 0, r.parent = !0, r.reactions.push(n), r.state != PENDING && notify$1(r, !1), n.promise;
  },
  catch: function (e) {
    return this.then(void 0, e);
  }
}), OwnPromiseCapability = function () {
  var e = new Internal(),
    t = getInternalState$3(e);
  this.promise = e, this.resolve = bind$3(internalResolve, t), this.reject = bind$3(internalReject, t);
}, newPromiseCapability.f = newPromiseCapability$1 = function (e) {
  return e === PromiseConstructor || e === PromiseWrapper ? new OwnPromiseCapability(e) : newGenericPromiseCapability(e);
}), _export({
  global: !0,
  wrap: !0,
  forced: FORCED$3
}, {
  Promise: PromiseConstructor
}), setToStringTag(PromiseConstructor, PROMISE, !1, !0), setSpecies(PROMISE), PromiseWrapper = getBuiltIn(PROMISE), _export({
  target: PROMISE,
  stat: !0,
  forced: FORCED$3
}, {
  reject: function (e) {
    var t = newPromiseCapability$1(this);
    return t.reject.call(void 0, e), t.promise;
  }
}), _export({
  target: PROMISE,
  stat: !0,
  forced: isPure
}, {
  resolve: function (e) {
    return promiseResolve(this === PromiseWrapper ? PromiseConstructor : this, e);
  }
}), _export({
  target: PROMISE,
  stat: !0,
  forced: INCORRECT_ITERATION$1
}, {
  all: function (e) {
    var t = this,
      r = newPromiseCapability$1(t),
      n = r.resolve,
      o = r.reject,
      a = perform(function () {
        var r = aFunction(t.resolve),
          a = [],
          i = 0,
          s = 1;
        iterate(e, function (e) {
          var c = i++,
            u = !1;
          a.push(void 0), s++, r.call(t, e).then(function (e) {
            u || (u = !0, a[c] = e, --s || n(a));
          }, o);
        }), --s || n(a);
      });
    return a.error && o(a.value), r.promise;
  },
  race: function (e) {
    var t = this,
      r = newPromiseCapability$1(t),
      n = r.reject,
      o = perform(function () {
        var o = aFunction(t.resolve);
        iterate(e, function (e) {
          o.call(t, e).then(r.resolve, n);
        });
      });
    return o.error && n(o.value), r.promise;
  }
}), _export({
  target: "Promise",
  stat: !0
}, {
  allSettled: function (e) {
    var t = this,
      r = newPromiseCapability.f(t),
      n = r.resolve,
      o = r.reject,
      a = perform(function () {
        var r = aFunction(t.resolve),
          o = [],
          a = 0,
          i = 1;
        iterate(e, function (e) {
          var s = a++,
            c = !1;
          o.push(void 0), i++, r.call(t, e).then(function (e) {
            c || (c = !0, o[s] = {
              status: "fulfilled",
              value: e
            }, --i || n(o));
          }, function (e) {
            c || (c = !0, o[s] = {
              status: "rejected",
              reason: e
            }, --i || n(o));
          });
        }), --i || n(o);
      });
    return a.error && o(a.value), r.promise;
  }
});
var PROMISE_ANY_ERROR = "No one promise resolved";
_export({
  target: "Promise",
  stat: !0
}, {
  any: function (e) {
    var t = this,
      r = newPromiseCapability.f(t),
      n = r.resolve,
      o = r.reject,
      a = perform(function () {
        var r = aFunction(t.resolve),
          a = [],
          i = 0,
          s = 1,
          c = !1;
        iterate(e, function (e) {
          var u = i++,
            l = !1;
          a.push(void 0), s++, r.call(t, e).then(function (e) {
            l || c || (c = !0, n(e));
          }, function (e) {
            l || c || (l = !0, a[u] = e, --s || o(new (getBuiltIn("AggregateError"))(a, PROMISE_ANY_ERROR)));
          });
        }), --s || o(new (getBuiltIn("AggregateError"))(a, PROMISE_ANY_ERROR));
      });
    return a.error && o(a.value), r.promise;
  }
});
var NON_GENERIC = !!nativePromiseConstructor && fails(function () {
  nativePromiseConstructor.prototype.finally.call({
    then: function () {}
  }, function () {});
});
_export({
  target: "Promise",
  proto: !0,
  real: !0,
  forced: NON_GENERIC
}, {
  finally: function (e) {
    var t = speciesConstructor(this, getBuiltIn("Promise")),
      r = "function" == typeof e;
    return this.then(r ? function (r) {
      return promiseResolve(t, e()).then(function () {
        return r;
      });
    } : e, r ? function (r) {
      return promiseResolve(t, e()).then(function () {
        throw r;
      });
    } : e);
  }
});
var promise$1 = path.Promise;
_export({
  target: "Promise",
  stat: !0
}, {
  try: function (e) {
    var t = newPromiseCapability.f(this),
      r = perform(e);
    return (r.error ? t.reject : t.resolve)(r.value), t.promise;
  }
});
var promise$2 = promise$1,
  promise$3 = promise$2;
function asyncGeneratorStep(e, t, r, n, o, a, i) {
  try {
    var s = e[a](i),
      c = s.value;
  } catch (e) {
    return void r(e);
  }
  s.done ? t(c) : promise$3.resolve(c).then(n, o);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      r = arguments;
    return new promise$3(function (n, o) {
      var a = e.apply(t, r);
      function i(e) {
        asyncGeneratorStep(a, n, o, i, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(a, n, o, i, s, "throw", e);
      }
      i(void 0);
    });
  };
}
var asyncToGenerator = _asyncToGenerator;
!function (e) {
  !function (t) {
    var r = ("URLSearchParams" in e),
      n = "Symbol" in e && "iterator" in Symbol,
      o = "FileReader" in e && "Blob" in e && function () {
        try {
          return new Blob(), !0;
        } catch (e) {
          return !1;
        }
      }(),
      a = ("FormData" in e),
      i = ("ArrayBuffer" in e);
    if (i) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
      c = ArrayBuffer.isView || function (e) {
        return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
      };
    function u(e) {
      if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
      return e.toLowerCase();
    }
    function l(e) {
      return "string" != typeof e && (e = String(e)), e;
    }
    function f(e) {
      var t = {
        next: function () {
          var t = e.shift();
          return {
            done: void 0 === t,
            value: t
          };
        }
      };
      return n && (t[Symbol.iterator] = function () {
        return t;
      }), t;
    }
    function p(e) {
      this.map = {}, e instanceof p ? e.forEach(function (e, t) {
        this.append(t, e);
      }, this) : Array.isArray(e) ? e.forEach(function (e) {
        this.append(e[0], e[1]);
      }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
        this.append(t, e[t]);
      }, this);
    }
    function h(e) {
      if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
      e.bodyUsed = !0;
    }
    function y(e) {
      return new Promise(function (t, r) {
        e.onload = function () {
          t(e.result);
        }, e.onerror = function () {
          r(e.error);
        };
      });
    }
    function d(e) {
      var t = new FileReader(),
        r = y(t);
      return t.readAsArrayBuffer(e), r;
    }
    function g(e) {
      if (e.slice) return e.slice(0);
      var t = new Uint8Array(e.byteLength);
      return t.set(new Uint8Array(e)), t.buffer;
    }
    function m() {
      return this.bodyUsed = !1, this._initBody = function (e) {
        var t;
        this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : a && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : i && (ArrayBuffer.prototype.isPrototypeOf(e) || c(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
      }, o && (this.blob = function () {
        var e = h(this);
        if (e) return e;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        return Promise.resolve(new Blob([this._bodyText]));
      }, this.arrayBuffer = function () {
        return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(d);
      }), this.text = function () {
        var e = h(this);
        if (e) return e;
        if (this._bodyBlob) return function (e) {
          var t = new FileReader(),
            r = y(t);
          return t.readAsText(e), r;
        }(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
          for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) r[n] = String.fromCharCode(t[n]);
          return r.join("");
        }(this._bodyArrayBuffer));
        if (this._bodyFormData) throw new Error("could not read FormData body as text");
        return Promise.resolve(this._bodyText);
      }, a && (this.formData = function () {
        return this.text().then(_);
      }), this.json = function () {
        return this.text().then(JSON.parse);
      }, this;
    }
    p.prototype.append = function (e, t) {
      e = u(e), t = l(t);
      var r = this.map[e];
      this.map[e] = r ? r + ", " + t : t;
    }, p.prototype.delete = function (e) {
      delete this.map[u(e)];
    }, p.prototype.get = function (e) {
      return e = u(e), this.has(e) ? this.map[e] : null;
    }, p.prototype.has = function (e) {
      return this.map.hasOwnProperty(u(e));
    }, p.prototype.set = function (e, t) {
      this.map[u(e)] = l(t);
    }, p.prototype.forEach = function (e, t) {
      for (var r in this.map) this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
    }, p.prototype.keys = function () {
      var e = [];
      return this.forEach(function (t, r) {
        e.push(r);
      }), f(e);
    }, p.prototype.values = function () {
      var e = [];
      return this.forEach(function (t) {
        e.push(t);
      }), f(e);
    }, p.prototype.entries = function () {
      var e = [];
      return this.forEach(function (t, r) {
        e.push([r, t]);
      }), f(e);
    }, n && (p.prototype[Symbol.iterator] = p.prototype.entries);
    var b = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
    function v(e, t) {
      var r,
        n,
        o = (t = t || {}).body;
      if (e instanceof v) {
        if (e.bodyUsed) throw new TypeError("Already read");
        this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new p(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
      } else this.url = String(e);
      if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (r = t.method || this.method || "GET", n = r.toUpperCase(), b.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
      this._initBody(o);
    }
    function _(e) {
      var t = new FormData();
      return e.trim().split("&").forEach(function (e) {
        if (e) {
          var r = e.split("="),
            n = r.shift().replace(/\+/g, " "),
            o = r.join("=").replace(/\+/g, " ");
          t.append(decodeURIComponent(n), decodeURIComponent(o));
        }
      }), t;
    }
    function A(e, t) {
      t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e);
    }
    v.prototype.clone = function () {
      return new v(this, {
        body: this._bodyInit
      });
    }, m.call(v.prototype), m.call(A.prototype), A.prototype.clone = function () {
      return new A(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new p(this.headers),
        url: this.url
      });
    }, A.error = function () {
      var e = new A(null, {
        status: 0,
        statusText: ""
      });
      return e.type = "error", e;
    };
    var E = [301, 302, 303, 307, 308];
    A.redirect = function (e, t) {
      if (-1 === E.indexOf(t)) throw new RangeError("Invalid status code");
      return new A(null, {
        status: t,
        headers: {
          location: e
        }
      });
    }, t.DOMException = e.DOMException;
    try {
      new t.DOMException();
    } catch (e) {
      t.DOMException = function (e, t) {
        this.message = e, this.name = t;
        var r = Error(e);
        this.stack = r.stack;
      }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
    }
    function $(e, r) {
      return new Promise(function (n, a) {
        var i = new v(e, r);
        if (i.signal && i.signal.aborted) return a(new t.DOMException("Aborted", "AbortError"));
        var s = new XMLHttpRequest();
        function c() {
          s.abort();
        }
        s.onload = function () {
          var e,
            t,
            r = {
              status: s.status,
              statusText: s.statusText,
              headers: (e = s.getAllResponseHeaders() || "", t = new p(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                var r = e.split(":"),
                  n = r.shift().trim();
                if (n) {
                  var o = r.join(":").trim();
                  t.append(n, o);
                }
              }), t)
            };
          r.url = "responseURL" in s ? s.responseURL : r.headers.get("X-Request-URL");
          var o = "response" in s ? s.response : s.responseText;
          n(new A(o, r));
        }, s.onerror = function () {
          a(new TypeError("Network request failed"));
        }, s.ontimeout = function () {
          a(new TypeError("Network request failed"));
        }, s.onabort = function () {
          a(new t.DOMException("Aborted", "AbortError"));
        }, s.open(i.method, i.url, !0), "include" === i.credentials ? s.withCredentials = !0 : "omit" === i.credentials && (s.withCredentials = !1), "responseType" in s && o && (s.responseType = "blob"), i.headers.forEach(function (e, t) {
          s.setRequestHeader(t, e);
        }), i.signal && (i.signal.addEventListener("abort", c), s.onreadystatechange = function () {
          4 === s.readyState && i.signal.removeEventListener("abort", c);
        }), s.send(void 0 === i._bodyInit ? null : i._bodyInit);
      });
    }
    $.polyfill = !0, e.fetch || (e.fetch = $, e.Headers = p, e.Request = v, e.Response = A), t.Headers = p, t.Request = v, t.Response = A, t.fetch = $;
  }({});
}("undefined" != typeof self ? self : commonjsGlobal);
var replace = String.prototype.replace,
  percentTwenties = /%20/g,
  Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  },
  formats = {
    default: Format.RFC3986,
    formatters: {
      RFC1738: function (e) {
        return replace.call(e, percentTwenties, "+");
      },
      RFC3986: function (e) {
        return String(e);
      }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
  },
  has$2 = Object.prototype.hasOwnProperty,
  isArray$9 = Array.isArray,
  hexTable = function () {
    for (var e = [], t = 0; t < 256; ++t) e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
    return e;
  }(),
  compactQueue = function compactQueue(e) {
    for (; e.length > 1;) {
      var t = e.pop(),
        r = t.obj[t.prop];
      if (isArray$9(r)) {
        for (var n = [], o = 0; o < r.length; ++o) void 0 !== r[o] && n.push(r[o]);
        t.obj[t.prop] = n;
      }
    }
  },
  arrayToObject = function arrayToObject(e, t) {
    for (var r = t && t.plainObjects ? Object.create(null) : {}, n = 0; n < e.length; ++n) void 0 !== e[n] && (r[n] = e[n]);
    return r;
  },
  merge = function e(t, r, n) {
    if (!r) return t;
    if ("object" != typeof r) {
      if (isArray$9(t)) t.push(r);else {
        if (!t || "object" != typeof t) return [t, r];
        (n && (n.plainObjects || n.allowPrototypes) || !has$2.call(Object.prototype, r)) && (t[r] = !0);
      }
      return t;
    }
    if (!t || "object" != typeof t) return [t].concat(r);
    var o = t;
    return isArray$9(t) && !isArray$9(r) && (o = arrayToObject(t, n)), isArray$9(t) && isArray$9(r) ? (r.forEach(function (r, o) {
      if (has$2.call(t, o)) {
        var a = t[o];
        a && "object" == typeof a && r && "object" == typeof r ? t[o] = e(a, r, n) : t.push(r);
      } else t[o] = r;
    }), t) : Object.keys(r).reduce(function (t, o) {
      var a = r[o];
      return has$2.call(t, o) ? t[o] = e(t[o], a, n) : t[o] = a, t;
    }, o);
  },
  assign$1 = function assign$1(e, t) {
    return Object.keys(t).reduce(function (e, r) {
      return e[r] = t[r], e;
    }, e);
  },
  decode = function decode(e, t, r) {
    var n = e.replace(/\+/g, " ");
    if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(n);
    } catch (e) {
      return n;
    }
  },
  encode$1 = function encode$1(e, t, r, n, o) {
    if (0 === e.length) return e;
    var a = e;
    if ("symbol" == typeof e ? a = Symbol.prototype.toString.call(e) : "string" != typeof e && (a = String(e)), "iso-8859-1" === r) return escape(a).replace(/%u[0-9a-f]{4}/gi, function (e) {
      return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
    });
    for (var i = "", s = 0; s < a.length; ++s) {
      var c = a.charCodeAt(s);
      45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || o === formats.RFC1738 && (40 === c || 41 === c) ? i += a.charAt(s) : c < 128 ? i += hexTable[c] : c < 2048 ? i += hexTable[192 | c >> 6] + hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? i += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c] : (s += 1, c = 65536 + ((1023 & c) << 10 | 1023 & a.charCodeAt(s)), i += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c]);
    }
    return i;
  },
  compact = function compact(e) {
    for (var t = [{
        obj: {
          o: e
        },
        prop: "o"
      }], r = [], n = 0; n < t.length; ++n) for (var o = t[n], a = o.obj[o.prop], i = Object.keys(a), s = 0; s < i.length; ++s) {
      var c = i[s],
        u = a[c];
      "object" == typeof u && null !== u && -1 === r.indexOf(u) && (t.push({
        obj: a,
        prop: c
      }), r.push(u));
    }
    return compactQueue(t), e;
  },
  isRegExp = function isRegExp(e) {
    return "[object RegExp]" === Object.prototype.toString.call(e);
  },
  isBuffer$1 = function isBuffer$1(e) {
    return !(!e || "object" != typeof e) && !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
  },
  combine = function combine(e, t) {
    return [].concat(e, t);
  },
  maybeMap = function maybeMap(e, t) {
    if (isArray$9(e)) {
      for (var r = [], n = 0; n < e.length; n += 1) r.push(t(e[n]));
      return r;
    }
    return t(e);
  },
  utils = {
    arrayToObject: arrayToObject,
    assign: assign$1,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode$1,
    isBuffer: isBuffer$1,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
  },
  has$3 = Object.prototype.hasOwnProperty,
  arrayPrefixGenerators = {
    brackets: function (e) {
      return e + "[]";
    },
    comma: "comma",
    indices: function (e, t) {
      return e + "[" + t + "]";
    },
    repeat: function (e) {
      return e;
    }
  },
  isArray$a = Array.isArray,
  push$1 = Array.prototype.push,
  pushToArray = function pushToArray(e, t) {
    push$1.apply(e, isArray$a(t) ? t : [t]);
  },
  toISO = Date.prototype.toISOString,
  defaultFormat = formats.default,
  defaults = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: utils.encode,
    encodeValuesOnly: !1,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    indices: !1,
    serializeDate: function (e) {
      return toISO.call(e);
    },
    skipNulls: !1,
    strictNullHandling: !1
  },
  isNonNullishPrimitive = function isNonNullishPrimitive(e) {
    return "string" == typeof e || "number" == typeof e || "boolean" == typeof e || "symbol" == typeof e || "bigint" == typeof e;
  },
  stringify$4 = function e(t, r, n, o, a, i, s, c, u, l, f, p, h, y) {
    var d = t;
    if ("function" == typeof s ? d = s(r, d) : d instanceof Date ? d = l(d) : "comma" === n && isArray$a(d) && (d = utils.maybeMap(d, function (e) {
      return e instanceof Date ? l(e) : e;
    })), null === d) {
      if (o) return i && !h ? i(r, defaults.encoder, y, "key", f) : r;
      d = "";
    }
    if (isNonNullishPrimitive(d) || utils.isBuffer(d)) return i ? [p(h ? r : i(r, defaults.encoder, y, "key", f)) + "=" + p(i(d, defaults.encoder, y, "value", f))] : [p(r) + "=" + p(String(d))];
    var g,
      m = [];
    if (void 0 === d) return m;
    if ("comma" === n && isArray$a(d)) g = [{
      value: d.length > 0 ? d.join(",") || null : void 0
    }];else if (isArray$a(s)) g = s;else {
      var b = Object.keys(d);
      g = c ? b.sort(c) : b;
    }
    for (var v = 0; v < g.length; ++v) {
      var _ = g[v],
        A = "object" == typeof _ && void 0 !== _.value ? _.value : d[_];
      if (!a || null !== A) {
        var E = isArray$a(d) ? "function" == typeof n ? n(r, _) : r : r + (u ? "." + _ : "[" + _ + "]");
        pushToArray(m, e(A, E, n, o, a, i, s, c, u, l, f, p, h, y));
      }
    }
    return m;
  },
  normalizeStringifyOptions = function normalizeStringifyOptions(e) {
    if (!e) return defaults;
    if (null !== e.encoder && void 0 !== e.encoder && "function" != typeof e.encoder) throw new TypeError("Encoder has to be a function.");
    var t = e.charset || defaults.charset;
    if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var r = formats.default;
    if (void 0 !== e.format) {
      if (!has$3.call(formats.formatters, e.format)) throw new TypeError("Unknown format option provided.");
      r = e.format;
    }
    var n = formats.formatters[r],
      o = defaults.filter;
    return ("function" == typeof e.filter || isArray$a(e.filter)) && (o = e.filter), {
      addQueryPrefix: "boolean" == typeof e.addQueryPrefix ? e.addQueryPrefix : defaults.addQueryPrefix,
      allowDots: void 0 === e.allowDots ? defaults.allowDots : !!e.allowDots,
      charset: t,
      charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : defaults.charsetSentinel,
      delimiter: void 0 === e.delimiter ? defaults.delimiter : e.delimiter,
      encode: "boolean" == typeof e.encode ? e.encode : defaults.encode,
      encoder: "function" == typeof e.encoder ? e.encoder : defaults.encoder,
      encodeValuesOnly: "boolean" == typeof e.encodeValuesOnly ? e.encodeValuesOnly : defaults.encodeValuesOnly,
      filter: o,
      format: r,
      formatter: n,
      serializeDate: "function" == typeof e.serializeDate ? e.serializeDate : defaults.serializeDate,
      skipNulls: "boolean" == typeof e.skipNulls ? e.skipNulls : defaults.skipNulls,
      sort: "function" == typeof e.sort ? e.sort : null,
      strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : defaults.strictNullHandling
    };
  },
  stringify_1 = function stringify_1(e, t) {
    var r,
      n = e,
      o = normalizeStringifyOptions(t);
    "function" == typeof o.filter ? n = (0, o.filter)("", n) : isArray$a(o.filter) && (r = o.filter);
    var a,
      i = [];
    if ("object" != typeof n || null === n) return "";
    a = t && t.arrayFormat in arrayPrefixGenerators ? t.arrayFormat : t && "indices" in t ? t.indices ? "indices" : "repeat" : "indices";
    var s = arrayPrefixGenerators[a];
    r || (r = Object.keys(n)), o.sort && r.sort(o.sort);
    for (var c = 0; c < r.length; ++c) {
      var u = r[c];
      o.skipNulls && null === n[u] || pushToArray(i, stringify$4(n[u], u, s, o.strictNullHandling, o.skipNulls, o.encode ? o.encoder : null, o.filter, o.sort, o.allowDots, o.serializeDate, o.format, o.formatter, o.encodeValuesOnly, o.charset));
    }
    var l = i.join(o.delimiter),
      f = !0 === o.addQueryPrefix ? "?" : "";
    return o.charsetSentinel && ("iso-8859-1" === o.charset ? f += "utf8=%26%2310003%3B&" : f += "utf8=%E2%9C%93&"), l.length > 0 ? f + l : "";
  },
  has$4 = Object.prototype.hasOwnProperty,
  isArray$b = Array.isArray,
  defaults$1 = {
    allowDots: !1,
    allowPrototypes: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  },
  interpretNumericEntities = function interpretNumericEntities(e) {
    return e.replace(/&#(\d+);/g, function (e, t) {
      return String.fromCharCode(parseInt(t, 10));
    });
  },
  parseArrayValue = function parseArrayValue(e, t) {
    return e && "string" == typeof e && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
  },
  isoSentinel = "utf8=%26%2310003%3B",
  charsetSentinel = "utf8=%E2%9C%93",
  parseValues = function parseValues(e, t) {
    var r,
      n = {},
      o = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e,
      a = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
      i = o.split(t.delimiter, a),
      s = -1,
      c = t.charset;
    if (t.charsetSentinel) for (r = 0; r < i.length; ++r) 0 === i[r].indexOf("utf8=") && (i[r] === charsetSentinel ? c = "utf-8" : i[r] === isoSentinel && (c = "iso-8859-1"), s = r, r = i.length);
    for (r = 0; r < i.length; ++r) if (r !== s) {
      var u,
        l,
        f = i[r],
        p = f.indexOf("]="),
        h = -1 === p ? f.indexOf("=") : p + 1;
      -1 === h ? (u = t.decoder(f, defaults$1.decoder, c, "key"), l = t.strictNullHandling ? null : "") : (u = t.decoder(f.slice(0, h), defaults$1.decoder, c, "key"), l = utils.maybeMap(parseArrayValue(f.slice(h + 1), t), function (e) {
        return t.decoder(e, defaults$1.decoder, c, "value");
      })), l && t.interpretNumericEntities && "iso-8859-1" === c && (l = interpretNumericEntities(l)), f.indexOf("[]=") > -1 && (l = isArray$b(l) ? [l] : l), has$4.call(n, u) ? n[u] = utils.combine(n[u], l) : n[u] = l;
    }
    return n;
  },
  parseObject = function parseObject(e, t, r, n) {
    for (var o = n ? t : parseArrayValue(t, r), a = e.length - 1; a >= 0; --a) {
      var i,
        s = e[a];
      if ("[]" === s && r.parseArrays) i = [].concat(o);else {
        i = r.plainObjects ? Object.create(null) : {};
        var c = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s,
          u = parseInt(c, 10);
        r.parseArrays || "" !== c ? !isNaN(u) && s !== c && String(u) === c && u >= 0 && r.parseArrays && u <= r.arrayLimit ? (i = [])[u] = o : i[c] = o : i = {
          0: o
        };
      }
      o = i;
    }
    return o;
  },
  parseKeys = function parseKeys(e, t, r, n) {
    if (e) {
      var o = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e,
        a = /(\[[^[\]]*])/g,
        i = r.depth > 0 && /(\[[^[\]]*])/.exec(o),
        s = i ? o.slice(0, i.index) : o,
        c = [];
      if (s) {
        if (!r.plainObjects && has$4.call(Object.prototype, s) && !r.allowPrototypes) return;
        c.push(s);
      }
      for (var u = 0; r.depth > 0 && null !== (i = a.exec(o)) && u < r.depth;) {
        if (u += 1, !r.plainObjects && has$4.call(Object.prototype, i[1].slice(1, -1)) && !r.allowPrototypes) return;
        c.push(i[1]);
      }
      return i && c.push("[" + o.slice(i.index) + "]"), parseObject(c, t, r, n);
    }
  },
  normalizeParseOptions = function normalizeParseOptions(e) {
    if (!e) return defaults$1;
    if (null !== e.decoder && void 0 !== e.decoder && "function" != typeof e.decoder) throw new TypeError("Decoder has to be a function.");
    if (void 0 !== e.charset && "utf-8" !== e.charset && "iso-8859-1" !== e.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var t = void 0 === e.charset ? defaults$1.charset : e.charset;
    return {
      allowDots: void 0 === e.allowDots ? defaults$1.allowDots : !!e.allowDots,
      allowPrototypes: "boolean" == typeof e.allowPrototypes ? e.allowPrototypes : defaults$1.allowPrototypes,
      arrayLimit: "number" == typeof e.arrayLimit ? e.arrayLimit : defaults$1.arrayLimit,
      charset: t,
      charsetSentinel: "boolean" == typeof e.charsetSentinel ? e.charsetSentinel : defaults$1.charsetSentinel,
      comma: "boolean" == typeof e.comma ? e.comma : defaults$1.comma,
      decoder: "function" == typeof e.decoder ? e.decoder : defaults$1.decoder,
      delimiter: "string" == typeof e.delimiter || utils.isRegExp(e.delimiter) ? e.delimiter : defaults$1.delimiter,
      depth: "number" == typeof e.depth || !1 === e.depth ? +e.depth : defaults$1.depth,
      ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
      interpretNumericEntities: "boolean" == typeof e.interpretNumericEntities ? e.interpretNumericEntities : defaults$1.interpretNumericEntities,
      parameterLimit: "number" == typeof e.parameterLimit ? e.parameterLimit : defaults$1.parameterLimit,
      parseArrays: !1 !== e.parseArrays,
      plainObjects: "boolean" == typeof e.plainObjects ? e.plainObjects : defaults$1.plainObjects,
      strictNullHandling: "boolean" == typeof e.strictNullHandling ? e.strictNullHandling : defaults$1.strictNullHandling
    };
  },
  parse$2 = function parse$2(e, t) {
    var r = normalizeParseOptions(t);
    if ("" === e || null == e) return r.plainObjects ? Object.create(null) : {};
    for (var n = "string" == typeof e ? parseValues(e, r) : e, o = r.plainObjects ? Object.create(null) : {}, a = Object.keys(n), i = 0; i < a.length; ++i) {
      var s = a[i],
        c = parseKeys(s, n[s], r, "string" == typeof e);
      o = utils.merge(o, c, r);
    }
    return utils.compact(o);
  },
  lib = {
    formats: formats,
    parse: parse$2,
    stringify: stringify_1
  };
function isNothing(e) {
  return null == e;
}
function isObject$3(e) {
  return "object" == typeof e && null !== e;
}
function toArray(e) {
  return Array.isArray(e) ? e : isNothing(e) ? [] : [e];
}
function extend(e, t) {
  var r, n, o, a;
  if (t) for (r = 0, n = (a = Object.keys(t)).length; r < n; r += 1) e[o = a[r]] = t[o];
  return e;
}
function repeat(e, t) {
  var r,
    n = "";
  for (r = 0; r < t; r += 1) n += e;
  return n;
}
function isNegativeZero(e) {
  return 0 === e && Number.NEGATIVE_INFINITY === 1 / e;
}
var isNothing_1 = isNothing,
  isObject_1$1 = isObject$3,
  toArray_1 = toArray,
  repeat_1 = repeat,
  isNegativeZero_1 = isNegativeZero,
  extend_1 = extend,
  common = {
    isNothing: isNothing_1,
    isObject: isObject_1$1,
    toArray: toArray_1,
    repeat: repeat_1,
    isNegativeZero: isNegativeZero_1,
    extend: extend_1
  };
function YAMLException(e, t) {
  Error.call(this), this.name = "YAMLException", this.reason = e, this.mark = t, this.message = (this.reason || "(unknown reason)") + (this.mark ? " " + this.mark.toString() : ""), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
}
YAMLException.prototype = Object.create(Error.prototype), YAMLException.prototype.constructor = YAMLException, YAMLException.prototype.toString = function (e) {
  var t = this.name + ": ";
  return t += this.reason || "(unknown reason)", !e && this.mark && (t += " " + this.mark.toString()), t;
};
var exception = YAMLException;
function Mark(e, t, r, n, o) {
  this.name = e, this.buffer = t, this.position = r, this.line = n, this.column = o;
}
Mark.prototype.getSnippet = function (e, t) {
  var r, n, o, a, i;
  if (!this.buffer) return null;
  for (e = e || 4, t = t || 75, r = "", n = this.position; n > 0 && -1 === "\0\r\n\u2028\u2029".indexOf(this.buffer.charAt(n - 1));) if (n -= 1, this.position - n > t / 2 - 1) {
    r = " ... ", n += 5;
    break;
  }
  for (o = "", a = this.position; a < this.buffer.length && -1 === "\0\r\n\u2028\u2029".indexOf(this.buffer.charAt(a));) if ((a += 1) - this.position > t / 2 - 1) {
    o = " ... ", a -= 5;
    break;
  }
  return i = this.buffer.slice(n, a), common.repeat(" ", e) + r + i + o + "\n" + common.repeat(" ", e + this.position - n + r.length) + "^";
}, Mark.prototype.toString = function (e) {
  var t,
    r = "";
  return this.name && (r += 'in "' + this.name + '" '), r += "at line " + (this.line + 1) + ", column " + (this.column + 1), e || (t = this.getSnippet()) && (r += ":\n" + t), r;
};
var mark = Mark,
  TYPE_CONSTRUCTOR_OPTIONS = ["kind", "resolve", "construct", "instanceOf", "predicate", "represent", "defaultStyle", "styleAliases"],
  YAML_NODE_KINDS = ["scalar", "sequence", "mapping"];
function compileStyleAliases(e) {
  var t = {};
  return null !== e && Object.keys(e).forEach(function (r) {
    e[r].forEach(function (e) {
      t[String(e)] = r;
    });
  }), t;
}
function Type(e, t) {
  if (t = t || {}, Object.keys(t).forEach(function (t) {
    if (-1 === TYPE_CONSTRUCTOR_OPTIONS.indexOf(t)) throw new exception('Unknown option "' + t + '" is met in definition of "' + e + '" YAML type.');
  }), this.tag = e, this.kind = t.kind || null, this.resolve = t.resolve || function () {
    return !0;
  }, this.construct = t.construct || function (e) {
    return e;
  }, this.instanceOf = t.instanceOf || null, this.predicate = t.predicate || null, this.represent = t.represent || null, this.defaultStyle = t.defaultStyle || null, this.styleAliases = compileStyleAliases(t.styleAliases || null), -1 === YAML_NODE_KINDS.indexOf(this.kind)) throw new exception('Unknown kind "' + this.kind + '" is specified for "' + e + '" YAML type.');
}
var type = Type;
function compileList(e, t, r) {
  var n = [];
  return e.include.forEach(function (e) {
    r = compileList(e, t, r);
  }), e[t].forEach(function (e) {
    r.forEach(function (t, r) {
      t.tag === e.tag && t.kind === e.kind && n.push(r);
    }), r.push(e);
  }), r.filter(function (e, t) {
    return -1 === n.indexOf(t);
  });
}
function compileMap() {
  var e,
    t,
    r = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {}
    };
  function n(e) {
    r[e.kind][e.tag] = r.fallback[e.tag] = e;
  }
  for (e = 0, t = arguments.length; e < t; e += 1) arguments[e].forEach(n);
  return r;
}
function Schema(e) {
  this.include = e.include || [], this.implicit = e.implicit || [], this.explicit = e.explicit || [], this.implicit.forEach(function (e) {
    if (e.loadKind && "scalar" !== e.loadKind) throw new exception("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
  }), this.compiledImplicit = compileList(this, "implicit", []), this.compiledExplicit = compileList(this, "explicit", []), this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
}
Schema.DEFAULT = null, Schema.create = function () {
  var e, t;
  switch (arguments.length) {
    case 1:
      e = Schema.DEFAULT, t = arguments[0];
      break;
    case 2:
      e = arguments[0], t = arguments[1];
      break;
    default:
      throw new exception("Wrong number of arguments for Schema.create function");
  }
  if (e = common.toArray(e), t = common.toArray(t), !e.every(function (e) {
    return e instanceof Schema;
  })) throw new exception("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
  if (!t.every(function (e) {
    return e instanceof type;
  })) throw new exception("Specified list of YAML types (or a single Type object) contains a non-Type object.");
  return new Schema({
    include: e,
    explicit: t
  });
};
var schema = Schema,
  str = new type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function (e) {
      return null !== e ? e : "";
    }
  }),
  seq = new type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function (e) {
      return null !== e ? e : [];
    }
  }),
  map$5 = new type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function (e) {
      return null !== e ? e : {};
    }
  }),
  failsafe = new schema({
    explicit: [str, seq, map$5]
  });
function resolveYamlNull(e) {
  if (null === e) return !0;
  var t = e.length;
  return 1 === t && "~" === e || 4 === t && ("null" === e || "Null" === e || "NULL" === e);
}
function constructYamlNull() {
  return null;
}
function isNull$1(e) {
  return null === e;
}
var _null = new type("tag:yaml.org,2002:null", {
  kind: "scalar",
  resolve: resolveYamlNull,
  construct: constructYamlNull,
  predicate: isNull$1,
  represent: {
    canonical: function () {
      return "~";
    },
    lowercase: function () {
      return "null";
    },
    uppercase: function () {
      return "NULL";
    },
    camelcase: function () {
      return "Null";
    }
  },
  defaultStyle: "lowercase"
});
function resolveYamlBoolean(e) {
  if (null === e) return !1;
  var t = e.length;
  return 4 === t && ("true" === e || "True" === e || "TRUE" === e) || 5 === t && ("false" === e || "False" === e || "FALSE" === e);
}
function constructYamlBoolean(e) {
  return "true" === e || "True" === e || "TRUE" === e;
}
function isBoolean(e) {
  return "[object Boolean]" === Object.prototype.toString.call(e);
}
var bool = new type("tag:yaml.org,2002:bool", {
  kind: "scalar",
  resolve: resolveYamlBoolean,
  construct: constructYamlBoolean,
  predicate: isBoolean,
  represent: {
    lowercase: function (e) {
      return e ? "true" : "false";
    },
    uppercase: function (e) {
      return e ? "TRUE" : "FALSE";
    },
    camelcase: function (e) {
      return e ? "True" : "False";
    }
  },
  defaultStyle: "lowercase"
});
function isHexCode(e) {
  return 48 <= e && e <= 57 || 65 <= e && e <= 70 || 97 <= e && e <= 102;
}
function isOctCode(e) {
  return 48 <= e && e <= 55;
}
function isDecCode(e) {
  return 48 <= e && e <= 57;
}
function resolveYamlInteger(e) {
  if (null === e) return !1;
  var t,
    r = e.length,
    n = 0,
    o = !1;
  if (!r) return !1;
  if ("-" !== (t = e[n]) && "+" !== t || (t = e[++n]), "0" === t) {
    if (n + 1 === r) return !0;
    if ("b" === (t = e[++n])) {
      for (n++; n < r; n++) if ("_" !== (t = e[n])) {
        if ("0" !== t && "1" !== t) return !1;
        o = !0;
      }
      return o && "_" !== t;
    }
    if ("x" === t) {
      for (n++; n < r; n++) if ("_" !== (t = e[n])) {
        if (!isHexCode(e.charCodeAt(n))) return !1;
        o = !0;
      }
      return o && "_" !== t;
    }
    for (; n < r; n++) if ("_" !== (t = e[n])) {
      if (!isOctCode(e.charCodeAt(n))) return !1;
      o = !0;
    }
    return o && "_" !== t;
  }
  if ("_" === t) return !1;
  for (; n < r; n++) if ("_" !== (t = e[n])) {
    if (":" === t) break;
    if (!isDecCode(e.charCodeAt(n))) return !1;
    o = !0;
  }
  return !(!o || "_" === t) && (":" !== t || /^(:[0-5]?[0-9])+$/.test(e.slice(n)));
}
function constructYamlInteger(e) {
  var t,
    r,
    n = e,
    o = 1,
    a = [];
  return -1 !== n.indexOf("_") && (n = n.replace(/_/g, "")), "-" !== (t = n[0]) && "+" !== t || ("-" === t && (o = -1), t = (n = n.slice(1))[0]), "0" === n ? 0 : "0" === t ? "b" === n[1] ? o * parseInt(n.slice(2), 2) : "x" === n[1] ? o * parseInt(n, 16) : o * parseInt(n, 8) : -1 !== n.indexOf(":") ? (n.split(":").forEach(function (e) {
    a.unshift(parseInt(e, 10));
  }), n = 0, r = 1, a.forEach(function (e) {
    n += e * r, r *= 60;
  }), o * n) : o * parseInt(n, 10);
}
function isInteger(e) {
  return "[object Number]" === Object.prototype.toString.call(e) && e % 1 == 0 && !common.isNegativeZero(e);
}
var int = new type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: resolveYamlInteger,
    construct: constructYamlInteger,
    predicate: isInteger,
    represent: {
      binary: function (e) {
        return e >= 0 ? "0b" + e.toString(2) : "-0b" + e.toString(2).slice(1);
      },
      octal: function (e) {
        return e >= 0 ? "0" + e.toString(8) : "-0" + e.toString(8).slice(1);
      },
      decimal: function (e) {
        return e.toString(10);
      },
      hexadecimal: function (e) {
        return e >= 0 ? "0x" + e.toString(16).toUpperCase() : "-0x" + e.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  }),
  YAML_FLOAT_PATTERN = new RegExp("^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function resolveYamlFloat(e) {
  return null !== e && !(!YAML_FLOAT_PATTERN.test(e) || "_" === e[e.length - 1]);
}
function constructYamlFloat(e) {
  var t, r, n, o;
  return r = "-" === (t = e.replace(/_/g, "").toLowerCase())[0] ? -1 : 1, o = [], "+-".indexOf(t[0]) >= 0 && (t = t.slice(1)), ".inf" === t ? 1 === r ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : ".nan" === t ? NaN : t.indexOf(":") >= 0 ? (t.split(":").forEach(function (e) {
    o.unshift(parseFloat(e, 10));
  }), t = 0, n = 1, o.forEach(function (e) {
    t += e * n, n *= 60;
  }), r * t) : r * parseFloat(t, 10);
}
var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function representYamlFloat(e, t) {
  var r;
  if (isNaN(e)) switch (t) {
    case "lowercase":
      return ".nan";
    case "uppercase":
      return ".NAN";
    case "camelcase":
      return ".NaN";
  } else if (Number.POSITIVE_INFINITY === e) switch (t) {
    case "lowercase":
      return ".inf";
    case "uppercase":
      return ".INF";
    case "camelcase":
      return ".Inf";
  } else if (Number.NEGATIVE_INFINITY === e) switch (t) {
    case "lowercase":
      return "-.inf";
    case "uppercase":
      return "-.INF";
    case "camelcase":
      return "-.Inf";
  } else if (common.isNegativeZero(e)) return "-0.0";
  return r = e.toString(10), SCIENTIFIC_WITHOUT_DOT.test(r) ? r.replace("e", ".e") : r;
}
function isFloat(e) {
  return "[object Number]" === Object.prototype.toString.call(e) && (e % 1 != 0 || common.isNegativeZero(e));
}
var float = new type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: resolveYamlFloat,
    construct: constructYamlFloat,
    predicate: isFloat,
    represent: representYamlFloat,
    defaultStyle: "lowercase"
  }),
  json = new schema({
    include: [failsafe],
    implicit: [_null, bool, int, float]
  }),
  core = new schema({
    include: [json]
  }),
  YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"),
  YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
function resolveYamlTimestamp(e) {
  return null !== e && (null !== YAML_DATE_REGEXP.exec(e) || null !== YAML_TIMESTAMP_REGEXP.exec(e));
}
function constructYamlTimestamp(e) {
  var t,
    r,
    n,
    o,
    a,
    i,
    s,
    c,
    u = 0,
    l = null;
  if (null === (t = YAML_DATE_REGEXP.exec(e)) && (t = YAML_TIMESTAMP_REGEXP.exec(e)), null === t) throw new Error("Date resolve error");
  if (r = +t[1], n = +t[2] - 1, o = +t[3], !t[4]) return new Date(Date.UTC(r, n, o));
  if (a = +t[4], i = +t[5], s = +t[6], t[7]) {
    for (u = t[7].slice(0, 3); u.length < 3;) u += "0";
    u = +u;
  }
  return t[9] && (l = 6e4 * (60 * +t[10] + +(t[11] || 0)), "-" === t[9] && (l = -l)), c = new Date(Date.UTC(r, n, o, a, i, s, u)), l && c.setTime(c.getTime() - l), c;
}
function representYamlTimestamp(e) {
  return e.toISOString();
}
var timestamp = new type("tag:yaml.org,2002:timestamp", {
  kind: "scalar",
  resolve: resolveYamlTimestamp,
  construct: constructYamlTimestamp,
  instanceOf: Date,
  represent: representYamlTimestamp
});
function resolveYamlMerge(e) {
  return "<<" === e || null === e;
}
var NodeBuffer,
  merge$1 = new type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: resolveYamlMerge
  });
try {
  var _require = commonjsRequire;
  NodeBuffer = _require("buffer").Buffer;
} catch (e) {}
var BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r";
function resolveYamlBinary(e) {
  if (null === e) return !1;
  var t,
    r,
    n = 0,
    o = e.length,
    a = BASE64_MAP;
  for (r = 0; r < o; r++) if (!((t = a.indexOf(e.charAt(r))) > 64)) {
    if (t < 0) return !1;
    n += 6;
  }
  return n % 8 == 0;
}
function constructYamlBinary(e) {
  var t,
    r,
    n = e.replace(/[\r\n=]/g, ""),
    o = n.length,
    a = BASE64_MAP,
    i = 0,
    s = [];
  for (t = 0; t < o; t++) t % 4 == 0 && t && (s.push(i >> 16 & 255), s.push(i >> 8 & 255), s.push(255 & i)), i = i << 6 | a.indexOf(n.charAt(t));
  return 0 === (r = o % 4 * 6) ? (s.push(i >> 16 & 255), s.push(i >> 8 & 255), s.push(255 & i)) : 18 === r ? (s.push(i >> 10 & 255), s.push(i >> 2 & 255)) : 12 === r && s.push(i >> 4 & 255), NodeBuffer ? NodeBuffer.from ? NodeBuffer.from(s) : new NodeBuffer(s) : s;
}
function representYamlBinary(e) {
  var t,
    r,
    n = "",
    o = 0,
    a = e.length,
    i = BASE64_MAP;
  for (t = 0; t < a; t++) t % 3 == 0 && t && (n += i[o >> 18 & 63], n += i[o >> 12 & 63], n += i[o >> 6 & 63], n += i[63 & o]), o = (o << 8) + e[t];
  return 0 === (r = a % 3) ? (n += i[o >> 18 & 63], n += i[o >> 12 & 63], n += i[o >> 6 & 63], n += i[63 & o]) : 2 === r ? (n += i[o >> 10 & 63], n += i[o >> 4 & 63], n += i[o << 2 & 63], n += i[64]) : 1 === r && (n += i[o >> 2 & 63], n += i[o << 4 & 63], n += i[64], n += i[64]), n;
}
function isBinary(e) {
  return NodeBuffer && NodeBuffer.isBuffer(e);
}
var binary = new type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: resolveYamlBinary,
    construct: constructYamlBinary,
    predicate: isBinary,
    represent: representYamlBinary
  }),
  _hasOwnProperty = Object.prototype.hasOwnProperty,
  _toString = Object.prototype.toString;
function resolveYamlOmap(e) {
  if (null === e) return !0;
  var t,
    r,
    n,
    o,
    a,
    i = [],
    s = e;
  for (t = 0, r = s.length; t < r; t += 1) {
    if (n = s[t], a = !1, "[object Object]" !== _toString.call(n)) return !1;
    for (o in n) if (_hasOwnProperty.call(n, o)) {
      if (a) return !1;
      a = !0;
    }
    if (!a) return !1;
    if (-1 !== i.indexOf(o)) return !1;
    i.push(o);
  }
  return !0;
}
function constructYamlOmap(e) {
  return null !== e ? e : [];
}
var omap = new type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: resolveYamlOmap,
    construct: constructYamlOmap
  }),
  _toString$1 = Object.prototype.toString;
function resolveYamlPairs(e) {
  if (null === e) return !0;
  var t,
    r,
    n,
    o,
    a,
    i = e;
  for (a = new Array(i.length), t = 0, r = i.length; t < r; t += 1) {
    if (n = i[t], "[object Object]" !== _toString$1.call(n)) return !1;
    if (1 !== (o = Object.keys(n)).length) return !1;
    a[t] = [o[0], n[o[0]]];
  }
  return !0;
}
function constructYamlPairs(e) {
  if (null === e) return [];
  var t,
    r,
    n,
    o,
    a,
    i = e;
  for (a = new Array(i.length), t = 0, r = i.length; t < r; t += 1) n = i[t], o = Object.keys(n), a[t] = [o[0], n[o[0]]];
  return a;
}
var pairs = new type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: resolveYamlPairs,
    construct: constructYamlPairs
  }),
  _hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function resolveYamlSet(e) {
  if (null === e) return !0;
  var t,
    r = e;
  for (t in r) if (_hasOwnProperty$1.call(r, t) && null !== r[t]) return !1;
  return !0;
}
function constructYamlSet(e) {
  return null !== e ? e : {};
}
var set$2 = new type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: resolveYamlSet,
    construct: constructYamlSet
  }),
  default_safe = new schema({
    include: [core],
    implicit: [timestamp, merge$1],
    explicit: [binary, omap, pairs, set$2]
  });
function resolveJavascriptUndefined() {
  return !0;
}
function constructJavascriptUndefined() {}
function representJavascriptUndefined() {
  return "";
}
function isUndefined(e) {
  return void 0 === e;
}
var _undefined = new type("tag:yaml.org,2002:js/undefined", {
  kind: "scalar",
  resolve: resolveJavascriptUndefined,
  construct: constructJavascriptUndefined,
  predicate: isUndefined,
  represent: representJavascriptUndefined
});
function resolveJavascriptRegExp(e) {
  if (null === e) return !1;
  if (0 === e.length) return !1;
  var t = e,
    r = /\/([gim]*)$/.exec(e),
    n = "";
  if ("/" === t[0]) {
    if (r && (n = r[1]), n.length > 3) return !1;
    if ("/" !== t[t.length - n.length - 1]) return !1;
  }
  return !0;
}
function constructJavascriptRegExp(e) {
  var t = e,
    r = /\/([gim]*)$/.exec(e),
    n = "";
  return "/" === t[0] && (r && (n = r[1]), t = t.slice(1, t.length - n.length - 1)), new RegExp(t, n);
}
function representJavascriptRegExp(e) {
  var t = "/" + e.source + "/";
  return e.global && (t += "g"), e.multiline && (t += "m"), e.ignoreCase && (t += "i"), t;
}
function isRegExp$1(e) {
  return "[object RegExp]" === Object.prototype.toString.call(e);
}
var esprima,
  regexp = new type("tag:yaml.org,2002:js/regexp", {
    kind: "scalar",
    resolve: resolveJavascriptRegExp,
    construct: constructJavascriptRegExp,
    predicate: isRegExp$1,
    represent: representJavascriptRegExp
  });
try {
  var _require$1 = commonjsRequire;
  esprima = _require$1("esprima");
} catch (e) {
  "undefined" != typeof window && (esprima = window.esprima);
}
function resolveJavascriptFunction(e) {
  if (null === e) return !1;
  try {
    var t = "(" + e + ")",
      r = esprima.parse(t, {
        range: !0
      });
    return "Program" === r.type && 1 === r.body.length && "ExpressionStatement" === r.body[0].type && ("ArrowFunctionExpression" === r.body[0].expression.type || "FunctionExpression" === r.body[0].expression.type);
  } catch (e) {
    return !1;
  }
}
function constructJavascriptFunction(e) {
  var t,
    r = "(" + e + ")",
    n = esprima.parse(r, {
      range: !0
    }),
    o = [];
  if ("Program" !== n.type || 1 !== n.body.length || "ExpressionStatement" !== n.body[0].type || "ArrowFunctionExpression" !== n.body[0].expression.type && "FunctionExpression" !== n.body[0].expression.type) throw new Error("Failed to resolve function");
  return n.body[0].expression.params.forEach(function (e) {
    o.push(e.name);
  }), t = n.body[0].expression.body.range, "BlockStatement" === n.body[0].expression.body.type ? new Function(o, r.slice(t[0] + 1, t[1] - 1)) : new Function(o, "return " + r.slice(t[0], t[1]));
}
function representJavascriptFunction(e) {
  return e.toString();
}
function isFunction$1(e) {
  return "[object Function]" === Object.prototype.toString.call(e);
}
var _function = new type("tag:yaml.org,2002:js/function", {
    kind: "scalar",
    resolve: resolveJavascriptFunction,
    construct: constructJavascriptFunction,
    predicate: isFunction$1,
    represent: representJavascriptFunction
  }),
  default_full = schema.DEFAULT = new schema({
    include: [default_safe],
    explicit: [_undefined, regexp, _function]
  }),
  _hasOwnProperty$2 = Object.prototype.hasOwnProperty,
  CONTEXT_FLOW_IN = 1,
  CONTEXT_FLOW_OUT = 2,
  CONTEXT_BLOCK_IN = 3,
  CONTEXT_BLOCK_OUT = 4,
  CHOMPING_CLIP = 1,
  CHOMPING_STRIP = 2,
  CHOMPING_KEEP = 3,
  PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,
  PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/,
  PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/,
  PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i,
  PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function _class(e) {
  return Object.prototype.toString.call(e);
}
function is_EOL(e) {
  return 10 === e || 13 === e;
}
function is_WHITE_SPACE(e) {
  return 9 === e || 32 === e;
}
function is_WS_OR_EOL(e) {
  return 9 === e || 32 === e || 10 === e || 13 === e;
}
function is_FLOW_INDICATOR(e) {
  return 44 === e || 91 === e || 93 === e || 123 === e || 125 === e;
}
function fromHexCode(e) {
  var t;
  return 48 <= e && e <= 57 ? e - 48 : 97 <= (t = 32 | e) && t <= 102 ? t - 97 + 10 : -1;
}
function escapedHexLen(e) {
  return 120 === e ? 2 : 117 === e ? 4 : 85 === e ? 8 : 0;
}
function fromDecimalCode(e) {
  return 48 <= e && e <= 57 ? e - 48 : -1;
}
function simpleEscapeSequence(e) {
  return 48 === e ? "\0" : 97 === e ? "" : 98 === e ? "\b" : 116 === e || 9 === e ? "\t" : 110 === e ? "\n" : 118 === e ? "\v" : 102 === e ? "\f" : 114 === e ? "\r" : 101 === e ? "" : 32 === e ? " " : 34 === e ? '"' : 47 === e ? "/" : 92 === e ? "\\" : 78 === e ? "" : 95 === e ? " " : 76 === e ? "\u2028" : 80 === e ? "\u2029" : "";
}
function charFromCodepoint(e) {
  return e <= 65535 ? String.fromCharCode(e) : String.fromCharCode(55296 + (e - 65536 >> 10), 56320 + (e - 65536 & 1023));
}
for (var simpleEscapeCheck = new Array(256), simpleEscapeMap = new Array(256), i = 0; i < 256; i++) simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0, simpleEscapeMap[i] = simpleEscapeSequence(i);
function State(e, t) {
  this.input = e, this.filename = t.filename || null, this.schema = t.schema || default_full, this.onWarning = t.onWarning || null, this.legacy = t.legacy || !1, this.json = t.json || !1, this.listener = t.listener || null, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = e.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.documents = [];
}
function generateError(e, t) {
  return new exception(t, new mark(e.filename, e.input, e.position, e.line, e.position - e.lineStart));
}
function throwError(e, t) {
  throw generateError(e, t);
}
function throwWarning(e, t) {
  e.onWarning && e.onWarning.call(null, generateError(e, t));
}
var directiveHandlers = {
  YAML: function (e, t, r) {
    var n, o, a;
    null !== e.version && throwError(e, "duplication of %YAML directive"), 1 !== r.length && throwError(e, "YAML directive accepts exactly one argument"), null === (n = /^([0-9]+)\.([0-9]+)$/.exec(r[0])) && throwError(e, "ill-formed argument of the YAML directive"), o = parseInt(n[1], 10), a = parseInt(n[2], 10), 1 !== o && throwError(e, "unacceptable YAML version of the document"), e.version = r[0], e.checkLineBreaks = a < 2, 1 !== a && 2 !== a && throwWarning(e, "unsupported YAML version of the document");
  },
  TAG: function (e, t, r) {
    var n, o;
    2 !== r.length && throwError(e, "TAG directive accepts exactly two arguments"), n = r[0], o = r[1], PATTERN_TAG_HANDLE.test(n) || throwError(e, "ill-formed tag handle (first argument) of the TAG directive"), _hasOwnProperty$2.call(e.tagMap, n) && throwError(e, 'there is a previously declared suffix for "' + n + '" tag handle'), PATTERN_TAG_URI.test(o) || throwError(e, "ill-formed tag prefix (second argument) of the TAG directive"), e.tagMap[n] = o;
  }
};
function captureSegment(e, t, r, n) {
  var o, a, i, s;
  if (t < r) {
    if (s = e.input.slice(t, r), n) for (o = 0, a = s.length; o < a; o += 1) 9 === (i = s.charCodeAt(o)) || 32 <= i && i <= 1114111 || throwError(e, "expected valid JSON character");else PATTERN_NON_PRINTABLE.test(s) && throwError(e, "the stream contains non-printable characters");
    e.result += s;
  }
}
function mergeMappings(e, t, r, n) {
  var o, a, i, s;
  for (common.isObject(r) || throwError(e, "cannot merge mappings; the provided source object is unacceptable"), i = 0, s = (o = Object.keys(r)).length; i < s; i += 1) a = o[i], _hasOwnProperty$2.call(t, a) || (t[a] = r[a], n[a] = !0);
}
function storeMappingPair(e, t, r, n, o, a, i, s) {
  var c, u;
  if (Array.isArray(o)) for (c = 0, u = (o = Array.prototype.slice.call(o)).length; c < u; c += 1) Array.isArray(o[c]) && throwError(e, "nested arrays are not supported inside keys"), "object" == typeof o && "[object Object]" === _class(o[c]) && (o[c] = "[object Object]");
  if ("object" == typeof o && "[object Object]" === _class(o) && (o = "[object Object]"), o = String(o), null === t && (t = {}), "tag:yaml.org,2002:merge" === n) {
    if (Array.isArray(a)) for (c = 0, u = a.length; c < u; c += 1) mergeMappings(e, t, a[c], r);else mergeMappings(e, t, a, r);
  } else e.json || _hasOwnProperty$2.call(r, o) || !_hasOwnProperty$2.call(t, o) || (e.line = i || e.line, e.position = s || e.position, throwError(e, "duplicated mapping key")), t[o] = a, delete r[o];
  return t;
}
function readLineBreak(e) {
  var t;
  10 === (t = e.input.charCodeAt(e.position)) ? e.position++ : 13 === t ? (e.position++, 10 === e.input.charCodeAt(e.position) && e.position++) : throwError(e, "a line break is expected"), e.line += 1, e.lineStart = e.position;
}
function skipSeparationSpace(e, t, r) {
  for (var n = 0, o = e.input.charCodeAt(e.position); 0 !== o;) {
    for (; is_WHITE_SPACE(o);) o = e.input.charCodeAt(++e.position);
    if (t && 35 === o) do {
      o = e.input.charCodeAt(++e.position);
    } while (10 !== o && 13 !== o && 0 !== o);
    if (!is_EOL(o)) break;
    for (readLineBreak(e), o = e.input.charCodeAt(e.position), n++, e.lineIndent = 0; 32 === o;) e.lineIndent++, o = e.input.charCodeAt(++e.position);
  }
  return -1 !== r && 0 !== n && e.lineIndent < r && throwWarning(e, "deficient indentation"), n;
}
function testDocumentSeparator(e) {
  var t,
    r = e.position;
  return !(45 !== (t = e.input.charCodeAt(r)) && 46 !== t || t !== e.input.charCodeAt(r + 1) || t !== e.input.charCodeAt(r + 2) || (r += 3, 0 !== (t = e.input.charCodeAt(r)) && !is_WS_OR_EOL(t)));
}
function writeFoldedLines(e, t) {
  1 === t ? e.result += " " : t > 1 && (e.result += common.repeat("\n", t - 1));
}
function readPlainScalar(e, t, r) {
  var n,
    o,
    a,
    i,
    s,
    c,
    u,
    l,
    f = e.kind,
    p = e.result;
  if (is_WS_OR_EOL(l = e.input.charCodeAt(e.position)) || is_FLOW_INDICATOR(l) || 35 === l || 38 === l || 42 === l || 33 === l || 124 === l || 62 === l || 39 === l || 34 === l || 37 === l || 64 === l || 96 === l) return !1;
  if ((63 === l || 45 === l) && (is_WS_OR_EOL(n = e.input.charCodeAt(e.position + 1)) || r && is_FLOW_INDICATOR(n))) return !1;
  for (e.kind = "scalar", e.result = "", o = a = e.position, i = !1; 0 !== l;) {
    if (58 === l) {
      if (is_WS_OR_EOL(n = e.input.charCodeAt(e.position + 1)) || r && is_FLOW_INDICATOR(n)) break;
    } else if (35 === l) {
      if (is_WS_OR_EOL(e.input.charCodeAt(e.position - 1))) break;
    } else {
      if (e.position === e.lineStart && testDocumentSeparator(e) || r && is_FLOW_INDICATOR(l)) break;
      if (is_EOL(l)) {
        if (s = e.line, c = e.lineStart, u = e.lineIndent, skipSeparationSpace(e, !1, -1), e.lineIndent >= t) {
          i = !0, l = e.input.charCodeAt(e.position);
          continue;
        }
        e.position = a, e.line = s, e.lineStart = c, e.lineIndent = u;
        break;
      }
    }
    i && (captureSegment(e, o, a, !1), writeFoldedLines(e, e.line - s), o = a = e.position, i = !1), is_WHITE_SPACE(l) || (a = e.position + 1), l = e.input.charCodeAt(++e.position);
  }
  return captureSegment(e, o, a, !1), !!e.result || (e.kind = f, e.result = p, !1);
}
function readSingleQuotedScalar(e, t) {
  var r, n, o;
  if (39 !== (r = e.input.charCodeAt(e.position))) return !1;
  for (e.kind = "scalar", e.result = "", e.position++, n = o = e.position; 0 !== (r = e.input.charCodeAt(e.position));) if (39 === r) {
    if (captureSegment(e, n, e.position, !0), 39 !== (r = e.input.charCodeAt(++e.position))) return !0;
    n = e.position, e.position++, o = e.position;
  } else is_EOL(r) ? (captureSegment(e, n, o, !0), writeFoldedLines(e, skipSeparationSpace(e, !1, t)), n = o = e.position) : e.position === e.lineStart && testDocumentSeparator(e) ? throwError(e, "unexpected end of the document within a single quoted scalar") : (e.position++, o = e.position);
  throwError(e, "unexpected end of the stream within a single quoted scalar");
}
function readDoubleQuotedScalar(e, t) {
  var r, n, o, a, i, s;
  if (34 !== (s = e.input.charCodeAt(e.position))) return !1;
  for (e.kind = "scalar", e.result = "", e.position++, r = n = e.position; 0 !== (s = e.input.charCodeAt(e.position));) {
    if (34 === s) return captureSegment(e, r, e.position, !0), e.position++, !0;
    if (92 === s) {
      if (captureSegment(e, r, e.position, !0), is_EOL(s = e.input.charCodeAt(++e.position))) skipSeparationSpace(e, !1, t);else if (s < 256 && simpleEscapeCheck[s]) e.result += simpleEscapeMap[s], e.position++;else if ((i = escapedHexLen(s)) > 0) {
        for (o = i, a = 0; o > 0; o--) (i = fromHexCode(s = e.input.charCodeAt(++e.position))) >= 0 ? a = (a << 4) + i : throwError(e, "expected hexadecimal character");
        e.result += charFromCodepoint(a), e.position++;
      } else throwError(e, "unknown escape sequence");
      r = n = e.position;
    } else is_EOL(s) ? (captureSegment(e, r, n, !0), writeFoldedLines(e, skipSeparationSpace(e, !1, t)), r = n = e.position) : e.position === e.lineStart && testDocumentSeparator(e) ? throwError(e, "unexpected end of the document within a double quoted scalar") : (e.position++, n = e.position);
  }
  throwError(e, "unexpected end of the stream within a double quoted scalar");
}
function readFlowCollection(e, t) {
  var r,
    n,
    o,
    a,
    i,
    s,
    c,
    u,
    l,
    f,
    p = !0,
    h = e.tag,
    y = e.anchor,
    d = {};
  if (91 === (f = e.input.charCodeAt(e.position))) o = 93, s = !1, n = [];else {
    if (123 !== f) return !1;
    o = 125, s = !0, n = {};
  }
  for (null !== e.anchor && (e.anchorMap[e.anchor] = n), f = e.input.charCodeAt(++e.position); 0 !== f;) {
    if (skipSeparationSpace(e, !0, t), (f = e.input.charCodeAt(e.position)) === o) return e.position++, e.tag = h, e.anchor = y, e.kind = s ? "mapping" : "sequence", e.result = n, !0;
    p || throwError(e, "missed comma between flow collection entries"), l = null, a = i = !1, 63 === f && is_WS_OR_EOL(e.input.charCodeAt(e.position + 1)) && (a = i = !0, e.position++, skipSeparationSpace(e, !0, t)), r = e.line, composeNode(e, t, CONTEXT_FLOW_IN, !1, !0), u = e.tag, c = e.result, skipSeparationSpace(e, !0, t), f = e.input.charCodeAt(e.position), !i && e.line !== r || 58 !== f || (a = !0, f = e.input.charCodeAt(++e.position), skipSeparationSpace(e, !0, t), composeNode(e, t, CONTEXT_FLOW_IN, !1, !0), l = e.result), s ? storeMappingPair(e, n, d, u, c, l) : a ? n.push(storeMappingPair(e, null, d, u, c, l)) : n.push(c), skipSeparationSpace(e, !0, t), 44 === (f = e.input.charCodeAt(e.position)) ? (p = !0, f = e.input.charCodeAt(++e.position)) : p = !1;
  }
  throwError(e, "unexpected end of the stream within a flow collection");
}
function readBlockScalar(e, t) {
  var r,
    n,
    o,
    a,
    i = CHOMPING_CLIP,
    s = !1,
    c = !1,
    u = t,
    l = 0,
    f = !1;
  if (124 === (a = e.input.charCodeAt(e.position))) n = !1;else {
    if (62 !== a) return !1;
    n = !0;
  }
  for (e.kind = "scalar", e.result = ""; 0 !== a;) if (43 === (a = e.input.charCodeAt(++e.position)) || 45 === a) CHOMPING_CLIP === i ? i = 43 === a ? CHOMPING_KEEP : CHOMPING_STRIP : throwError(e, "repeat of a chomping mode identifier");else {
    if (!((o = fromDecimalCode(a)) >= 0)) break;
    0 === o ? throwError(e, "bad explicit indentation width of a block scalar; it cannot be less than one") : c ? throwError(e, "repeat of an indentation width identifier") : (u = t + o - 1, c = !0);
  }
  if (is_WHITE_SPACE(a)) {
    do {
      a = e.input.charCodeAt(++e.position);
    } while (is_WHITE_SPACE(a));
    if (35 === a) do {
      a = e.input.charCodeAt(++e.position);
    } while (!is_EOL(a) && 0 !== a);
  }
  for (; 0 !== a;) {
    for (readLineBreak(e), e.lineIndent = 0, a = e.input.charCodeAt(e.position); (!c || e.lineIndent < u) && 32 === a;) e.lineIndent++, a = e.input.charCodeAt(++e.position);
    if (!c && e.lineIndent > u && (u = e.lineIndent), is_EOL(a)) l++;else {
      if (e.lineIndent < u) {
        i === CHOMPING_KEEP ? e.result += common.repeat("\n", s ? 1 + l : l) : i === CHOMPING_CLIP && s && (e.result += "\n");
        break;
      }
      for (n ? is_WHITE_SPACE(a) ? (f = !0, e.result += common.repeat("\n", s ? 1 + l : l)) : f ? (f = !1, e.result += common.repeat("\n", l + 1)) : 0 === l ? s && (e.result += " ") : e.result += common.repeat("\n", l) : e.result += common.repeat("\n", s ? 1 + l : l), s = !0, c = !0, l = 0, r = e.position; !is_EOL(a) && 0 !== a;) a = e.input.charCodeAt(++e.position);
      captureSegment(e, r, e.position, !1);
    }
  }
  return !0;
}
function readBlockSequence(e, t) {
  var r,
    n,
    o = e.tag,
    a = e.anchor,
    i = [],
    s = !1;
  for (null !== e.anchor && (e.anchorMap[e.anchor] = i), n = e.input.charCodeAt(e.position); 0 !== n && 45 === n && is_WS_OR_EOL(e.input.charCodeAt(e.position + 1));) if (s = !0, e.position++, skipSeparationSpace(e, !0, -1) && e.lineIndent <= t) i.push(null), n = e.input.charCodeAt(e.position);else if (r = e.line, composeNode(e, t, CONTEXT_BLOCK_IN, !1, !0), i.push(e.result), skipSeparationSpace(e, !0, -1), n = e.input.charCodeAt(e.position), (e.line === r || e.lineIndent > t) && 0 !== n) throwError(e, "bad indentation of a sequence entry");else if (e.lineIndent < t) break;
  return !!s && (e.tag = o, e.anchor = a, e.kind = "sequence", e.result = i, !0);
}
function readBlockMapping(e, t, r) {
  var n,
    o,
    a,
    i,
    s,
    c = e.tag,
    u = e.anchor,
    l = {},
    f = {},
    p = null,
    h = null,
    y = null,
    d = !1,
    g = !1;
  for (null !== e.anchor && (e.anchorMap[e.anchor] = l), s = e.input.charCodeAt(e.position); 0 !== s;) {
    if (n = e.input.charCodeAt(e.position + 1), a = e.line, i = e.position, 63 !== s && 58 !== s || !is_WS_OR_EOL(n)) {
      if (!composeNode(e, r, CONTEXT_FLOW_OUT, !1, !0)) break;
      if (e.line === a) {
        for (s = e.input.charCodeAt(e.position); is_WHITE_SPACE(s);) s = e.input.charCodeAt(++e.position);
        if (58 === s) is_WS_OR_EOL(s = e.input.charCodeAt(++e.position)) || throwError(e, "a whitespace character is expected after the key-value separator within a block mapping"), d && (storeMappingPair(e, l, f, p, h, null), p = h = y = null), g = !0, d = !1, o = !1, p = e.tag, h = e.result;else {
          if (!g) return e.tag = c, e.anchor = u, !0;
          throwError(e, "can not read an implicit mapping pair; a colon is missed");
        }
      } else {
        if (!g) return e.tag = c, e.anchor = u, !0;
        throwError(e, "can not read a block mapping entry; a multiline key may not be an implicit key");
      }
    } else 63 === s ? (d && (storeMappingPair(e, l, f, p, h, null), p = h = y = null), g = !0, d = !0, o = !0) : d ? (d = !1, o = !0) : throwError(e, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), e.position += 1, s = n;
    if ((e.line === a || e.lineIndent > t) && (composeNode(e, t, CONTEXT_BLOCK_OUT, !0, o) && (d ? h = e.result : y = e.result), d || (storeMappingPair(e, l, f, p, h, y, a, i), p = h = y = null), skipSeparationSpace(e, !0, -1), s = e.input.charCodeAt(e.position)), e.lineIndent > t && 0 !== s) throwError(e, "bad indentation of a mapping entry");else if (e.lineIndent < t) break;
  }
  return d && storeMappingPair(e, l, f, p, h, null), g && (e.tag = c, e.anchor = u, e.kind = "mapping", e.result = l), g;
}
function readTagProperty(e) {
  var t,
    r,
    n,
    o,
    a = !1,
    i = !1;
  if (33 !== (o = e.input.charCodeAt(e.position))) return !1;
  if (null !== e.tag && throwError(e, "duplication of a tag property"), 60 === (o = e.input.charCodeAt(++e.position)) ? (a = !0, o = e.input.charCodeAt(++e.position)) : 33 === o ? (i = !0, r = "!!", o = e.input.charCodeAt(++e.position)) : r = "!", t = e.position, a) {
    do {
      o = e.input.charCodeAt(++e.position);
    } while (0 !== o && 62 !== o);
    e.position < e.length ? (n = e.input.slice(t, e.position), o = e.input.charCodeAt(++e.position)) : throwError(e, "unexpected end of the stream within a verbatim tag");
  } else {
    for (; 0 !== o && !is_WS_OR_EOL(o);) 33 === o && (i ? throwError(e, "tag suffix cannot contain exclamation marks") : (r = e.input.slice(t - 1, e.position + 1), PATTERN_TAG_HANDLE.test(r) || throwError(e, "named tag handle cannot contain such characters"), i = !0, t = e.position + 1)), o = e.input.charCodeAt(++e.position);
    n = e.input.slice(t, e.position), PATTERN_FLOW_INDICATORS.test(n) && throwError(e, "tag suffix cannot contain flow indicator characters");
  }
  return n && !PATTERN_TAG_URI.test(n) && throwError(e, "tag name cannot contain such characters: " + n), a ? e.tag = n : _hasOwnProperty$2.call(e.tagMap, r) ? e.tag = e.tagMap[r] + n : "!" === r ? e.tag = "!" + n : "!!" === r ? e.tag = "tag:yaml.org,2002:" + n : throwError(e, 'undeclared tag handle "' + r + '"'), !0;
}
function readAnchorProperty(e) {
  var t, r;
  if (38 !== (r = e.input.charCodeAt(e.position))) return !1;
  for (null !== e.anchor && throwError(e, "duplication of an anchor property"), r = e.input.charCodeAt(++e.position), t = e.position; 0 !== r && !is_WS_OR_EOL(r) && !is_FLOW_INDICATOR(r);) r = e.input.charCodeAt(++e.position);
  return e.position === t && throwError(e, "name of an anchor node must contain at least one character"), e.anchor = e.input.slice(t, e.position), !0;
}
function readAlias(e) {
  var t, r, n;
  if (42 !== (n = e.input.charCodeAt(e.position))) return !1;
  for (n = e.input.charCodeAt(++e.position), t = e.position; 0 !== n && !is_WS_OR_EOL(n) && !is_FLOW_INDICATOR(n);) n = e.input.charCodeAt(++e.position);
  return e.position === t && throwError(e, "name of an alias node must contain at least one character"), r = e.input.slice(t, e.position), _hasOwnProperty$2.call(e.anchorMap, r) || throwError(e, 'unidentified alias "' + r + '"'), e.result = e.anchorMap[r], skipSeparationSpace(e, !0, -1), !0;
}
function composeNode(e, t, r, n, o) {
  var a,
    i,
    s,
    c,
    u,
    l,
    f,
    p,
    h = 1,
    y = !1,
    d = !1;
  if (null !== e.listener && e.listener("open", e), e.tag = null, e.anchor = null, e.kind = null, e.result = null, a = i = s = CONTEXT_BLOCK_OUT === r || CONTEXT_BLOCK_IN === r, n && skipSeparationSpace(e, !0, -1) && (y = !0, e.lineIndent > t ? h = 1 : e.lineIndent === t ? h = 0 : e.lineIndent < t && (h = -1)), 1 === h) for (; readTagProperty(e) || readAnchorProperty(e);) skipSeparationSpace(e, !0, -1) ? (y = !0, s = a, e.lineIndent > t ? h = 1 : e.lineIndent === t ? h = 0 : e.lineIndent < t && (h = -1)) : s = !1;
  if (s && (s = y || o), 1 !== h && CONTEXT_BLOCK_OUT !== r || (f = CONTEXT_FLOW_IN === r || CONTEXT_FLOW_OUT === r ? t : t + 1, p = e.position - e.lineStart, 1 === h ? s && (readBlockSequence(e, p) || readBlockMapping(e, p, f)) || readFlowCollection(e, f) ? d = !0 : (i && readBlockScalar(e, f) || readSingleQuotedScalar(e, f) || readDoubleQuotedScalar(e, f) ? d = !0 : readAlias(e) ? (d = !0, null === e.tag && null === e.anchor || throwError(e, "alias node should not have any properties")) : readPlainScalar(e, f, CONTEXT_FLOW_IN === r) && (d = !0, null === e.tag && (e.tag = "?")), null !== e.anchor && (e.anchorMap[e.anchor] = e.result)) : 0 === h && (d = s && readBlockSequence(e, p))), null !== e.tag && "!" !== e.tag) if ("?" === e.tag) {
    for (null !== e.result && "scalar" !== e.kind && throwError(e, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + e.kind + '"'), c = 0, u = e.implicitTypes.length; c < u; c += 1) if ((l = e.implicitTypes[c]).resolve(e.result)) {
      e.result = l.construct(e.result), e.tag = l.tag, null !== e.anchor && (e.anchorMap[e.anchor] = e.result);
      break;
    }
  } else _hasOwnProperty$2.call(e.typeMap[e.kind || "fallback"], e.tag) ? (l = e.typeMap[e.kind || "fallback"][e.tag], null !== e.result && l.kind !== e.kind && throwError(e, "unacceptable node kind for !<" + e.tag + '> tag; it should be "' + l.kind + '", not "' + e.kind + '"'), l.resolve(e.result) ? (e.result = l.construct(e.result), null !== e.anchor && (e.anchorMap[e.anchor] = e.result)) : throwError(e, "cannot resolve a node with !<" + e.tag + "> explicit tag")) : throwError(e, "unknown tag !<" + e.tag + ">");
  return null !== e.listener && e.listener("close", e), null !== e.tag || null !== e.anchor || d;
}
function readDocument(e) {
  var t,
    r,
    n,
    o,
    a = e.position,
    i = !1;
  for (e.version = null, e.checkLineBreaks = e.legacy, e.tagMap = {}, e.anchorMap = {}; 0 !== (o = e.input.charCodeAt(e.position)) && (skipSeparationSpace(e, !0, -1), o = e.input.charCodeAt(e.position), !(e.lineIndent > 0 || 37 !== o));) {
    for (i = !0, o = e.input.charCodeAt(++e.position), t = e.position; 0 !== o && !is_WS_OR_EOL(o);) o = e.input.charCodeAt(++e.position);
    for (n = [], (r = e.input.slice(t, e.position)).length < 1 && throwError(e, "directive name must not be less than one character in length"); 0 !== o;) {
      for (; is_WHITE_SPACE(o);) o = e.input.charCodeAt(++e.position);
      if (35 === o) {
        do {
          o = e.input.charCodeAt(++e.position);
        } while (0 !== o && !is_EOL(o));
        break;
      }
      if (is_EOL(o)) break;
      for (t = e.position; 0 !== o && !is_WS_OR_EOL(o);) o = e.input.charCodeAt(++e.position);
      n.push(e.input.slice(t, e.position));
    }
    0 !== o && readLineBreak(e), _hasOwnProperty$2.call(directiveHandlers, r) ? directiveHandlers[r](e, r, n) : throwWarning(e, 'unknown document directive "' + r + '"');
  }
  skipSeparationSpace(e, !0, -1), 0 === e.lineIndent && 45 === e.input.charCodeAt(e.position) && 45 === e.input.charCodeAt(e.position + 1) && 45 === e.input.charCodeAt(e.position + 2) ? (e.position += 3, skipSeparationSpace(e, !0, -1)) : i && throwError(e, "directives end mark is expected"), composeNode(e, e.lineIndent - 1, CONTEXT_BLOCK_OUT, !1, !0), skipSeparationSpace(e, !0, -1), e.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(e.input.slice(a, e.position)) && throwWarning(e, "non-ASCII line breaks are interpreted as content"), e.documents.push(e.result), e.position === e.lineStart && testDocumentSeparator(e) ? 46 === e.input.charCodeAt(e.position) && (e.position += 3, skipSeparationSpace(e, !0, -1)) : e.position < e.length - 1 && throwError(e, "end of the stream or a document separator is expected");
}
function loadDocuments(e, t) {
  t = t || {}, 0 !== (e = String(e)).length && (10 !== e.charCodeAt(e.length - 1) && 13 !== e.charCodeAt(e.length - 1) && (e += "\n"), 65279 === e.charCodeAt(0) && (e = e.slice(1)));
  var r = new State(e, t),
    n = e.indexOf("\0");
  for (-1 !== n && (r.position = n, throwError(r, "null byte is not allowed in input")), r.input += "\0"; 32 === r.input.charCodeAt(r.position);) r.lineIndent += 1, r.position += 1;
  for (; r.position < r.length - 1;) readDocument(r);
  return r.documents;
}
function loadAll(e, t, r) {
  null !== t && "object" == typeof t && void 0 === r && (r = t, t = null);
  var n = loadDocuments(e, r);
  if ("function" != typeof t) return n;
  for (var o = 0, a = n.length; o < a; o += 1) t(n[o]);
}
function load(e, t) {
  var r = loadDocuments(e, t);
  if (0 !== r.length) {
    if (1 === r.length) return r[0];
    throw new exception("expected a single document in the stream, but found more");
  }
}
function safeLoadAll(e, t, r) {
  return "object" == typeof t && null !== t && void 0 === r && (r = t, t = null), loadAll(e, t, common.extend({
    schema: default_safe
  }, r));
}
function safeLoad(e, t) {
  return load(e, common.extend({
    schema: default_safe
  }, t));
}
var loadAll_1 = loadAll,
  load_1 = load,
  safeLoadAll_1 = safeLoadAll,
  safeLoad_1 = safeLoad,
  loader = {
    loadAll: loadAll_1,
    load: load_1,
    safeLoadAll: safeLoadAll_1,
    safeLoad: safeLoad_1
  },
  _toString$2 = Object.prototype.toString,
  _hasOwnProperty$3 = Object.prototype.hasOwnProperty,
  CHAR_TAB = 9,
  CHAR_LINE_FEED = 10,
  CHAR_CARRIAGE_RETURN = 13,
  CHAR_SPACE = 32,
  CHAR_EXCLAMATION = 33,
  CHAR_DOUBLE_QUOTE = 34,
  CHAR_SHARP = 35,
  CHAR_PERCENT = 37,
  CHAR_AMPERSAND = 38,
  CHAR_SINGLE_QUOTE = 39,
  CHAR_ASTERISK = 42,
  CHAR_COMMA = 44,
  CHAR_MINUS = 45,
  CHAR_COLON = 58,
  CHAR_EQUALS = 61,
  CHAR_GREATER_THAN = 62,
  CHAR_QUESTION = 63,
  CHAR_COMMERCIAL_AT = 64,
  CHAR_LEFT_SQUARE_BRACKET = 91,
  CHAR_RIGHT_SQUARE_BRACKET = 93,
  CHAR_GRAVE_ACCENT = 96,
  CHAR_LEFT_CURLY_BRACKET = 123,
  CHAR_VERTICAL_LINE = 124,
  CHAR_RIGHT_CURLY_BRACKET = 125,
  ESCAPE_SEQUENCES = {
    0: "\\0",
    7: "\\a",
    8: "\\b",
    9: "\\t",
    10: "\\n",
    11: "\\v",
    12: "\\f",
    13: "\\r",
    27: "\\e",
    34: '\\"',
    92: "\\\\",
    133: "\\N",
    160: "\\_",
    8232: "\\L",
    8233: "\\P"
  },
  DEPRECATED_BOOLEANS_SYNTAX = ["y", "Y", "yes", "Yes", "YES", "on", "On", "ON", "n", "N", "no", "No", "NO", "off", "Off", "OFF"];
function compileStyleMap(e, t) {
  var r, n, o, a, i, s, c;
  if (null === t) return {};
  for (r = {}, o = 0, a = (n = Object.keys(t)).length; o < a; o += 1) i = n[o], s = String(t[i]), "!!" === i.slice(0, 2) && (i = "tag:yaml.org,2002:" + i.slice(2)), (c = e.compiledTypeMap.fallback[i]) && _hasOwnProperty$3.call(c.styleAliases, s) && (s = c.styleAliases[s]), r[i] = s;
  return r;
}
function encodeHex(e) {
  var t, r, n;
  if (t = e.toString(16).toUpperCase(), e <= 255) r = "x", n = 2;else if (e <= 65535) r = "u", n = 4;else {
    if (!(e <= 4294967295)) throw new exception("code point within a string may not be greater than 0xFFFFFFFF");
    r = "U", n = 8;
  }
  return "\\" + r + common.repeat("0", n - t.length) + t;
}
function State$1(e) {
  this.schema = e.schema || default_full, this.indent = Math.max(1, e.indent || 2), this.noArrayIndent = e.noArrayIndent || !1, this.skipInvalid = e.skipInvalid || !1, this.flowLevel = common.isNothing(e.flowLevel) ? -1 : e.flowLevel, this.styleMap = compileStyleMap(this.schema, e.styles || null), this.sortKeys = e.sortKeys || !1, this.lineWidth = e.lineWidth || 80, this.noRefs = e.noRefs || !1, this.noCompatMode = e.noCompatMode || !1, this.condenseFlow = e.condenseFlow || !1, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
}
function indentString(e, t) {
  for (var r, n = common.repeat(" ", t), o = 0, a = -1, i = "", s = e.length; o < s;) -1 === (a = e.indexOf("\n", o)) ? (r = e.slice(o), o = s) : (r = e.slice(o, a + 1), o = a + 1), r.length && "\n" !== r && (i += n), i += r;
  return i;
}
function generateNextLine(e, t) {
  return "\n" + common.repeat(" ", e.indent * t);
}
function testImplicitResolving(e, t) {
  var r, n;
  for (r = 0, n = e.implicitTypes.length; r < n; r += 1) if (e.implicitTypes[r].resolve(t)) return !0;
  return !1;
}
function isWhitespace(e) {
  return e === CHAR_SPACE || e === CHAR_TAB;
}
function isPrintable(e) {
  return 32 <= e && e <= 126 || 161 <= e && e <= 55295 && 8232 !== e && 8233 !== e || 57344 <= e && e <= 65533 && 65279 !== e || 65536 <= e && e <= 1114111;
}
function isNsChar(e) {
  return isPrintable(e) && !isWhitespace(e) && 65279 !== e && e !== CHAR_CARRIAGE_RETURN && e !== CHAR_LINE_FEED;
}
function isPlainSafe(e, t) {
  return isPrintable(e) && 65279 !== e && e !== CHAR_COMMA && e !== CHAR_LEFT_SQUARE_BRACKET && e !== CHAR_RIGHT_SQUARE_BRACKET && e !== CHAR_LEFT_CURLY_BRACKET && e !== CHAR_RIGHT_CURLY_BRACKET && e !== CHAR_COLON && (e !== CHAR_SHARP || t && isNsChar(t));
}
function isPlainSafeFirst(e) {
  return isPrintable(e) && 65279 !== e && !isWhitespace(e) && e !== CHAR_MINUS && e !== CHAR_QUESTION && e !== CHAR_COLON && e !== CHAR_COMMA && e !== CHAR_LEFT_SQUARE_BRACKET && e !== CHAR_RIGHT_SQUARE_BRACKET && e !== CHAR_LEFT_CURLY_BRACKET && e !== CHAR_RIGHT_CURLY_BRACKET && e !== CHAR_SHARP && e !== CHAR_AMPERSAND && e !== CHAR_ASTERISK && e !== CHAR_EXCLAMATION && e !== CHAR_VERTICAL_LINE && e !== CHAR_EQUALS && e !== CHAR_GREATER_THAN && e !== CHAR_SINGLE_QUOTE && e !== CHAR_DOUBLE_QUOTE && e !== CHAR_PERCENT && e !== CHAR_COMMERCIAL_AT && e !== CHAR_GRAVE_ACCENT;
}
function needIndentIndicator(e) {
  return /^\n* /.test(e);
}
var STYLE_PLAIN = 1,
  STYLE_SINGLE = 2,
  STYLE_LITERAL = 3,
  STYLE_FOLDED = 4,
  STYLE_DOUBLE = 5;
function chooseScalarStyle(e, t, r, n, o) {
  var a,
    i,
    s,
    c = !1,
    u = !1,
    l = -1 !== n,
    f = -1,
    p = isPlainSafeFirst(e.charCodeAt(0)) && !isWhitespace(e.charCodeAt(e.length - 1));
  if (t) for (a = 0; a < e.length; a++) {
    if (!isPrintable(i = e.charCodeAt(a))) return STYLE_DOUBLE;
    s = a > 0 ? e.charCodeAt(a - 1) : null, p = p && isPlainSafe(i, s);
  } else {
    for (a = 0; a < e.length; a++) {
      if ((i = e.charCodeAt(a)) === CHAR_LINE_FEED) c = !0, l && (u = u || a - f - 1 > n && " " !== e[f + 1], f = a);else if (!isPrintable(i)) return STYLE_DOUBLE;
      s = a > 0 ? e.charCodeAt(a - 1) : null, p = p && isPlainSafe(i, s);
    }
    u = u || l && a - f - 1 > n && " " !== e[f + 1];
  }
  return c || u ? r > 9 && needIndentIndicator(e) ? STYLE_DOUBLE : u ? STYLE_FOLDED : STYLE_LITERAL : p && !o(e) ? STYLE_PLAIN : STYLE_SINGLE;
}
function writeScalar(e, t, r, n) {
  e.dump = function () {
    if (0 === t.length) return "''";
    if (!e.noCompatMode && -1 !== DEPRECATED_BOOLEANS_SYNTAX.indexOf(t)) return "'" + t + "'";
    var o = e.indent * Math.max(1, r),
      a = -1 === e.lineWidth ? -1 : Math.max(Math.min(e.lineWidth, 40), e.lineWidth - o),
      i = n || e.flowLevel > -1 && r >= e.flowLevel;
    switch (chooseScalarStyle(t, i, e.indent, a, function (t) {
      return testImplicitResolving(e, t);
    })) {
      case STYLE_PLAIN:
        return t;
      case STYLE_SINGLE:
        return "'" + t.replace(/'/g, "''") + "'";
      case STYLE_LITERAL:
        return "|" + blockHeader(t, e.indent) + dropEndingNewline(indentString(t, o));
      case STYLE_FOLDED:
        return ">" + blockHeader(t, e.indent) + dropEndingNewline(indentString(foldString(t, a), o));
      case STYLE_DOUBLE:
        return '"' + escapeString(t) + '"';
      default:
        throw new exception("impossible error: invalid scalar style");
    }
  }();
}
function blockHeader(e, t) {
  var r = needIndentIndicator(e) ? String(t) : "",
    n = "\n" === e[e.length - 1];
  return r + (n && ("\n" === e[e.length - 2] || "\n" === e) ? "+" : n ? "" : "-") + "\n";
}
function dropEndingNewline(e) {
  return "\n" === e[e.length - 1] ? e.slice(0, -1) : e;
}
function foldString(e, t) {
  for (var r, n, o, a = /(\n+)([^\n]*)/g, i = (r = -1 !== (r = e.indexOf("\n")) ? r : e.length, a.lastIndex = r, foldLine(e.slice(0, r), t)), s = "\n" === e[0] || " " === e[0]; o = a.exec(e);) {
    var c = o[1],
      u = o[2];
    n = " " === u[0], i += c + (s || n || "" === u ? "" : "\n") + foldLine(u, t), s = n;
  }
  return i;
}
function foldLine(e, t) {
  if ("" === e || " " === e[0]) return e;
  for (var r, n, o = / [^ ]/g, a = 0, i = 0, s = 0, c = ""; r = o.exec(e);) (s = r.index) - a > t && (n = i > a ? i : s, c += "\n" + e.slice(a, n), a = n + 1), i = s;
  return c += "\n", e.length - a > t && i > a ? c += e.slice(a, i) + "\n" + e.slice(i + 1) : c += e.slice(a), c.slice(1);
}
function escapeString(e) {
  for (var t, r, n, o = "", a = 0; a < e.length; a++) (t = e.charCodeAt(a)) >= 55296 && t <= 56319 && (r = e.charCodeAt(a + 1)) >= 56320 && r <= 57343 ? (o += encodeHex(1024 * (t - 55296) + r - 56320 + 65536), a++) : o += !(n = ESCAPE_SEQUENCES[t]) && isPrintable(t) ? e[a] : n || encodeHex(t);
  return o;
}
function writeFlowSequence(e, t, r) {
  var n,
    o,
    a = "",
    i = e.tag;
  for (n = 0, o = r.length; n < o; n += 1) writeNode(e, t, r[n], !1, !1) && (0 !== n && (a += "," + (e.condenseFlow ? "" : " ")), a += e.dump);
  e.tag = i, e.dump = "[" + a + "]";
}
function writeBlockSequence(e, t, r, n) {
  var o,
    a,
    i = "",
    s = e.tag;
  for (o = 0, a = r.length; o < a; o += 1) writeNode(e, t + 1, r[o], !0, !0) && (n && 0 === o || (i += generateNextLine(e, t)), e.dump && CHAR_LINE_FEED === e.dump.charCodeAt(0) ? i += "-" : i += "- ", i += e.dump);
  e.tag = s, e.dump = i || "[]";
}
function writeFlowMapping(e, t, r) {
  var n,
    o,
    a,
    i,
    s,
    c = "",
    u = e.tag,
    l = Object.keys(r);
  for (n = 0, o = l.length; n < o; n += 1) s = "", 0 !== n && (s += ", "), e.condenseFlow && (s += '"'), i = r[a = l[n]], writeNode(e, t, a, !1, !1) && (e.dump.length > 1024 && (s += "? "), s += e.dump + (e.condenseFlow ? '"' : "") + ":" + (e.condenseFlow ? "" : " "), writeNode(e, t, i, !1, !1) && (c += s += e.dump));
  e.tag = u, e.dump = "{" + c + "}";
}
function writeBlockMapping(e, t, r, n) {
  var o,
    a,
    i,
    s,
    c,
    u,
    l = "",
    f = e.tag,
    p = Object.keys(r);
  if (!0 === e.sortKeys) p.sort();else if ("function" == typeof e.sortKeys) p.sort(e.sortKeys);else if (e.sortKeys) throw new exception("sortKeys must be a boolean or a function");
  for (o = 0, a = p.length; o < a; o += 1) u = "", n && 0 === o || (u += generateNextLine(e, t)), s = r[i = p[o]], writeNode(e, t + 1, i, !0, !0, !0) && ((c = null !== e.tag && "?" !== e.tag || e.dump && e.dump.length > 1024) && (e.dump && CHAR_LINE_FEED === e.dump.charCodeAt(0) ? u += "?" : u += "? "), u += e.dump, c && (u += generateNextLine(e, t)), writeNode(e, t + 1, s, !0, c) && (e.dump && CHAR_LINE_FEED === e.dump.charCodeAt(0) ? u += ":" : u += ": ", l += u += e.dump));
  e.tag = f, e.dump = l || "{}";
}
function detectType(e, t, r) {
  var n, o, a, i, s, c;
  for (a = 0, i = (o = r ? e.explicitTypes : e.implicitTypes).length; a < i; a += 1) if (((s = o[a]).instanceOf || s.predicate) && (!s.instanceOf || "object" == typeof t && t instanceof s.instanceOf) && (!s.predicate || s.predicate(t))) {
    if (e.tag = r ? s.tag : "?", s.represent) {
      if (c = e.styleMap[s.tag] || s.defaultStyle, "[object Function]" === _toString$2.call(s.represent)) n = s.represent(t, c);else {
        if (!_hasOwnProperty$3.call(s.represent, c)) throw new exception("!<" + s.tag + '> tag resolver accepts not "' + c + '" style');
        n = s.represent[c](t, c);
      }
      e.dump = n;
    }
    return !0;
  }
  return !1;
}
function writeNode(e, t, r, n, o, a) {
  e.tag = null, e.dump = r, detectType(e, r, !1) || detectType(e, r, !0);
  var i = _toString$2.call(e.dump);
  n && (n = e.flowLevel < 0 || e.flowLevel > t);
  var s,
    c,
    u = "[object Object]" === i || "[object Array]" === i;
  if (u && (c = -1 !== (s = e.duplicates.indexOf(r))), (null !== e.tag && "?" !== e.tag || c || 2 !== e.indent && t > 0) && (o = !1), c && e.usedDuplicates[s]) e.dump = "*ref_" + s;else {
    if (u && c && !e.usedDuplicates[s] && (e.usedDuplicates[s] = !0), "[object Object]" === i) n && 0 !== Object.keys(e.dump).length ? (writeBlockMapping(e, t, e.dump, o), c && (e.dump = "&ref_" + s + e.dump)) : (writeFlowMapping(e, t, e.dump), c && (e.dump = "&ref_" + s + " " + e.dump));else if ("[object Array]" === i) {
      var l = e.noArrayIndent && t > 0 ? t - 1 : t;
      n && 0 !== e.dump.length ? (writeBlockSequence(e, l, e.dump, o), c && (e.dump = "&ref_" + s + e.dump)) : (writeFlowSequence(e, l, e.dump), c && (e.dump = "&ref_" + s + " " + e.dump));
    } else {
      if ("[object String]" !== i) {
        if (e.skipInvalid) return !1;
        throw new exception("unacceptable kind of an object to dump " + i);
      }
      "?" !== e.tag && writeScalar(e, e.dump, t, a);
    }
    null !== e.tag && "?" !== e.tag && (e.dump = "!<" + e.tag + "> " + e.dump);
  }
  return !0;
}
function getDuplicateReferences(e, t) {
  var r,
    n,
    o = [],
    a = [];
  for (inspectNode(e, o, a), r = 0, n = a.length; r < n; r += 1) t.duplicates.push(o[a[r]]);
  t.usedDuplicates = new Array(n);
}
function inspectNode(e, t, r) {
  var n, o, a;
  if (null !== e && "object" == typeof e) if (-1 !== (o = t.indexOf(e))) -1 === r.indexOf(o) && r.push(o);else if (t.push(e), Array.isArray(e)) for (o = 0, a = e.length; o < a; o += 1) inspectNode(e[o], t, r);else for (o = 0, a = (n = Object.keys(e)).length; o < a; o += 1) inspectNode(e[n[o]], t, r);
}
function dump(e, t) {
  var r = new State$1(t = t || {});
  return r.noRefs || getDuplicateReferences(e, r), writeNode(r, 0, e, !0, !0) ? r.dump + "\n" : "";
}
function safeDump(e, t) {
  return dump(e, common.extend({
    schema: default_safe
  }, t));
}
var dump_1 = dump,
  safeDump_1 = safeDump,
  dumper = {
    dump: dump_1,
    safeDump: safeDump_1
  };
function deprecated(e) {
  return function () {
    throw new Error("Function " + e + " is deprecated and cannot be used.");
  };
}
var Type$1 = type,
  Schema$1 = schema,
  FAILSAFE_SCHEMA = failsafe,
  JSON_SCHEMA = json,
  CORE_SCHEMA = core,
  DEFAULT_SAFE_SCHEMA = default_safe,
  DEFAULT_FULL_SCHEMA = default_full,
  load$1 = loader.load,
  loadAll$1 = loader.loadAll,
  safeLoad$1 = loader.safeLoad,
  safeLoadAll$1 = loader.safeLoadAll,
  dump$1 = dumper.dump,
  safeDump$1 = dumper.safeDump,
  YAMLException$1 = exception,
  MINIMAL_SCHEMA = failsafe,
  SAFE_SCHEMA = default_safe,
  DEFAULT_SCHEMA = default_full,
  scan = deprecated("scan"),
  parse$3 = deprecated("parse"),
  compose = deprecated("compose"),
  addConstructor = deprecated("addConstructor"),
  jsYaml = {
    Type: Type$1,
    Schema: Schema$1,
    FAILSAFE_SCHEMA: FAILSAFE_SCHEMA,
    JSON_SCHEMA: JSON_SCHEMA,
    CORE_SCHEMA: CORE_SCHEMA,
    DEFAULT_SAFE_SCHEMA: DEFAULT_SAFE_SCHEMA,
    DEFAULT_FULL_SCHEMA: DEFAULT_FULL_SCHEMA,
    load: load$1,
    loadAll: loadAll$1,
    safeLoad: safeLoad$1,
    safeLoadAll: safeLoadAll$1,
    dump: dump$1,
    safeDump: safeDump$1,
    YAMLException: YAMLException$1,
    MINIMAL_SCHEMA: MINIMAL_SCHEMA,
    SAFE_SCHEMA: SAFE_SCHEMA,
    DEFAULT_SCHEMA: DEFAULT_SCHEMA,
    scan: scan,
    parse: parse$3,
    compose: compose,
    addConstructor: addConstructor
  },
  jsYaml$1 = jsYaml,
  reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;
function isKey(e, t) {
  if (isArray_1(e)) return !1;
  var r = typeof e;
  return !("number" != r && "symbol" != r && "boolean" != r && null != e && !isSymbol_1(e)) || reIsPlainProp.test(e) || !reIsDeepProp.test(e) || null != t && e in Object(t);
}
var _isKey = isKey,
  nativeCreate = _getNative(Object, "create"),
  _nativeCreate = nativeCreate;
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {}, this.size = 0;
}
var _hashClear = hashClear;
function hashDelete(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var _hashDelete = hashDelete,
  HASH_UNDEFINED = "__lodash_hash_undefined__",
  objectProto$9 = Object.prototype,
  hasOwnProperty$9 = objectProto$9.hasOwnProperty;
function hashGet(e) {
  var t = this.__data__;
  if (_nativeCreate) {
    var r = t[e];
    return r === HASH_UNDEFINED ? void 0 : r;
  }
  return hasOwnProperty$9.call(t, e) ? t[e] : void 0;
}
var _hashGet = hashGet,
  objectProto$a = Object.prototype,
  hasOwnProperty$a = objectProto$a.hasOwnProperty;
function hashHas(e) {
  var t = this.__data__;
  return _nativeCreate ? void 0 !== t[e] : hasOwnProperty$a.call(t, e);
}
var _hashHas = hashHas,
  HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = _nativeCreate && void 0 === t ? HASH_UNDEFINED$1 : t, this;
}
var _hashSet = hashSet;
function Hash(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hash.prototype.clear = _hashClear, Hash.prototype.delete = _hashDelete, Hash.prototype.get = _hashGet, Hash.prototype.has = _hashHas, Hash.prototype.set = _hashSet;
var _Hash = Hash;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear;
function assocIndexOf(e, t) {
  for (var r = e.length; r--;) if (eq_1(e[r][0], t)) return r;
  return -1;
}
var _assocIndexOf = assocIndexOf,
  arrayProto = Array.prototype,
  splice = arrayProto.splice;
function listCacheDelete(e) {
  var t = this.__data__,
    r = _assocIndexOf(t, e);
  return !(r < 0) && (r == t.length - 1 ? t.pop() : splice.call(t, r, 1), --this.size, !0);
}
var _listCacheDelete = listCacheDelete;
function listCacheGet(e) {
  var t = this.__data__,
    r = _assocIndexOf(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var _listCacheGet = listCacheGet;
function listCacheHas(e) {
  return _assocIndexOf(this.__data__, e) > -1;
}
var _listCacheHas = listCacheHas;
function listCacheSet(e, t) {
  var r = this.__data__,
    n = _assocIndexOf(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var _listCacheSet = listCacheSet;
function ListCache(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
ListCache.prototype.clear = _listCacheClear, ListCache.prototype.delete = _listCacheDelete, ListCache.prototype.get = _listCacheGet, ListCache.prototype.has = _listCacheHas, ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache,
  Map$1 = _getNative(_root, "Map"),
  _Map = Map$1;
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new _Hash(),
    map: new (_Map || _ListCache)(),
    string: new _Hash()
  };
}
var _mapCacheClear = mapCacheClear;
function isKeyable(e) {
  var t = typeof e;
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}
var _isKeyable = isKeyable;
function getMapData(e, t) {
  var r = e.__data__;
  return _isKeyable(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
}
var _getMapData = getMapData;
function mapCacheDelete(e) {
  var t = _getMapData(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var _mapCacheDelete = mapCacheDelete;
function mapCacheGet(e) {
  return _getMapData(this, e).get(e);
}
var _mapCacheGet = mapCacheGet;
function mapCacheHas(e) {
  return _getMapData(this, e).has(e);
}
var _mapCacheHas = mapCacheHas;
function mapCacheSet(e, t) {
  var r = _getMapData(this, e),
    n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet;
function MapCache(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
MapCache.prototype.clear = _mapCacheClear, MapCache.prototype.delete = _mapCacheDelete, MapCache.prototype.get = _mapCacheGet, MapCache.prototype.has = _mapCacheHas, MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache,
  FUNC_ERROR_TEXT = "Expected a function";
function memoize(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(FUNC_ERROR_TEXT);
  var r = function r() {
    var n = arguments,
      o = t ? t.apply(this, n) : n[0],
      a = r.cache;
    if (a.has(o)) return a.get(o);
    var i = e.apply(this, n);
    return r.cache = a.set(o, i) || a, i;
  };
  return r.cache = new (memoize.Cache || _MapCache)(), r;
}
memoize.Cache = _MapCache;
var memoize_1 = memoize,
  MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(e) {
  var t = memoize_1(e, function (e) {
      return r.size === MAX_MEMOIZE_SIZE && r.clear(), e;
    }),
    r = t.cache;
  return t;
}
var _memoizeCapped = memoizeCapped,
  rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  reEscapeChar = /\\(\\)?/g,
  stringToPath = _memoizeCapped(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(rePropName, function (e, r, n, o) {
      t.push(n ? o.replace(reEscapeChar, "$1") : r || e);
    }), t;
  }),
  _stringToPath = stringToPath;
function castPath(e, t) {
  return isArray_1(e) ? e : _isKey(e, t) ? [e] : _stringToPath(toString_1(e));
}
var _castPath = castPath,
  INFINITY$2 = 1 / 0;
function toKey(e) {
  if ("string" == typeof e || isSymbol_1(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY$2 ? "-0" : t;
}
var _toKey = toKey;
function baseGet(e, t) {
  for (var r = 0, n = (t = _castPath(t, e)).length; null != e && r < n;) e = e[_toKey(t[r++])];
  return r && r == n ? e : void 0;
}
var _baseGet = baseGet;
function baseSet(e, t, r, n) {
  if (!isObject_1(e)) return e;
  for (var o = -1, a = (t = _castPath(t, e)).length, i = a - 1, s = e; null != s && ++o < a;) {
    var c = _toKey(t[o]),
      u = r;
    if ("__proto__" === c || "constructor" === c || "prototype" === c) return e;
    if (o != i) {
      var l = s[c];
      void 0 === (u = n ? n(l, c, s) : void 0) && (u = isObject_1(l) ? l : _isIndex(t[o + 1]) ? [] : {});
    }
    _assignValue(s, c, u), s = s[c];
  }
  return e;
}
var _baseSet = baseSet;
function basePickBy(e, t, r) {
  for (var n = -1, o = t.length, a = {}; ++n < o;) {
    var i = t[n],
      s = _baseGet(e, i);
    r(s, i) && _baseSet(a, _castPath(i, e), s);
  }
  return a;
}
var _basePickBy = basePickBy;
function baseHasIn(e, t) {
  return null != e && t in Object(e);
}
var _baseHasIn = baseHasIn;
function hasPath(e, t, r) {
  for (var n = -1, o = (t = _castPath(t, e)).length, a = !1; ++n < o;) {
    var i = _toKey(t[n]);
    if (!(a = null != e && r(e, i))) break;
    e = e[i];
  }
  return a || ++n != o ? a : !!(o = null == e ? 0 : e.length) && isLength_1(o) && _isIndex(i, o) && (isArray_1(e) || isArguments_1(e));
}
var _hasPath = hasPath;
function hasIn(e, t) {
  return null != e && _hasPath(e, t, _baseHasIn);
}
var hasIn_1 = hasIn;
function basePick(e, t) {
  return _basePickBy(e, t, function (t, r) {
    return hasIn_1(e, r);
  });
}
var _basePick = basePick;
function arrayPush(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n;) e[o + r] = t[r];
  return e;
}
var _arrayPush = arrayPush,
  spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : void 0;
function isFlattenable(e) {
  return isArray_1(e) || isArguments_1(e) || !!(spreadableSymbol && e && e[spreadableSymbol]);
}
var _isFlattenable = isFlattenable;
function baseFlatten(e, t, r, n, o) {
  var a = -1,
    i = e.length;
  for (r || (r = _isFlattenable), o || (o = []); ++a < i;) {
    var s = e[a];
    t > 0 && r(s) ? t > 1 ? baseFlatten(s, t - 1, r, n, o) : _arrayPush(o, s) : n || (o[o.length] = s);
  }
  return o;
}
var _baseFlatten = baseFlatten;
function flatten(e) {
  return (null == e ? 0 : e.length) ? _baseFlatten(e, 1) : [];
}
var flatten_1 = flatten;
function flatRest(e) {
  return _setToString(_overRest(e, void 0, flatten_1), e + "");
}
var _flatRest = flatRest,
  pick = _flatRest(function (e, t) {
    return null == e ? {} : _basePick(e, t);
  }),
  pick_1 = pick,
  $find = arrayIteration.find,
  FIND = "find",
  SKIPS_HOLES = !0,
  USES_TO_LENGTH$9 = arrayMethodUsesToLength(FIND);
FIND in [] && Array(1)[FIND](function () {
  SKIPS_HOLES = !1;
}), _export({
  target: "Array",
  proto: !0,
  forced: SKIPS_HOLES || !USES_TO_LENGTH$9
}, {
  find: function (e) {
    return $find(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var find = entryVirtual("Array").find,
  ArrayPrototype$c = Array.prototype,
  find_1 = function find_1(e) {
    var t = e.find;
    return e === ArrayPrototype$c || e instanceof Array && t === ArrayPrototype$c.find ? find : t;
  },
  find$1 = find_1,
  find$2 = find$1;
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
var classCallCheck = _classCallCheck;
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), defineProperty$1(e, n.key, n);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var createClass = _createClass;
function get$1(e, t) {
  var r,
    n,
    o = arguments.length < 3 ? e : arguments[2];
  return anObject(e) === o ? e[t] : (r = objectGetOwnPropertyDescriptor.f(e, t)) ? has(r, "value") ? r.value : void 0 === r.get ? void 0 : r.get.call(o) : isObject(n = objectGetPrototypeOf(e)) ? get$1(n, t, o) : void 0;
}
_export({
  target: "Reflect",
  stat: !0
}, {
  get: get$1
});
var get$2 = path.Reflect.get,
  get$3 = get$2,
  get$4 = get$3,
  FAILS_ON_PRIMITIVES$2 = fails(function () {
    objectGetPrototypeOf(1);
  });
_export({
  target: "Object",
  stat: !0,
  forced: FAILS_ON_PRIMITIVES$2,
  sham: !correctPrototypeGetter
}, {
  getPrototypeOf: function (e) {
    return objectGetPrototypeOf(toObject(e));
  }
});
var getPrototypeOf = path.Object.getPrototypeOf,
  getPrototypeOf$1 = getPrototypeOf,
  getPrototypeOf$2 = getPrototypeOf$1;
_export({
  target: "Object",
  stat: !0
}, {
  setPrototypeOf: objectSetPrototypeOf
});
var setPrototypeOf = path.Object.setPrototypeOf,
  setPrototypeOf$1 = setPrototypeOf,
  setPrototypeOf$2 = setPrototypeOf$1,
  getPrototypeOf$3 = createCommonjsModule(function (e) {
    function t(r) {
      return e.exports = t = setPrototypeOf$2 ? getPrototypeOf$2 : function (e) {
        return e.__proto__ || getPrototypeOf$2(e);
      }, t(r);
    }
    e.exports = t;
  });
function _superPropBase(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = getPrototypeOf$3(e)););
  return e;
}
var superPropBase = _superPropBase,
  get$5 = createCommonjsModule(function (e) {
    function t(r, n, o) {
      return "undefined" != typeof Reflect && get$4 ? e.exports = t = get$4 : e.exports = t = function (e, t, r) {
        var n = superPropBase(e, t);
        if (n) {
          var o = getOwnPropertyDescriptor$3(n, t);
          return o.get ? o.get.call(r) : o.value;
        }
      }, t(r, n, o || r);
    }
    e.exports = t;
  });
_export({
  target: "Object",
  stat: !0,
  sham: !descriptors
}, {
  create: objectCreate
});
var Object$1 = path.Object,
  create = function create(e, t) {
    return Object$1.create(e, t);
  },
  create$1 = create,
  create$2 = create$1,
  setPrototypeOf$3 = createCommonjsModule(function (e) {
    function t(r, n) {
      return e.exports = t = setPrototypeOf$2 || function (e, t) {
        return e.__proto__ = t, e;
      }, t(r, n);
    }
    e.exports = t;
  });
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = create$2(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && setPrototypeOf$3(e, t);
}
var inherits = _inherits,
  nativeConstruct = getBuiltIn("Reflect", "construct"),
  NEW_TARGET_BUG = fails(function () {
    function e() {}
    return !(nativeConstruct(function () {}, [], e) instanceof e);
  }),
  ARGS_BUG = !fails(function () {
    nativeConstruct(function () {});
  }),
  FORCED$4 = NEW_TARGET_BUG || ARGS_BUG;
_export({
  target: "Reflect",
  stat: !0,
  forced: FORCED$4,
  sham: FORCED$4
}, {
  construct: function (e, t) {
    aFunction(e), anObject(t);
    var r = arguments.length < 3 ? e : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(e, t, r);
    if (e == r) {
      switch (t.length) {
        case 0:
          return new e();
        case 1:
          return new e(t[0]);
        case 2:
          return new e(t[0], t[1]);
        case 3:
          return new e(t[0], t[1], t[2]);
        case 4:
          return new e(t[0], t[1], t[2], t[3]);
      }
      var n = [null];
      return n.push.apply(n, t), new (functionBind.apply(e, n))();
    }
    var o = r.prototype,
      a = objectCreate(isObject(o) ? o : Object.prototype),
      i = Function.apply.call(e, a, t);
    return isObject(i) ? i : a;
  }
});
var construct$1 = path.Reflect.construct,
  construct$2 = construct$1,
  construct$3 = construct$2;
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !construct$3) return !1;
  if (construct$3.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(construct$3(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
var isNativeReflectConstruct = _isNativeReflectConstruct;
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var assertThisInitialized = _assertThisInitialized;
function _possibleConstructorReturn(e, t) {
  return !t || "object" !== _typeof_1(t) && "function" != typeof t ? assertThisInitialized(e) : t;
}
var possibleConstructorReturn = _possibleConstructorReturn;
function _createSuper(e) {
  var t = isNativeReflectConstruct();
  return function () {
    var r,
      n = getPrototypeOf$3(e);
    if (t) {
      var o = getPrototypeOf$3(this).constructor;
      r = construct$3(n, arguments, o);
    } else r = n.apply(this, arguments);
    return possibleConstructorReturn(this, r);
  };
}
var createSuper = _createSuper,
  browser = window.FormData,
  patch = function patch(e) {
    var t = function t(e, t) {
      return {
        name: e,
        value: t
      };
    };
    return isFunction_1(e.prototype.set) || isFunction_1(e.prototype.get) || isFunction_1(e.prototype.getAll) || isFunction_1(e.prototype.has) ? e : function (e) {
      inherits(n, e);
      var r = createSuper(n);
      function n(e) {
        var t;
        return classCallCheck(this, n), (t = r.call(this, e)).entryList = [], t;
      }
      return createClass(n, [{
        key: "append",
        value: function (e, r, o) {
          return this.entryList.push(t(e, r)), get$5(getPrototypeOf$3(n.prototype), "append", this).call(this, e, r, o);
        }
      }, {
        key: "set",
        value: function (e, r) {
          var n,
            o = t(e, r);
          this.entryList = filter$4(n = this.entryList).call(n, function (t) {
            return t.name !== e;
          }), this.entryList.push(o);
        }
      }, {
        key: "get",
        value: function (e) {
          var t,
            r = find$2(t = this.entryList).call(t, function (t) {
              return t.name === e;
            });
          return void 0 === r ? null : r;
        }
      }, {
        key: "getAll",
        value: function (e) {
          var t, r;
          return map$4(t = filter$4(r = this.entryList).call(r, function (t) {
            return t.name === e;
          })).call(t, function (e) {
            return e.value;
          });
        }
      }, {
        key: "has",
        value: function (e) {
          var t;
          return some$2(t = this.entryList).call(t, function (t) {
            return t.name === e;
          });
        }
      }]), n;
    }(e);
  },
  FormData$1 = patch(browser),
  slice$4 = slice_1,
  slice$5 = slice$4;
function _arrayWithoutHoles(e) {
  if (isArray$6(e)) return arrayLikeToArray(e);
}
var arrayWithoutHoles = _arrayWithoutHoles;
function _iterableToArray(e) {
  if (void 0 !== symbol$2 && isIterable$1(Object(e))) return from$3(e);
}
var iterableToArray = _iterableToArray;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var nonIterableSpread = _nonIterableSpread;
function _toConsumableArray(e) {
  return arrayWithoutHoles(e) || iterableToArray(e) || unsupportedIterableToArray(e) || nonIterableSpread();
}
var toConsumableArray = _toConsumableArray,
  Buffer$1 = Buffer,
  isRfc3986Reserved = function isRfc3986Reserved(e) {
    return indexOf$3(":/?#[]@!$&'()*+,;=").call(":/?#[]@!$&'()*+,;=", e) > -1;
  },
  isRrc3986Unreserved = function isRrc3986Unreserved(e) {
    return /^[a-z0-9\-._~]+$/i.test(e);
  };
function encodeDisallowedCharacters(e) {
  var t,
    r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).escape,
    n = arguments.length > 2 ? arguments[2] : void 0;
  return "number" == typeof e && (e = e.toString()), "string" == typeof e && e.length && r ? n ? JSON.parse(e) : map$4(t = toConsumableArray(e)).call(t, function (e) {
    var t, n;
    return isRrc3986Unreserved(e) || isRfc3986Reserved(e) && "unsafe" === r ? e : map$4(t = map$4(n = Buffer$1.from(e).toJSON().data || []).call(n, function (e) {
      var t;
      return slice$5(t = "0".concat(e.toString(16).toUpperCase())).call(t, -2);
    })).call(t, function (e) {
      return "%".concat(e);
    }).join("");
  }).join("") : e;
}
function stylize(e) {
  var t = e.value;
  return isArray$8(t) ? encodeArray(e) : "object" === _typeof_1(t) ? encodeObject(e) : encodePrimitive(e);
}
function encodeArray(e) {
  var t,
    r = e.key,
    n = e.value,
    o = e.style,
    a = e.explode,
    i = e.escape,
    s = function s(e) {
      return encodeDisallowedCharacters(e, {
        escape: i
      });
    };
  if ("simple" === o) return map$4(n).call(n, function (e) {
    return s(e);
  }).join(",");
  if ("label" === o) return ".".concat(map$4(n).call(n, function (e) {
    return s(e);
  }).join("."));
  if ("matrix" === o) return reduce$2(t = map$4(n).call(n, function (e) {
    return s(e);
  })).call(t, function (e, t) {
    var n, o, i;
    return !e || a ? concat$2(o = concat$2(i = "".concat(e || "", ";")).call(i, r, "=")).call(o, t) : concat$2(n = "".concat(e, ",")).call(n, t);
  }, "");
  if ("form" === o) {
    var c = a ? "&".concat(r, "=") : ",";
    return map$4(n).call(n, function (e) {
      return s(e);
    }).join(c);
  }
  if ("spaceDelimited" === o) {
    var u = a ? "".concat(r, "=") : "";
    return map$4(n).call(n, function (e) {
      return s(e);
    }).join(" ".concat(u));
  }
  if ("pipeDelimited" === o) {
    var l = a ? "".concat(r, "=") : "";
    return map$4(n).call(n, function (e) {
      return s(e);
    }).join("|".concat(l));
  }
}
function encodeObject(e) {
  var t = e.key,
    r = e.value,
    n = e.style,
    o = e.explode,
    a = e.escape,
    i = function i(e) {
      return encodeDisallowedCharacters(e, {
        escape: a
      });
    },
    s = keys$6(r);
  return "simple" === n ? reduce$2(s).call(s, function (e, t) {
    var n,
      a,
      s,
      c = i(r[t]),
      u = o ? "=" : ",",
      l = e ? "".concat(e, ",") : "";
    return concat$2(n = concat$2(a = concat$2(s = "".concat(l)).call(s, t)).call(a, u)).call(n, c);
  }, "") : "label" === n ? reduce$2(s).call(s, function (e, t) {
    var n,
      a,
      s,
      c = i(r[t]),
      u = o ? "=" : ".",
      l = e ? "".concat(e, ".") : ".";
    return concat$2(n = concat$2(a = concat$2(s = "".concat(l)).call(s, t)).call(a, u)).call(n, c);
  }, "") : "matrix" === n && o ? reduce$2(s).call(s, function (e, t) {
    var n,
      o,
      a = i(r[t]),
      s = e ? "".concat(e, ";") : ";";
    return concat$2(n = concat$2(o = "".concat(s)).call(o, t, "=")).call(n, a);
  }, "") : "matrix" === n ? reduce$2(s).call(s, function (e, n) {
    var o,
      a,
      s = i(r[n]),
      c = e ? "".concat(e, ",") : ";".concat(t, "=");
    return concat$2(o = concat$2(a = "".concat(c)).call(a, n, ",")).call(o, s);
  }, "") : "form" === n ? reduce$2(s).call(s, function (e, t) {
    var n,
      a,
      s,
      c,
      u = i(r[t]),
      l = e ? concat$2(n = "".concat(e)).call(n, o ? "&" : ",") : "",
      f = o ? "=" : ",";
    return concat$2(a = concat$2(s = concat$2(c = "".concat(l)).call(c, t)).call(s, f)).call(a, u);
  }, "") : void 0;
}
function encodePrimitive(e) {
  var t,
    r = e.key,
    n = e.value,
    o = e.style,
    a = e.escape,
    i = function i(e) {
      return encodeDisallowedCharacters(e, {
        escape: a
      });
    };
  return "simple" === o ? i(n) : "label" === o ? ".".concat(i(n)) : "matrix" === o ? concat$2(t = ";".concat(r, "=")).call(t, i(n)) : "form" === o || "deepObject" === o ? i(n) : void 0;
}
var self$1 = {
  serializeRes: serializeRes,
  mergeInQueryOrForm: mergeInQueryOrForm
};
function http(e) {
  return _http.apply(this, arguments);
}
function _http() {
  return _http = asyncToGenerator(regenerator.mark(function e(t) {
    var r,
      n,
      o,
      a,
      i,
      s,
      c = arguments;
    return regenerator.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (r = c.length > 1 && void 0 !== c[1] ? c[1] : {}, "object" === _typeof_1(t) && (t = (r = t).url), r.headers = r.headers || {}, self$1.mergeInQueryOrForm(r), r.headers && forEach$4(n = keys$6(r.headers)).call(n, function (e) {
            var t = r.headers[e];
            "string" == typeof t && (r.headers[e] = t.replace(/\n+/g, " "));
          }), !r.requestInterceptor) {
            e.next = 12;
            break;
          }
          return e.next = 8, r.requestInterceptor(r);
        case 8:
          if (e.t0 = e.sent, e.t0) {
            e.next = 11;
            break;
          }
          e.t0 = r;
        case 11:
          r = e.t0;
        case 12:
          return o = r.headers["content-type"] || r.headers["Content-Type"], /multipart\/form-data/i.test(o) && (delete r.headers["content-type"], delete r.headers["Content-Type"]), e.prev = 14, e.next = 17, (r.userFetch || fetch)(r.url, r);
        case 17:
          return a = e.sent, e.next = 20, self$1.serializeRes(a, t, r);
        case 20:
          if (a = e.sent, !r.responseInterceptor) {
            e.next = 28;
            break;
          }
          return e.next = 24, r.responseInterceptor(a);
        case 24:
          if (e.t1 = e.sent, e.t1) {
            e.next = 27;
            break;
          }
          e.t1 = a;
        case 27:
          a = e.t1;
        case 28:
          e.next = 39;
          break;
        case 30:
          if (e.prev = 30, e.t2 = e.catch(14), a) {
            e.next = 34;
            break;
          }
          throw e.t2;
        case 34:
          throw (i = new Error(a.statusText)).status = a.status, i.statusCode = a.status, i.responseError = e.t2, i;
        case 39:
          if (a.ok) {
            e.next = 45;
            break;
          }
          throw (s = new Error(a.statusText)).status = a.status, s.statusCode = a.status, s.response = a, s;
        case 45:
          return e.abrupt("return", a);
        case 46:
        case "end":
          return e.stop();
      }
    }, e, null, [[14, 30]]);
  })), _http.apply(this, arguments);
}
var shouldDownloadAsText = function shouldDownloadAsText() {
  return /(json|xml|yaml|text)\b/.test(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "");
};
function parseBody(e, t) {
  return t && (0 === indexOf$3(t).call(t, "application/json") || indexOf$3(t).call(t, "+json") > 0) ? JSON.parse(e) : jsYaml$1.safeLoad(e);
}
function serializeRes(e, t) {
  var r = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).loadSpec,
    n = void 0 !== r && r,
    o = {
      ok: e.ok,
      url: e.url || t,
      status: e.status,
      statusText: e.statusText,
      headers: serializeHeaders(e.headers)
    },
    a = o.headers["content-type"],
    i = n || shouldDownloadAsText(a);
  return (i ? e.text : e.blob || e.buffer).call(e).then(function (e) {
    if (o.text = e, o.data = e, i) try {
      var t = parseBody(e, a);
      o.body = t, o.obj = t;
    } catch (e) {
      o.parseError = e;
    }
    return o;
  });
}
function serializeHeaderValue(e) {
  return includes$4(e).call(e, ", ") ? e.split(", ") : e;
}
function serializeHeaders() {
  var e,
    t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return isFunction_1(entries$5(t)) ? reduce$2(e = from$5(entries$5(t).call(t))).call(e, function (e, t) {
    var r = slicedToArray(t, 2),
      n = r[0],
      o = r[1];
    return e[n] = serializeHeaderValue(o), e;
  }, {}) : {};
}
function isFile(e, t) {
  return t || "undefined" == typeof navigator || (t = navigator), t && "ReactNative" === t.product ? !(!e || "object" !== _typeof_1(e) || "string" != typeof e.uri) : "undefined" != typeof File && e instanceof File || "undefined" != typeof Blob && e instanceof Blob || void 0 !== Buffer && e instanceof Buffer || null !== e && "object" === _typeof_1(e) && "function" == typeof e.pipe;
}
function isArrayOfFile(e, t) {
  return isArray$8(e) && some$2(e).call(e, function (e) {
    return isFile(e, t);
  });
}
var STYLE_SEPARATORS = {
    form: ",",
    spaceDelimited: "%20",
    pipeDelimited: "|"
  },
  SEPARATORS = {
    csv: ",",
    ssv: "%20",
    tsv: "%09",
    pipes: "|"
  };
function formatKeyValue(e, t) {
  var r,
    n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    o = t.collectionFormat,
    a = t.allowEmptyValue,
    i = t.serializationOption,
    s = t.encoding,
    c = "object" !== _typeof_1(t) || isArray$8(t) ? t : t.value,
    u = n ? function (e) {
      return e.toString();
    } : function (e) {
      return encodeURIComponent(e);
    },
    l = u(e);
  return void 0 === c && a ? [[l, ""]] : isFile(c) || isArrayOfFile(c) ? [[l, c]] : i ? formatKeyValueBySerializationOption(e, c, n, i) : s ? some$2(r = [_typeof_1(s.style), _typeof_1(s.explode), _typeof_1(s.allowReserved)]).call(r, function (e) {
    return "undefined" !== e;
  }) ? formatKeyValueBySerializationOption(e, c, n, pick_1(s, ["style", "explode", "allowReserved"])) : s.contentType ? "application/json" === s.contentType ? [[l, u("string" == typeof c ? c : stringify$3(c))]] : [[l, u(c.toString())]] : "object" !== _typeof_1(c) ? [[l, u(c)]] : isArray$8(c) && every$2(c).call(c, function (e) {
    return "object" !== _typeof_1(e);
  }) ? [[l, map$4(c).call(c, u).join(",")]] : [[l, u(stringify$3(c))]] : "object" !== _typeof_1(c) ? [[l, u(c)]] : isArray$8(c) ? "multi" === o ? [[l, map$4(c).call(c, u)]] : [[l, map$4(c).call(c, u).join(SEPARATORS[o || "csv"])]] : [[l, ""]];
}
function formatKeyValueBySerializationOption(e, t, r, n) {
  var o,
    a,
    i,
    s = n.style || "form",
    c = void 0 === n.explode ? "form" === s : n.explode,
    u = !r && (n && n.allowReserved ? "unsafe" : "reserved"),
    l = function l(e) {
      return encodeDisallowedCharacters(e, {
        escape: u
      });
    },
    f = r ? function (e) {
      return e;
    } : function (e) {
      return encodeDisallowedCharacters(e, {
        escape: u
      });
    };
  return "object" !== _typeof_1(t) ? [[f(e), l(t)]] : isArray$8(t) ? c ? [[f(e), map$4(t).call(t, l)]] : [[f(e), map$4(t).call(t, l).join(STYLE_SEPARATORS[s])]] : "deepObject" === s ? map$4(a = keys$6(t)).call(a, function (r) {
    var n;
    return [f(concat$2(n = "".concat(e, "[")).call(n, r, "]")), l(t[r])];
  }) : c ? map$4(i = keys$6(t)).call(i, function (e) {
    return [f(e), l(t[e])];
  }) : [[f(e), map$4(o = keys$6(t)).call(o, function (e) {
    var r;
    return [concat$2(r = "".concat(f(e), ",")).call(r, l(t[e]))];
  }).join(",")]];
}
function buildFormData(e) {
  var t;
  return reduce$2(t = entries$2(e)).call(t, function (e, t) {
    var r,
      n = slicedToArray(t, 2),
      o = n[0],
      a = n[1],
      i = createForOfIteratorHelper(formatKeyValue(o, a, !0));
    try {
      for (i.s(); !(r = i.n()).done;) {
        var s = slicedToArray(r.value, 2),
          c = s[0],
          u = s[1];
        if (isArray$8(u)) {
          var l,
            f = createForOfIteratorHelper(u);
          try {
            for (f.s(); !(l = f.n()).done;) {
              var p = l.value;
              e.append(c, p);
            }
          } catch (e) {
            f.e(e);
          } finally {
            f.f();
          }
        } else e.append(c, u);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    return e;
  }, new FormData$1());
}
function encodeFormOrQuery(e) {
  var t,
    r = reduce$2(t = keys$6(e)).call(t, function (t, r) {
      var n,
        o = createForOfIteratorHelper(formatKeyValue(r, e[r]));
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a = slicedToArray(n.value, 2),
            i = a[0],
            s = a[1];
          t[i] = s;
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      return t;
    }, {});
  return lib.stringify(r, {
    encode: !1,
    indices: !1
  }) || "";
}
function mergeInQueryOrForm() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = e.url,
    r = void 0 === t ? "" : t,
    n = e.query,
    o = e.form;
  if (o) {
    var a,
      i = some$2(a = keys$6(o)).call(a, function (e) {
        var t = o[e].value;
        return isFile(t) || isArrayOfFile(t);
      }),
      s = e.headers["content-type"] || e.headers["Content-Type"];
    i || /multipart\/form-data/i.test(s) ? e.body = buildFormData(e.form) : e.body = encodeFormOrQuery(o), delete e.form;
  }
  if (n) {
    var c = r.split("?"),
      u = slicedToArray(c, 2),
      l = u[0],
      f = u[1],
      p = "";
    if (f) {
      var h = lib.parse(f),
        y = keys$6(n);
      forEach$4(y).call(y, function (e) {
        return delete h[e];
      }), p = lib.stringify(h, {
        encode: !0
      });
    }
    var d = function () {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
      var n = filter$4(t).call(t, function (e) {
        return e;
      }).join("&");
      return n ? "?".concat(n) : "";
    }(p, encodeFormOrQuery(n));
    e.url = l + d, delete e.query;
  }
  return e;
}
function makeHttp(e, t, r) {
  return r = r || function (e) {
    return e;
  }, t = t || function (e) {
    return e;
  }, function (n) {
    return "string" == typeof n && (n = {
      url: n
    }), self$1.mergeInQueryOrForm(n), n = t(n), r(e(n));
  };
}
var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport("splice"),
  USES_TO_LENGTH$a = arrayMethodUsesToLength("splice", {
    ACCESSORS: !0,
    0: 0,
    1: 2
  }),
  max$2 = Math.max,
  min$2 = Math.min,
  MAX_SAFE_INTEGER$3 = 9007199254740991,
  MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
_export({
  target: "Array",
  proto: !0,
  forced: !HAS_SPECIES_SUPPORT$3 || !USES_TO_LENGTH$a
}, {
  splice: function (e, t) {
    var r,
      n,
      o,
      a,
      i,
      s,
      c = toObject(this),
      u = toLength(c.length),
      l = toAbsoluteIndex(e, u),
      f = arguments.length;
    if (0 === f ? r = n = 0 : 1 === f ? (r = 0, n = u - l) : (r = f - 2, n = min$2(max$2(toInteger(t), 0), u - l)), u + r - n > MAX_SAFE_INTEGER$3) throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    for (o = arraySpeciesCreate(c, n), a = 0; a < n; a++) (i = l + a) in c && createProperty(o, a, c[i]);
    if (o.length = n, r < n) {
      for (a = l; a < u - n; a++) s = a + r, (i = a + n) in c ? c[s] = c[i] : delete c[s];
      for (a = u; a > u - n + r; a--) delete c[a - 1];
    } else if (r > n) for (a = u - n; a > l; a--) s = a + r - 1, (i = a + n - 1) in c ? c[s] = c[i] : delete c[s];
    for (a = 0; a < r; a++) c[a + l] = arguments[a + 2];
    return c.length = u - n + r, o;
  }
});
var splice$1 = entryVirtual("Array").splice,
  ArrayPrototype$d = Array.prototype,
  splice_1 = function splice_1(e) {
    var t = e.splice;
    return e === ArrayPrototype$d || e instanceof Array && t === ArrayPrototype$d.splice ? splice$1 : t;
  },
  splice$2 = splice_1,
  splice$3 = splice$2,
  promise$4 = promise$1,
  promise$5 = promise$4,
  create$3 = create,
  create$4 = create$3,
  nativeAssign = Object.assign,
  defineProperty$7 = Object.defineProperty,
  objectAssign = !nativeAssign || fails(function () {
    if (descriptors && 1 !== nativeAssign({
      b: 1
    }, nativeAssign(defineProperty$7({}, "a", {
      enumerable: !0,
      get: function () {
        defineProperty$7(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), {
      b: 2
    })).b) return !0;
    var e = {},
      t = {},
      r = Symbol(),
      n = "abcdefghijklmnopqrst";
    return e[r] = 7, n.split("").forEach(function (e) {
      t[e] = e;
    }), 7 != nativeAssign({}, e)[r] || objectKeys(nativeAssign({}, t)).join("") != n;
  }) ? function (e, t) {
    for (var r = toObject(e), n = arguments.length, o = 1, a = objectGetOwnPropertySymbols.f, i = objectPropertyIsEnumerable.f; n > o;) for (var s, c = indexedObject(arguments[o++]), u = a ? objectKeys(c).concat(a(c)) : objectKeys(c), l = u.length, f = 0; l > f;) s = u[f++], descriptors && !i.call(c, s) || (r[s] = c[s]);
    return r;
  } : nativeAssign;
_export({
  target: "Object",
  stat: !0,
  forced: Object.assign !== objectAssign
}, {
  assign: objectAssign
});
var assign$2 = path.Object.assign,
  assign$3 = assign$2,
  assign$4 = assign$3;
function stackClear() {
  this.__data__ = new _ListCache(), this.size = 0;
}
var _stackClear = stackClear;
function stackDelete(e) {
  var t = this.__data__,
    r = t.delete(e);
  return this.size = t.size, r;
}
var _stackDelete = stackDelete;
function stackGet(e) {
  return this.__data__.get(e);
}
var _stackGet = stackGet;
function stackHas(e) {
  return this.__data__.has(e);
}
var _stackHas = stackHas,
  LARGE_ARRAY_SIZE = 200;
function stackSet(e, t) {
  var r = this.__data__;
  if (r instanceof _ListCache) {
    var n = r.__data__;
    if (!_Map || n.length < LARGE_ARRAY_SIZE - 1) return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new _MapCache(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var _stackSet = stackSet;
function Stack(e) {
  var t = this.__data__ = new _ListCache(e);
  this.size = t.size;
}
Stack.prototype.clear = _stackClear, Stack.prototype.delete = _stackDelete, Stack.prototype.get = _stackGet, Stack.prototype.has = _stackHas, Stack.prototype.set = _stackSet;
var _Stack = Stack,
  HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
function setCacheAdd(e) {
  return this.__data__.set(e, HASH_UNDEFINED$2), this;
}
var _setCacheAdd = setCacheAdd;
function setCacheHas(e) {
  return this.__data__.has(e);
}
var _setCacheHas = setCacheHas;
function SetCache(e) {
  var t = -1,
    r = null == e ? 0 : e.length;
  for (this.__data__ = new _MapCache(); ++t < r;) this.add(e[t]);
}
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd, SetCache.prototype.has = _setCacheHas;
var _SetCache = SetCache;
function arraySome(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) if (t(e[r], r, e)) return !0;
  return !1;
}
var _arraySome = arraySome;
function cacheHas(e, t) {
  return e.has(t);
}
var _cacheHas = cacheHas,
  COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;
function equalArrays(e, t, r, n, o, a) {
  var i = r & COMPARE_PARTIAL_FLAG,
    s = e.length,
    c = t.length;
  if (s != c && !(i && c > s)) return !1;
  var u = a.get(e),
    l = a.get(t);
  if (u && l) return u == t && l == e;
  var f = -1,
    p = !0,
    h = r & COMPARE_UNORDERED_FLAG ? new _SetCache() : void 0;
  for (a.set(e, t), a.set(t, e); ++f < s;) {
    var y = e[f],
      d = t[f];
    if (n) var g = i ? n(d, y, f, t, e, a) : n(y, d, f, e, t, a);
    if (void 0 !== g) {
      if (g) continue;
      p = !1;
      break;
    }
    if (h) {
      if (!_arraySome(t, function (e, t) {
        if (!_cacheHas(h, t) && (y === e || o(y, e, r, n, a))) return h.push(t);
      })) {
        p = !1;
        break;
      }
    } else if (y !== d && !o(y, d, r, n, a)) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
var _equalArrays = equalArrays,
  Uint8Array$1 = _root.Uint8Array,
  _Uint8Array = Uint8Array$1;
function mapToArray(e) {
  var t = -1,
    r = Array(e.size);
  return e.forEach(function (e, n) {
    r[++t] = [n, e];
  }), r;
}
var _mapToArray = mapToArray;
function setToArray(e) {
  var t = -1,
    r = Array(e.size);
  return e.forEach(function (e) {
    r[++t] = e;
  }), r;
}
var _setToArray = setToArray,
  COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2,
  boolTag$1 = "[object Boolean]",
  dateTag$1 = "[object Date]",
  errorTag$1 = "[object Error]",
  mapTag$1 = "[object Map]",
  numberTag$1 = "[object Number]",
  regexpTag$1 = "[object RegExp]",
  setTag$1 = "[object Set]",
  stringTag$1 = "[object String]",
  symbolTag$1 = "[object Symbol]",
  arrayBufferTag$1 = "[object ArrayBuffer]",
  dataViewTag$1 = "[object DataView]",
  symbolProto$1 = _Symbol ? _Symbol.prototype : void 0,
  symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag(e, t, r, n, o, a, i) {
  switch (r) {
    case dataViewTag$1:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
      e = e.buffer, t = t.buffer;
    case arrayBufferTag$1:
      return !(e.byteLength != t.byteLength || !a(new _Uint8Array(e), new _Uint8Array(t)));
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq_1(+e, +t);
    case errorTag$1:
      return e.name == t.name && e.message == t.message;
    case regexpTag$1:
    case stringTag$1:
      return e == t + "";
    case mapTag$1:
      var s = _mapToArray;
    case setTag$1:
      var c = n & COMPARE_PARTIAL_FLAG$1;
      if (s || (s = _setToArray), e.size != t.size && !c) return !1;
      var u = i.get(e);
      if (u) return u == t;
      n |= COMPARE_UNORDERED_FLAG$1, i.set(e, t);
      var l = _equalArrays(s(e), s(t), n, o, a, i);
      return i.delete(e), l;
    case symbolTag$1:
      if (symbolValueOf) return symbolValueOf.call(e) == symbolValueOf.call(t);
  }
  return !1;
}
var _equalByTag = equalByTag;
function baseGetAllKeys(e, t, r) {
  var n = t(e);
  return isArray_1(e) ? n : _arrayPush(n, r(e));
}
var _baseGetAllKeys = baseGetAllKeys;
function arrayFilter(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length, o = 0, a = []; ++r < n;) {
    var i = e[r];
    t(i, r, e) && (a[o++] = i);
  }
  return a;
}
var _arrayFilter = arrayFilter;
function stubArray() {
  return [];
}
var stubArray_1 = stubArray,
  objectProto$b = Object.prototype,
  propertyIsEnumerable$2 = objectProto$b.propertyIsEnumerable,
  nativeGetSymbols = Object.getOwnPropertySymbols,
  getSymbols = nativeGetSymbols ? function (e) {
    return null == e ? [] : (e = Object(e), _arrayFilter(nativeGetSymbols(e), function (t) {
      return propertyIsEnumerable$2.call(e, t);
    }));
  } : stubArray_1,
  _getSymbols = getSymbols;
function getAllKeys(e) {
  return _baseGetAllKeys(e, keys_1, _getSymbols);
}
var _getAllKeys = getAllKeys,
  COMPARE_PARTIAL_FLAG$2 = 1,
  objectProto$c = Object.prototype,
  hasOwnProperty$b = objectProto$c.hasOwnProperty;
function equalObjects(e, t, r, n, o, a) {
  var i = r & COMPARE_PARTIAL_FLAG$2,
    s = _getAllKeys(e),
    c = s.length;
  if (c != _getAllKeys(t).length && !i) return !1;
  for (var u = c; u--;) {
    var l = s[u];
    if (!(i ? l in t : hasOwnProperty$b.call(t, l))) return !1;
  }
  var f = a.get(e),
    p = a.get(t);
  if (f && p) return f == t && p == e;
  var h = !0;
  a.set(e, t), a.set(t, e);
  for (var y = i; ++u < c;) {
    var d = e[l = s[u]],
      g = t[l];
    if (n) var m = i ? n(g, d, l, t, e, a) : n(d, g, l, e, t, a);
    if (!(void 0 === m ? d === g || o(d, g, r, n, a) : m)) {
      h = !1;
      break;
    }
    y || (y = "constructor" == l);
  }
  if (h && !y) {
    var b = e.constructor,
      v = t.constructor;
    b == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof b && b instanceof b && "function" == typeof v && v instanceof v || (h = !1);
  }
  return a.delete(e), a.delete(t), h;
}
var _equalObjects = equalObjects,
  DataView$1 = _getNative(_root, "DataView"),
  _DataView = DataView$1,
  Promise$2 = _getNative(_root, "Promise"),
  _Promise = Promise$2,
  Set = _getNative(_root, "Set"),
  _Set = Set,
  WeakMap$3 = _getNative(_root, "WeakMap"),
  _WeakMap = WeakMap$3,
  mapTag$2 = "[object Map]",
  objectTag$1 = "[object Object]",
  promiseTag = "[object Promise]",
  setTag$2 = "[object Set]",
  weakMapTag$1 = "[object WeakMap]",
  dataViewTag$2 = "[object DataView]",
  dataViewCtorString = _toSource(_DataView),
  mapCtorString = _toSource(_Map),
  promiseCtorString = _toSource(_Promise),
  setCtorString = _toSource(_Set),
  weakMapCtorString = _toSource(_WeakMap),
  getTag = _baseGetTag;
(_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) && (getTag = function (e) {
  var t = _baseGetTag(e),
    r = t == objectTag$1 ? e.constructor : void 0,
    n = r ? _toSource(r) : "";
  if (n) switch (n) {
    case dataViewCtorString:
      return dataViewTag$2;
    case mapCtorString:
      return mapTag$2;
    case promiseCtorString:
      return promiseTag;
    case setCtorString:
      return setTag$2;
    case weakMapCtorString:
      return weakMapTag$1;
  }
  return t;
});
var _getTag = getTag,
  COMPARE_PARTIAL_FLAG$3 = 1,
  argsTag$2 = "[object Arguments]",
  arrayTag$1 = "[object Array]",
  objectTag$2 = "[object Object]",
  objectProto$d = Object.prototype,
  hasOwnProperty$c = objectProto$d.hasOwnProperty;
function baseIsEqualDeep(e, t, r, n, o, a) {
  var i = isArray_1(e),
    s = isArray_1(t),
    c = i ? arrayTag$1 : _getTag(e),
    u = s ? arrayTag$1 : _getTag(t),
    l = (c = c == argsTag$2 ? objectTag$2 : c) == objectTag$2,
    f = (u = u == argsTag$2 ? objectTag$2 : u) == objectTag$2,
    p = c == u;
  if (p && isBuffer_1(e)) {
    if (!isBuffer_1(t)) return !1;
    i = !0, l = !1;
  }
  if (p && !l) return a || (a = new _Stack()), i || isTypedArray_1(e) ? _equalArrays(e, t, r, n, o, a) : _equalByTag(e, t, c, r, n, o, a);
  if (!(r & COMPARE_PARTIAL_FLAG$3)) {
    var h = l && hasOwnProperty$c.call(e, "__wrapped__"),
      y = f && hasOwnProperty$c.call(t, "__wrapped__");
    if (h || y) {
      var d = h ? e.value() : e,
        g = y ? t.value() : t;
      return a || (a = new _Stack()), o(d, g, r, n, a);
    }
  }
  return !!p && (a || (a = new _Stack()), _equalObjects(e, t, r, n, o, a));
}
var _baseIsEqualDeep = baseIsEqualDeep;
function baseIsEqual(e, t, r, n, o) {
  return e === t || (null == e || null == t || !isObjectLike_1(e) && !isObjectLike_1(t) ? e != e && t != t : _baseIsEqualDeep(e, t, r, n, baseIsEqual, o));
}
var _baseIsEqual = baseIsEqual,
  COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;
function baseIsMatch(e, t, r, n) {
  var o = r.length,
    a = o,
    i = !n;
  if (null == e) return !a;
  for (e = Object(e); o--;) {
    var s = r[o];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
  }
  for (; ++o < a;) {
    var c = (s = r[o])[0],
      u = e[c],
      l = s[1];
    if (i && s[2]) {
      if (void 0 === u && !(c in e)) return !1;
    } else {
      var f = new _Stack();
      if (n) var p = n(u, l, c, e, t, f);
      if (!(void 0 === p ? _baseIsEqual(l, u, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, n, f) : p)) return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch;
function isStrictComparable(e) {
  return e == e && !isObject_1(e);
}
var _isStrictComparable = isStrictComparable;
function getMatchData(e) {
  for (var t = keys_1(e), r = t.length; r--;) {
    var n = t[r],
      o = e[n];
    t[r] = [n, o, _isStrictComparable(o)];
  }
  return t;
}
var _getMatchData = getMatchData;
function matchesStrictComparable(e, t) {
  return function (r) {
    return null != r && r[e] === t && (void 0 !== t || e in Object(r));
  };
}
var _matchesStrictComparable = matchesStrictComparable;
function baseMatches(e) {
  var t = _getMatchData(e);
  return 1 == t.length && t[0][2] ? _matchesStrictComparable(t[0][0], t[0][1]) : function (r) {
    return r === e || _baseIsMatch(r, e, t);
  };
}
var _baseMatches = baseMatches;
function get$6(e, t, r) {
  var n = null == e ? void 0 : _baseGet(e, t);
  return void 0 === n ? r : n;
}
var get_1 = get$6,
  COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;
function baseMatchesProperty(e, t) {
  return _isKey(e) && _isStrictComparable(t) ? _matchesStrictComparable(_toKey(e), t) : function (r) {
    var n = get_1(r, e);
    return void 0 === n && n === t ? hasIn_1(r, e) : _baseIsEqual(t, n, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}
var _baseMatchesProperty = baseMatchesProperty;
function baseProperty(e) {
  return function (t) {
    return null == t ? void 0 : t[e];
  };
}
var _baseProperty = baseProperty;
function basePropertyDeep(e) {
  return function (t) {
    return _baseGet(t, e);
  };
}
var _basePropertyDeep = basePropertyDeep;
function property(e) {
  return _isKey(e) ? _baseProperty(_toKey(e)) : _basePropertyDeep(e);
}
var property_1 = property;
function baseIteratee(e) {
  return "function" == typeof e ? e : null == e ? identity_1 : "object" == typeof e ? isArray_1(e) ? _baseMatchesProperty(e[0], e[1]) : _baseMatches(e) : property_1(e);
}
var _baseIteratee = baseIteratee;
function createFind(e) {
  return function (t, r, n) {
    var o = Object(t);
    if (!isArrayLike_1(t)) {
      var a = _baseIteratee(r);
      t = keys_1(t), r = function (e) {
        return a(o[e], e, o);
      };
    }
    var i = e(t, r, n);
    return i > -1 ? o[a ? t[i] : i] : void 0;
  };
}
var _createFind = createFind;
function baseFindIndex(e, t, r, n) {
  for (var o = e.length, a = r + (n ? 1 : -1); n ? a-- : ++a < o;) if (t(e[a], a, e)) return a;
  return -1;
}
var _baseFindIndex = baseFindIndex,
  nativeMax$1 = Math.max;
function findIndex(e, t, r) {
  var n = null == e ? 0 : e.length;
  if (!n) return -1;
  var o = null == r ? 0 : toInteger_1(r);
  return o < 0 && (o = nativeMax$1(n + o, 0)), _baseFindIndex(e, _baseIteratee(t), o);
}
var findIndex_1 = findIndex,
  find$3 = _createFind(findIndex_1),
  find_1$1 = find$3;
function noop() {}
var noop_1 = noop,
  __extends = function () {
    var _e = function e(t, r) {
      return _e = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
      }, _e(t, r);
    };
    return function (t, r) {
      function n() {
        this.constructor = t;
      }
      _e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }(),
  _hasOwnProperty$4 = Object.prototype.hasOwnProperty;
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017 Joachim Wester
 * MIT license
 */
function hasOwnProperty$d(e, t) {
  return _hasOwnProperty$4.call(e, t);
}
function _objectKeys(e) {
  if (Array.isArray(e)) {
    for (var t = new Array(e.length), r = 0; r < t.length; r++) t[r] = "" + r;
    return t;
  }
  if (Object.keys) return Object.keys(e);
  t = [];
  for (var n in e) hasOwnProperty$d(e, n) && t.push(n);
  return t;
}
function _deepClone(e) {
  switch (typeof e) {
    case "object":
      return JSON.parse(JSON.stringify(e));
    case "undefined":
      return null;
    default:
      return e;
  }
}
function isInteger$1(e) {
  for (var t, r = 0, n = e.length; r < n;) {
    if (!((t = e.charCodeAt(r)) >= 48 && t <= 57)) return !1;
    r++;
  }
  return !0;
}
function escapePathComponent(e) {
  return -1 === e.indexOf("/") && -1 === e.indexOf("~") ? e : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapePathComponent(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
function hasUndefined(e) {
  if (void 0 === e) return !0;
  if (e) if (Array.isArray(e)) {
    for (var t = 0, r = e.length; t < r; t++) if (hasUndefined(e[t])) return !0;
  } else if ("object" == typeof e) {
    var n = _objectKeys(e),
      o = n.length;
    for (t = 0; t < o; t++) if (hasUndefined(e[n[t]])) return !0;
  }
  return !1;
}
function patchErrorMessageFormatter(e, t) {
  var r = [e];
  for (var n in t) {
    var o = "object" == typeof t[n] ? JSON.stringify(t[n], null, 2) : t[n];
    void 0 !== o && r.push(n + ": " + o);
  }
  return r.join("\n");
}
var PatchError = function (e) {
    function t(t, r, n, o, a) {
      var i = this.constructor,
        s = e.call(this, patchErrorMessageFormatter(t, {
          name: r,
          index: n,
          operation: o,
          tree: a
        })) || this;
      return s.name = r, s.index = n, s.operation = o, s.tree = a, Object.setPrototypeOf(s, i.prototype), s.message = patchErrorMessageFormatter(t, {
        name: r,
        index: n,
        operation: o,
        tree: a
      }), s;
    }
    return __extends(t, e), t;
  }(Error),
  JsonPatchError = PatchError,
  deepClone = _deepClone,
  objOps = {
    add: function (e, t, r) {
      return e[t] = this.value, {
        newDocument: r
      };
    },
    remove: function (e, t, r) {
      var n = e[t];
      return delete e[t], {
        newDocument: r,
        removed: n
      };
    },
    replace: function (e, t, r) {
      var n = e[t];
      return e[t] = this.value, {
        newDocument: r,
        removed: n
      };
    },
    move: function (e, t, r) {
      var n = getValueByPointer(r, this.path);
      n && (n = _deepClone(n));
      var o = applyOperation(r, {
        op: "remove",
        path: this.from
      }).removed;
      return applyOperation(r, {
        op: "add",
        path: this.path,
        value: o
      }), {
        newDocument: r,
        removed: n
      };
    },
    copy: function (e, t, r) {
      var n = getValueByPointer(r, this.from);
      return applyOperation(r, {
        op: "add",
        path: this.path,
        value: _deepClone(n)
      }), {
        newDocument: r
      };
    },
    test: function (e, t, r) {
      return {
        newDocument: r,
        test: _areEquals(e[t], this.value)
      };
    },
    _get: function (e, t, r) {
      return this.value = e[t], {
        newDocument: r
      };
    }
  },
  arrOps = {
    add: function (e, t, r) {
      return isInteger$1(t) ? e.splice(t, 0, this.value) : e[t] = this.value, {
        newDocument: r,
        index: t
      };
    },
    remove: function (e, t, r) {
      return {
        newDocument: r,
        removed: e.splice(t, 1)[0]
      };
    },
    replace: function (e, t, r) {
      var n = e[t];
      return e[t] = this.value, {
        newDocument: r,
        removed: n
      };
    },
    move: objOps.move,
    copy: objOps.copy,
    test: objOps.test,
    _get: objOps._get
  };
function getValueByPointer(e, t) {
  if ("" == t) return e;
  var r = {
    op: "_get",
    path: t
  };
  return applyOperation(e, r), r.value;
}
function applyOperation(e, t, r, n, o, a) {
  if (void 0 === r && (r = !1), void 0 === n && (n = !0), void 0 === o && (o = !0), void 0 === a && (a = 0), r && ("function" == typeof r ? r(t, 0, e, t.path) : validator(t, 0)), "" === t.path) {
    var i = {
      newDocument: e
    };
    if ("add" === t.op) return i.newDocument = t.value, i;
    if ("replace" === t.op) return i.newDocument = t.value, i.removed = e, i;
    if ("move" === t.op || "copy" === t.op) return i.newDocument = getValueByPointer(e, t.from), "move" === t.op && (i.removed = e), i;
    if ("test" === t.op) {
      if (i.test = _areEquals(e, t.value), !1 === i.test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
      return i.newDocument = e, i;
    }
    if ("remove" === t.op) return i.removed = e, i.newDocument = null, i;
    if ("_get" === t.op) return t.value = e, i;
    if (r) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", a, t, e);
    return i;
  }
  n || (e = _deepClone(e));
  var s = (t.path || "").split("/"),
    c = e,
    u = 1,
    l = s.length,
    f = void 0,
    p = void 0,
    h = void 0;
  for (h = "function" == typeof r ? r : validator;;) {
    if (p = s[u], o && "__proto__" == p) throw new TypeError("JSON-Patch: modifying `__proto__` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
    if (r && void 0 === f && (void 0 === c[p] ? f = s.slice(0, u).join("/") : u == l - 1 && (f = t.path), void 0 !== f && h(t, 0, e, f)), u++, Array.isArray(c)) {
      if ("-" === p) p = c.length;else {
        if (r && !isInteger$1(p)) throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", a, t, e);
        isInteger$1(p) && (p = ~~p);
      }
      if (u >= l) {
        if (r && "add" === t.op && p > c.length) throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", a, t, e);
        if (!1 === (i = arrOps[t.op].call(t, c, p, e)).test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
        return i;
      }
    } else if (p && -1 != p.indexOf("~") && (p = unescapePathComponent(p)), u >= l) {
      if (!1 === (i = objOps[t.op].call(t, c, p, e)).test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
      return i;
    }
    c = c[p];
  }
}
function applyPatch(e, t, r, n, o) {
  if (void 0 === n && (n = !0), void 0 === o && (o = !0), r && !Array.isArray(t)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  n || (e = _deepClone(e));
  for (var a = new Array(t.length), i = 0, s = t.length; i < s; i++) a[i] = applyOperation(e, t[i], r, !0, o, i), e = a[i].newDocument;
  return a.newDocument = e, a;
}
function applyReducer(e, t, r) {
  var n = applyOperation(e, t);
  if (!1 === n.test) throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", r, t, e);
  return n.newDocument;
}
function validator(e, t, r, n) {
  if ("object" != typeof e || null === e || Array.isArray(e)) throw new JsonPatchError("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, e, r);
  if (!objOps[e.op]) throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, e, r);
  if ("string" != typeof e.path) throw new JsonPatchError("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, e, r);
  if (0 !== e.path.indexOf("/") && e.path.length > 0) throw new JsonPatchError('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", t, e, r);
  if (("move" === e.op || "copy" === e.op) && "string" != typeof e.from) throw new JsonPatchError("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, e, r);
  if (("add" === e.op || "replace" === e.op || "test" === e.op) && void 0 === e.value) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, e, r);
  if (("add" === e.op || "replace" === e.op || "test" === e.op) && hasUndefined(e.value)) throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, e, r);
  if (r) if ("add" == e.op) {
    var o = e.path.split("/").length,
      a = n.split("/").length;
    if (o !== a + 1 && o !== a) throw new JsonPatchError("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, e, r);
  } else if ("replace" === e.op || "remove" === e.op || "_get" === e.op) {
    if (e.path !== n) throw new JsonPatchError("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, e, r);
  } else if ("move" === e.op || "copy" === e.op) {
    var i = validate([{
      op: "_get",
      path: e.from,
      value: void 0
    }], r);
    if (i && "OPERATION_PATH_UNRESOLVABLE" === i.name) throw new JsonPatchError("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, e, r);
  }
}
function validate(e, t, r) {
  try {
    if (!Array.isArray(e)) throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (t) applyPatch(_deepClone(t), _deepClone(e), r || !0);else {
      r = r || validator;
      for (var n = 0; n < e.length; n++) r(e[n], n, t, void 0);
    }
  } catch (e) {
    if (e instanceof JsonPatchError) return e;
    throw e;
  }
}
function _areEquals(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    var r,
      n,
      o,
      a = Array.isArray(e),
      i = Array.isArray(t);
    if (a && i) {
      if ((n = e.length) != t.length) return !1;
      for (r = n; 0 != r--;) if (!_areEquals(e[r], t[r])) return !1;
      return !0;
    }
    if (a != i) return !1;
    var s = Object.keys(e);
    if ((n = s.length) !== Object.keys(t).length) return !1;
    for (r = n; 0 != r--;) if (!t.hasOwnProperty(s[r])) return !1;
    for (r = n; 0 != r--;) if (!_areEquals(e[o = s[r]], t[o])) return !1;
    return !0;
  }
  return e != e && t != t;
}
var core$1 = Object.freeze({
    __proto__: null,
    JsonPatchError: JsonPatchError,
    deepClone: deepClone,
    getValueByPointer: getValueByPointer,
    applyOperation: applyOperation,
    applyPatch: applyPatch,
    applyReducer: applyReducer,
    validator: validator,
    validate: validate,
    _areEquals: _areEquals
  }),
  beforeDict = new WeakMap(),
  Mirror = function Mirror(e) {
    this.observers = new Map(), this.obj = e;
  },
  ObserverInfo = function ObserverInfo(e, t) {
    this.callback = e, this.observer = t;
  };
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017 Joachim Wester
 * MIT license
 */
function getMirror(e) {
  return beforeDict.get(e);
}
function getObserverFromMirror(e, t) {
  return e.observers.get(t);
}
function removeObserverFromMirror(e, t) {
  e.observers.delete(t.callback);
}
function unobserve(e, t) {
  t.unobserve();
}
function observe(e, t) {
  var r,
    n = getMirror(e);
  if (n) {
    var o = getObserverFromMirror(n, t);
    r = o && o.observer;
  } else n = new Mirror(e), beforeDict.set(e, n);
  if (r) return r;
  if (r = {}, n.value = _deepClone(e), t) {
    r.callback = t, r.next = null;
    var a = function a() {
        generate(r);
      },
      i = function i() {
        clearTimeout(r.next), r.next = setTimeout(a);
      };
    "undefined" != typeof window && (window.addEventListener("mouseup", i), window.addEventListener("keyup", i), window.addEventListener("mousedown", i), window.addEventListener("keydown", i), window.addEventListener("change", i));
  }
  return r.patches = [], r.object = e, r.unobserve = function () {
    generate(r), clearTimeout(r.next), removeObserverFromMirror(n, r), "undefined" != typeof window && (window.removeEventListener("mouseup", i), window.removeEventListener("keyup", i), window.removeEventListener("mousedown", i), window.removeEventListener("keydown", i), window.removeEventListener("change", i));
  }, n.observers.set(t, new ObserverInfo(t, r)), r;
}
function generate(e, t) {
  void 0 === t && (t = !1);
  var r = beforeDict.get(e.object);
  _generate(r.value, e.object, e.patches, "", t), e.patches.length && applyPatch(r.value, e.patches);
  var n = e.patches;
  return n.length > 0 && (e.patches = [], e.callback && e.callback(n)), n;
}
function _generate(e, t, r, n, o) {
  if (t !== e) {
    "function" == typeof t.toJSON && (t = t.toJSON());
    for (var a = _objectKeys(t), i = _objectKeys(e), s = !1, c = i.length - 1; c >= 0; c--) {
      var u = e[f = i[c]];
      if (!hasOwnProperty$d(t, f) || void 0 === t[f] && void 0 !== u && !1 === Array.isArray(t)) Array.isArray(e) === Array.isArray(t) ? (o && r.push({
        op: "test",
        path: n + "/" + escapePathComponent(f),
        value: _deepClone(u)
      }), r.push({
        op: "remove",
        path: n + "/" + escapePathComponent(f)
      }), s = !0) : (o && r.push({
        op: "test",
        path: n,
        value: e
      }), r.push({
        op: "replace",
        path: n,
        value: t
      }));else {
        var l = t[f];
        "object" == typeof u && null != u && "object" == typeof l && null != l ? _generate(u, l, r, n + "/" + escapePathComponent(f), o) : u !== l && (o && r.push({
          op: "test",
          path: n + "/" + escapePathComponent(f),
          value: _deepClone(u)
        }), r.push({
          op: "replace",
          path: n + "/" + escapePathComponent(f),
          value: _deepClone(l)
        }));
      }
    }
    if (s || a.length != i.length) for (c = 0; c < a.length; c++) {
      var f;
      hasOwnProperty$d(e, f = a[c]) || void 0 === t[f] || r.push({
        op: "add",
        path: n + "/" + escapePathComponent(f),
        value: _deepClone(t[f])
      });
    }
  }
}
function compare(e, t, r) {
  void 0 === r && (r = !1);
  var n = [];
  return _generate(e, t, n, "", r), n;
}
var duplex = Object.freeze({
  __proto__: null,
  unobserve: unobserve,
  observe: observe,
  generate: generate,
  compare: compare
});
Object.assign({}, core$1, duplex, {
  JsonPatchError: PatchError,
  deepClone: _deepClone,
  escapePathComponent: escapePathComponent,
  unescapePathComponent: unescapePathComponent
});
var deepExtend_1 = createCommonjsModule(function (e) {
  function t(e) {
    return e instanceof Buffer || e instanceof Date || e instanceof RegExp;
  }
  function r(e) {
    if (e instanceof Buffer) {
      var t = Buffer.alloc ? Buffer.alloc(e.length) : new Buffer(e.length);
      return e.copy(t), t;
    }
    if (e instanceof Date) return new Date(e.getTime());
    if (e instanceof RegExp) return new RegExp(e);
    throw new Error("Unexpected situation");
  }
  function n(e) {
    var o = [];
    return e.forEach(function (e, i) {
      "object" == typeof e && null !== e ? Array.isArray(e) ? o[i] = n(e) : t(e) ? o[i] = r(e) : o[i] = a({}, e) : o[i] = e;
    }), o;
  }
  function o(e, t) {
    return "__proto__" === t ? void 0 : e[t];
  }
  var a = e.exports = function () {
    if (arguments.length < 1 || "object" != typeof arguments[0]) return !1;
    if (arguments.length < 2) return arguments[0];
    var e,
      i,
      s = arguments[0];
    return Array.prototype.slice.call(arguments, 1).forEach(function (c) {
      "object" != typeof c || null === c || Array.isArray(c) || Object.keys(c).forEach(function (u) {
        return i = o(s, u), (e = o(c, u)) === s ? void 0 : "object" != typeof e || null === e ? void (s[u] = e) : Array.isArray(e) ? void (s[u] = n(e)) : t(e) ? void (s[u] = r(e)) : "object" != typeof i || null === i || Array.isArray(i) ? void (s[u] = a({}, e)) : void (s[u] = a(i, e));
      });
    }), s;
  };
});
function arrayEach(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e););
  return e;
}
var _arrayEach = arrayEach;
function baseAssign(e, t) {
  return e && _copyObject(t, keys_1(t), e);
}
var _baseAssign = baseAssign;
function nativeKeysIn(e) {
  var t = [];
  if (null != e) for (var r in Object(e)) t.push(r);
  return t;
}
var _nativeKeysIn = nativeKeysIn,
  objectProto$e = Object.prototype,
  hasOwnProperty$e = objectProto$e.hasOwnProperty;
function baseKeysIn(e) {
  if (!isObject_1(e)) return _nativeKeysIn(e);
  var t = _isPrototype(e),
    r = [];
  for (var n in e) ("constructor" != n || !t && hasOwnProperty$e.call(e, n)) && r.push(n);
  return r;
}
var _baseKeysIn = baseKeysIn;
function keysIn(e) {
  return isArrayLike_1(e) ? _arrayLikeKeys(e, !0) : _baseKeysIn(e);
}
var keysIn_1 = keysIn;
function baseAssignIn(e, t) {
  return e && _copyObject(t, keysIn_1(t), e);
}
var _baseAssignIn = baseAssignIn,
  _cloneBuffer = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
      n = r && e && !e.nodeType && e,
      o = n && n.exports === r ? _root.Buffer : void 0,
      a = o ? o.allocUnsafe : void 0;
    e.exports = function (e, t) {
      if (t) return e.slice();
      var r = e.length,
        n = a ? a(r) : new e.constructor(r);
      return e.copy(n), n;
    };
  });
function copyArray(e, t) {
  var r = -1,
    n = e.length;
  for (t || (t = Array(n)); ++r < n;) t[r] = e[r];
  return t;
}
var _copyArray = copyArray;
function copySymbols(e, t) {
  return _copyObject(e, _getSymbols(e), t);
}
var _copySymbols = copySymbols,
  getPrototype = _overArg(Object.getPrototypeOf, Object),
  _getPrototype = getPrototype,
  nativeGetSymbols$1 = Object.getOwnPropertySymbols,
  getSymbolsIn = nativeGetSymbols$1 ? function (e) {
    for (var t = []; e;) _arrayPush(t, _getSymbols(e)), e = _getPrototype(e);
    return t;
  } : stubArray_1,
  _getSymbolsIn = getSymbolsIn;
function copySymbolsIn(e, t) {
  return _copyObject(e, _getSymbolsIn(e), t);
}
var _copySymbolsIn = copySymbolsIn;
function getAllKeysIn(e) {
  return _baseGetAllKeys(e, keysIn_1, _getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn,
  objectProto$f = Object.prototype,
  hasOwnProperty$f = objectProto$f.hasOwnProperty;
function initCloneArray(e) {
  var t = e.length,
    r = new e.constructor(t);
  return t && "string" == typeof e[0] && hasOwnProperty$f.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var _initCloneArray = initCloneArray;
function cloneArrayBuffer(e) {
  var t = new e.constructor(e.byteLength);
  return new _Uint8Array(t).set(new _Uint8Array(e)), t;
}
var _cloneArrayBuffer = cloneArrayBuffer;
function cloneDataView(e, t) {
  var r = t ? _cloneArrayBuffer(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var _cloneDataView = cloneDataView,
  reFlags = /\w*$/;
function cloneRegExp(e) {
  var t = new e.constructor(e.source, reFlags.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var _cloneRegExp = cloneRegExp,
  symbolProto$2 = _Symbol ? _Symbol.prototype : void 0,
  symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function cloneSymbol(e) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(e)) : {};
}
var _cloneSymbol = cloneSymbol;
function cloneTypedArray(e, t) {
  var r = t ? _cloneArrayBuffer(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var _cloneTypedArray = cloneTypedArray,
  boolTag$2 = "[object Boolean]",
  dateTag$2 = "[object Date]",
  mapTag$3 = "[object Map]",
  numberTag$2 = "[object Number]",
  regexpTag$2 = "[object RegExp]",
  setTag$3 = "[object Set]",
  stringTag$2 = "[object String]",
  symbolTag$2 = "[object Symbol]",
  arrayBufferTag$2 = "[object ArrayBuffer]",
  dataViewTag$3 = "[object DataView]",
  float32Tag$1 = "[object Float32Array]",
  float64Tag$1 = "[object Float64Array]",
  int8Tag$1 = "[object Int8Array]",
  int16Tag$1 = "[object Int16Array]",
  int32Tag$1 = "[object Int32Array]",
  uint8Tag$1 = "[object Uint8Array]",
  uint8ClampedTag$1 = "[object Uint8ClampedArray]",
  uint16Tag$1 = "[object Uint16Array]",
  uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case arrayBufferTag$2:
      return _cloneArrayBuffer(e);
    case boolTag$2:
    case dateTag$2:
      return new n(+e);
    case dataViewTag$3:
      return _cloneDataView(e, r);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(e, r);
    case mapTag$3:
      return new n();
    case numberTag$2:
    case stringTag$2:
      return new n(e);
    case regexpTag$2:
      return _cloneRegExp(e);
    case setTag$3:
      return new n();
    case symbolTag$2:
      return _cloneSymbol(e);
  }
}
var _initCloneByTag = initCloneByTag,
  objectCreate$1 = Object.create,
  baseCreate = function () {
    function e() {}
    return function (t) {
      if (!isObject_1(t)) return {};
      if (objectCreate$1) return objectCreate$1(t);
      e.prototype = t;
      var r = new e();
      return e.prototype = void 0, r;
    };
  }(),
  _baseCreate = baseCreate;
function initCloneObject(e) {
  return "function" != typeof e.constructor || _isPrototype(e) ? {} : _baseCreate(_getPrototype(e));
}
var _initCloneObject = initCloneObject,
  mapTag$4 = "[object Map]";
function baseIsMap(e) {
  return isObjectLike_1(e) && _getTag(e) == mapTag$4;
}
var _baseIsMap = baseIsMap,
  nodeIsMap = _nodeUtil && _nodeUtil.isMap,
  isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap,
  isMap_1 = isMap,
  setTag$4 = "[object Set]";
function baseIsSet(e) {
  return isObjectLike_1(e) && _getTag(e) == setTag$4;
}
var _baseIsSet = baseIsSet,
  nodeIsSet = _nodeUtil && _nodeUtil.isSet,
  isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet,
  isSet_1 = isSet,
  CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4,
  argsTag$3 = "[object Arguments]",
  arrayTag$2 = "[object Array]",
  boolTag$3 = "[object Boolean]",
  dateTag$3 = "[object Date]",
  errorTag$2 = "[object Error]",
  funcTag$2 = "[object Function]",
  genTag$1 = "[object GeneratorFunction]",
  mapTag$5 = "[object Map]",
  numberTag$3 = "[object Number]",
  objectTag$3 = "[object Object]",
  regexpTag$3 = "[object RegExp]",
  setTag$5 = "[object Set]",
  stringTag$3 = "[object String]",
  symbolTag$3 = "[object Symbol]",
  weakMapTag$2 = "[object WeakMap]",
  arrayBufferTag$3 = "[object ArrayBuffer]",
  dataViewTag$4 = "[object DataView]",
  float32Tag$2 = "[object Float32Array]",
  float64Tag$2 = "[object Float64Array]",
  int8Tag$2 = "[object Int8Array]",
  int16Tag$2 = "[object Int16Array]",
  int32Tag$2 = "[object Int32Array]",
  uint8Tag$2 = "[object Uint8Array]",
  uint8ClampedTag$2 = "[object Uint8ClampedArray]",
  uint16Tag$2 = "[object Uint16Array]",
  uint32Tag$2 = "[object Uint32Array]",
  cloneableTags = {};
function baseClone(e, t, r, n, o, a) {
  var i,
    s = t & CLONE_DEEP_FLAG,
    c = t & CLONE_FLAT_FLAG,
    u = t & CLONE_SYMBOLS_FLAG;
  if (r && (i = o ? r(e, n, o, a) : r(e)), void 0 !== i) return i;
  if (!isObject_1(e)) return e;
  var l = isArray_1(e);
  if (l) {
    if (i = _initCloneArray(e), !s) return _copyArray(e, i);
  } else {
    var f = _getTag(e),
      p = f == funcTag$2 || f == genTag$1;
    if (isBuffer_1(e)) return _cloneBuffer(e, s);
    if (f == objectTag$3 || f == argsTag$3 || p && !o) {
      if (i = c || p ? {} : _initCloneObject(e), !s) return c ? _copySymbolsIn(e, _baseAssignIn(i, e)) : _copySymbols(e, _baseAssign(i, e));
    } else {
      if (!cloneableTags[f]) return o ? e : {};
      i = _initCloneByTag(e, f, s);
    }
  }
  a || (a = new _Stack());
  var h = a.get(e);
  if (h) return h;
  a.set(e, i), isSet_1(e) ? e.forEach(function (n) {
    i.add(baseClone(n, t, r, n, e, a));
  }) : isMap_1(e) && e.forEach(function (n, o) {
    i.set(o, baseClone(n, t, r, o, e, a));
  });
  var y = l ? void 0 : (u ? c ? _getAllKeysIn : _getAllKeys : c ? keysIn_1 : keys_1)(e);
  return _arrayEach(y || e, function (n, o) {
    y && (n = e[o = n]), _assignValue(i, o, baseClone(n, t, r, o, e, a));
  }), i;
}
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$3] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$5] = cloneableTags[numberTag$3] = cloneableTags[objectTag$3] = cloneableTags[regexpTag$3] = cloneableTags[setTag$5] = cloneableTags[stringTag$3] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = !0, cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = !1;
var _baseClone = baseClone,
  CLONE_DEEP_FLAG$1 = 1,
  CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(e) {
  return _baseClone(e, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var cloneDeep_1 = cloneDeep,
  lib$1 = {
    add: add,
    replace: replace$1,
    remove: remove,
    merge: merge$2,
    mergeDeep: mergeDeep,
    context: context,
    getIn: getIn,
    applyPatch: applyPatch$1,
    parentPathMatch: parentPathMatch,
    flatten: flatten$1,
    fullyNormalizeArray: fullyNormalizeArray,
    normalizeArray: normalizeArray,
    isPromise: isPromise,
    forEachNew: forEachNew,
    forEachNewPrimitive: forEachNewPrimitive,
    isJsonPatch: isJsonPatch,
    isContextPatch: isContextPatch,
    isPatch: isPatch,
    isMutation: isMutation,
    isAdditiveMutation: isAdditiveMutation,
    isGenerator: isGenerator,
    isFunction: isFunction$2,
    isObject: isObject$4,
    isError: isError
  };
function applyPatch$1(e, t, r) {
  if (r = r || {}, "merge" === (t = objectSpread2(objectSpread2({}, t), {}, {
    path: t.path && normalizeJSONPath(t.path)
  })).op) {
    var n = getInByJsonPath(e, t.path);
    assign$4(n, t.value), applyPatch(e, [replace$1(t.path, n)]);
  } else if ("mergeDeep" === t.op) {
    var o = getInByJsonPath(e, t.path);
    for (var a in t.value) {
      var i = t.value[a],
        s = isArray$8(i);
      if (s) {
        var c = o[a] || [];
        o[a] = concat$2(c).call(c, i);
      } else if (isObject$4(i) && !s) {
        var u = objectSpread2({}, o[a]);
        for (var l in i) {
          if (Object.prototype.hasOwnProperty.call(u, l)) {
            u = deepExtend_1(cloneDeep_1(u), i);
            break;
          }
          assign$4(u, defineProperty$5({}, l, i[l]));
        }
        o[a] = u;
      } else o[a] = i;
    }
  } else if ("add" === t.op && "" === t.path && isObject$4(t.value)) {
    var f,
      p = reduce$2(f = keys$6(t.value)).call(f, function (e, r) {
        return e.push({
          op: "add",
          path: "/".concat(normalizeJSONPath(r)),
          value: t.value[r]
        }), e;
      }, []);
    applyPatch(e, p);
  } else if ("replace" === t.op && "" === t.path) {
    var h = t.value;
    r.allowMetaPatches && t.meta && isAdditiveMutation(t) && (isArray$8(t.value) || isObject$4(t.value)) && (h = objectSpread2(objectSpread2({}, h), t.meta)), e = h;
  } else if (applyPatch(e, [t]), r.allowMetaPatches && t.meta && isAdditiveMutation(t) && (isArray$8(t.value) || isObject$4(t.value))) {
    var y = getInByJsonPath(e, t.path),
      d = objectSpread2(objectSpread2({}, y), t.meta);
    applyPatch(e, [replace$1(t.path, d)]);
  }
  return e;
}
function normalizeJSONPath(e) {
  return isArray$8(e) ? e.length < 1 ? "" : "/".concat(map$4(e).call(e, function (e) {
    return (e + "").replace(/~/g, "~0").replace(/\//g, "~1");
  }).join("/")) : e;
}
function add(e, t) {
  return {
    op: "add",
    path: e,
    value: t
  };
}
function replace$1(e, t, r) {
  return {
    op: "replace",
    path: e,
    value: t,
    meta: r
  };
}
function remove(e) {
  return {
    op: "remove",
    path: e
  };
}
function merge$2(e, t) {
  return {
    type: "mutation",
    op: "merge",
    path: e,
    value: t
  };
}
function mergeDeep(e, t) {
  return {
    type: "mutation",
    op: "mergeDeep",
    path: e,
    value: t
  };
}
function context(e, t) {
  return {
    type: "context",
    path: e,
    value: t
  };
}
function forEachNew(e, t) {
  try {
    return forEachNewPatch(e, forEach$5, t);
  } catch (e) {
    return e;
  }
}
function forEachNewPrimitive(e, t) {
  try {
    return forEachNewPatch(e, forEachPrimitive, t);
  } catch (e) {
    return e;
  }
}
function forEachNewPatch(e, t, r) {
  var n;
  return cleanArray(flatten$1(map$4(n = filter$4(e).call(e, isAdditiveMutation)).call(n, function (e) {
    return t(e.value, r, e.path);
  }) || []));
}
function forEachPrimitive(e, t, r) {
  return r = r || [], isArray$8(e) ? map$4(e).call(e, function (e, n) {
    return forEachPrimitive(e, t, concat$2(r).call(r, n));
  }) : isObject$4(e) ? map$4(n = keys$6(e)).call(n, function (n) {
    return forEachPrimitive(e[n], t, concat$2(r).call(r, n));
  }) : t(e, r[r.length - 1], r);
  var n;
}
function forEach$5(e, t, r) {
  var n = [];
  if ((r = r || []).length > 0) {
    var o = t(e, r[r.length - 1], r);
    o && (n = concat$2(n).call(n, o));
  }
  if (isArray$8(e)) {
    var a = map$4(e).call(e, function (e, n) {
      return forEach$5(e, t, concat$2(r).call(r, n));
    });
    a && (n = concat$2(n).call(n, a));
  } else if (isObject$4(e)) {
    var i,
      s = map$4(i = keys$6(e)).call(i, function (n) {
        return forEach$5(e[n], t, concat$2(r).call(r, n));
      });
    s && (n = concat$2(n).call(n, s));
  }
  return n = flatten$1(n);
}
function parentPathMatch(e, t) {
  if (!isArray$8(t)) return !1;
  for (var r = 0, n = t.length; r < n; r += 1) if (t[r] !== e[r]) return !1;
  return !0;
}
function getIn(e, t) {
  return reduce$2(t).call(t, function (e, t) {
    return void 0 !== t && e ? e[t] : e;
  }, e);
}
function fullyNormalizeArray(e) {
  return cleanArray(flatten$1(normalizeArray(e)));
}
function normalizeArray(e) {
  return isArray$8(e) ? e : [e];
}
function flatten$1(e) {
  var t, r, n;
  return (r = concat$2(t = [])).call.apply(r, concat$2(n = [t]).call(n, toConsumableArray(map$4(e).call(e, function (e) {
    return isArray$8(e) ? flatten$1(e) : e;
  }))));
}
function cleanArray(e) {
  return filter$4(e).call(e, function (e) {
    return void 0 !== e;
  });
}
function isObject$4(e) {
  return e && "object" === _typeof_1(e);
}
function isPromise(e) {
  return isObject$4(e) && isFunction$2(e.then);
}
function isFunction$2(e) {
  return e && "function" == typeof e;
}
function isError(e) {
  return e instanceof Error;
}
function isJsonPatch(e) {
  if (isPatch(e)) {
    var t = e.op;
    return "add" === t || "remove" === t || "replace" === t;
  }
  return !1;
}
function isGenerator(e) {
  return "[object GeneratorFunction]" === Object.prototype.toString.call(e);
}
function isMutation(e) {
  return isJsonPatch(e) || isPatch(e) && "mutation" === e.type;
}
function isAdditiveMutation(e) {
  return isMutation(e) && ("add" === e.op || "replace" === e.op || "merge" === e.op || "mergeDeep" === e.op);
}
function isContextPatch(e) {
  return isPatch(e) && "context" === e.type;
}
function isPatch(e) {
  return e && "object" === _typeof_1(e);
}
function getInByJsonPath(e, t) {
  try {
    return getValueByPointer(e, t);
  } catch (e) {
    return console.error(e), {};
  }
}
var freezing = !fails(function () {
    return Object.isExtensible(Object.preventExtensions({}));
  }),
  internalMetadata = createCommonjsModule(function (e) {
    var t = objectDefineProperty.f,
      r = uid("meta"),
      n = 0,
      o = Object.isExtensible || function () {
        return !0;
      },
      a = function a(e) {
        t(e, r, {
          value: {
            objectID: "O" + ++n,
            weakData: {}
          }
        });
      },
      i = e.exports = {
        REQUIRED: !1,
        fastKey: function (e, t) {
          if (!isObject(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
          if (!has(e, r)) {
            if (!o(e)) return "F";
            if (!t) return "E";
            a(e);
          }
          return e[r].objectID;
        },
        getWeakData: function (e, t) {
          if (!has(e, r)) {
            if (!o(e)) return !0;
            if (!t) return !1;
            a(e);
          }
          return e[r].weakData;
        },
        onFreeze: function (e) {
          return freezing && i.REQUIRED && o(e) && !has(e, r) && a(e), e;
        }
      };
    hiddenKeys[r] = !0;
  }),
  defineProperty$8 = objectDefineProperty.f,
  forEach$6 = arrayIteration.forEach,
  setInternalState$4 = internalState.set,
  internalStateGetterFor = internalState.getterFor,
  collection = function collection(e, t, r) {
    var n,
      o = -1 !== e.indexOf("Map"),
      a = -1 !== e.indexOf("Weak"),
      i = o ? "set" : "add",
      s = global$1[e],
      c = s && s.prototype,
      u = {};
    if (descriptors && "function" == typeof s && (a || c.forEach && !fails(function () {
      new s().entries().next();
    }))) {
      n = t(function (t, r) {
        setInternalState$4(anInstance(t, n, e), {
          type: e,
          collection: new s()
        }), null != r && iterate(r, t[i], {
          that: t,
          AS_ENTRIES: o
        });
      });
      var l = internalStateGetterFor(e);
      forEach$6(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (e) {
        var t = "add" == e || "set" == e;
        !(e in c) || a && "clear" == e || createNonEnumerableProperty(n.prototype, e, function (r, n) {
          var o = l(this).collection;
          if (!t && a && !isObject(r)) return "get" == e && void 0;
          var i = o[e](0 === r ? 0 : r, n);
          return t ? this : i;
        });
      }), a || defineProperty$8(n.prototype, "size", {
        configurable: !0,
        get: function () {
          return l(this).collection.size;
        }
      });
    } else n = r.getConstructor(t, e, o, i), internalMetadata.REQUIRED = !0;
    return setToStringTag(n, e, !1, !0), u[e] = n, _export({
      global: !0,
      forced: !0
    }, u), a || r.setStrong(n, e, o), n;
  },
  getWeakData = internalMetadata.getWeakData,
  setInternalState$5 = internalState.set,
  internalStateGetterFor$1 = internalState.getterFor,
  find$4 = arrayIteration.find,
  findIndex$1 = arrayIteration.findIndex,
  id$1 = 0,
  uncaughtFrozenStore = function uncaughtFrozenStore(e) {
    return e.frozen || (e.frozen = new UncaughtFrozenStore());
  },
  UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
  },
  findUncaughtFrozen = function findUncaughtFrozen(e, t) {
    return find$4(e.entries, function (e) {
      return e[0] === t;
    });
  };
UncaughtFrozenStore.prototype = {
  get: function (e) {
    var t = findUncaughtFrozen(this, e);
    if (t) return t[1];
  },
  has: function (e) {
    return !!findUncaughtFrozen(this, e);
  },
  set: function (e, t) {
    var r = findUncaughtFrozen(this, e);
    r ? r[1] = t : this.entries.push([e, t]);
  },
  delete: function (e) {
    var t = findIndex$1(this.entries, function (t) {
      return t[0] === e;
    });
    return ~t && this.entries.splice(t, 1), !!~t;
  }
};
var collectionWeak = {
  getConstructor: function (e, t, r, n) {
    var o = e(function (e, a) {
        anInstance(e, o, t), setInternalState$5(e, {
          type: t,
          id: id$1++,
          frozen: void 0
        }), null != a && iterate(a, e[n], {
          that: e,
          AS_ENTRIES: r
        });
      }),
      a = internalStateGetterFor$1(t),
      i = function i(e, t, r) {
        var n = a(e),
          o = getWeakData(anObject(t), !0);
        return !0 === o ? uncaughtFrozenStore(n).set(t, r) : o[n.id] = r, e;
      };
    return redefineAll(o.prototype, {
      delete: function (e) {
        var t = a(this);
        if (!isObject(e)) return !1;
        var r = getWeakData(e);
        return !0 === r ? uncaughtFrozenStore(t).delete(e) : r && has(r, t.id) && delete r[t.id];
      },
      has: function (e) {
        var t = a(this);
        if (!isObject(e)) return !1;
        var r = getWeakData(e);
        return !0 === r ? uncaughtFrozenStore(t).has(e) : r && has(r, t.id);
      }
    }), redefineAll(o.prototype, r ? {
      get: function (e) {
        var t = a(this);
        if (isObject(e)) {
          var r = getWeakData(e);
          return !0 === r ? uncaughtFrozenStore(t).get(e) : r ? r[t.id] : void 0;
        }
      },
      set: function (e, t) {
        return i(this, e, t);
      }
    } : {
      add: function (e) {
        return i(this, e, !0);
      }
    }), o;
  }
};
createCommonjsModule(function (e) {
  var t,
    r = internalState.enforce,
    n = !global$1.ActiveXObject && "ActiveXObject" in global$1,
    o = Object.isExtensible,
    a = function a(e) {
      return function () {
        return e(this, arguments.length ? arguments[0] : void 0);
      };
    },
    i = e.exports = collection("WeakMap", a, collectionWeak);
  if (nativeWeakMap && n) {
    t = collectionWeak.getConstructor(a, "WeakMap", !0), internalMetadata.REQUIRED = !0;
    var s = i.prototype,
      c = s.delete,
      u = s.has,
      l = s.get,
      f = s.set;
    redefineAll(s, {
      delete: function (e) {
        if (isObject(e) && !o(e)) {
          var n = r(this);
          return n.frozen || (n.frozen = new t()), c.call(this, e) || n.frozen.delete(e);
        }
        return c.call(this, e);
      },
      has: function (e) {
        if (isObject(e) && !o(e)) {
          var n = r(this);
          return n.frozen || (n.frozen = new t()), u.call(this, e) || n.frozen.has(e);
        }
        return u.call(this, e);
      },
      get: function (e) {
        if (isObject(e) && !o(e)) {
          var n = r(this);
          return n.frozen || (n.frozen = new t()), u.call(this, e) ? l.call(this, e) : n.frozen.get(e);
        }
        return l.call(this, e);
      },
      set: function (e, n) {
        if (isObject(e) && !o(e)) {
          var a = r(this);
          a.frozen || (a.frozen = new t()), u.call(this, e) ? f.call(this, e, n) : a.frozen.set(e, n);
        } else f.call(this, e, n);
        return this;
      }
    });
  }
});
var weakMap = path.WeakMap,
  weakMap$1 = weakMap,
  weakMap$2 = weakMap$1,
  browserPonyfill = createCommonjsModule(function (e, t) {
    var r = function (e) {
      function t() {
        this.fetch = !1, this.DOMException = e.DOMException;
      }
      return t.prototype = e, new t();
    }("undefined" != typeof self ? self : commonjsGlobal);
    !function (e) {
      !function (t) {
        var r = ("URLSearchParams" in e),
          n = "Symbol" in e && "iterator" in Symbol,
          o = "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(),
          a = ("FormData" in e),
          i = ("ArrayBuffer" in e);
        if (i) var s = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          c = ArrayBuffer.isView || function (e) {
            return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
          };
        function u(e) {
          if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
          return e.toLowerCase();
        }
        function l(e) {
          return "string" != typeof e && (e = String(e)), e;
        }
        function f(e) {
          var t = {
            next: function () {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return n && (t[Symbol.iterator] = function () {
            return t;
          }), t;
        }
        function p(e) {
          this.map = {}, e instanceof p ? e.forEach(function (e, t) {
            this.append(t, e);
          }, this) : Array.isArray(e) ? e.forEach(function (e) {
            this.append(e[0], e[1]);
          }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
            this.append(t, e[t]);
          }, this);
        }
        function h(e) {
          if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
          e.bodyUsed = !0;
        }
        function y(e) {
          return new Promise(function (t, r) {
            e.onload = function () {
              t(e.result);
            }, e.onerror = function () {
              r(e.error);
            };
          });
        }
        function d(e) {
          var t = new FileReader(),
            r = y(t);
          return t.readAsArrayBuffer(e), r;
        }
        function g(e) {
          if (e.slice) return e.slice(0);
          var t = new Uint8Array(e.byteLength);
          return t.set(new Uint8Array(e)), t.buffer;
        }
        function m() {
          return this.bodyUsed = !1, this._initBody = function (e) {
            var t;
            this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : o && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : a && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i && o && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : i && (ArrayBuffer.prototype.isPrototypeOf(e) || c(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, o && (this.blob = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function () {
            return this._bodyArrayBuffer ? h(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(d);
          }), this.text = function () {
            var e = h(this);
            if (e) return e;
            if (this._bodyBlob) return function (e) {
              var t = new FileReader(),
                r = y(t);
              return t.readAsText(e), r;
            }(this._bodyBlob);
            if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
              for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) r[n] = String.fromCharCode(t[n]);
              return r.join("");
            }(this._bodyArrayBuffer));
            if (this._bodyFormData) throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, a && (this.formData = function () {
            return this.text().then(_);
          }), this.json = function () {
            return this.text().then(JSON.parse);
          }, this;
        }
        p.prototype.append = function (e, t) {
          e = u(e), t = l(t);
          var r = this.map[e];
          this.map[e] = r ? r + ", " + t : t;
        }, p.prototype.delete = function (e) {
          delete this.map[u(e)];
        }, p.prototype.get = function (e) {
          return e = u(e), this.has(e) ? this.map[e] : null;
        }, p.prototype.has = function (e) {
          return this.map.hasOwnProperty(u(e));
        }, p.prototype.set = function (e, t) {
          this.map[u(e)] = l(t);
        }, p.prototype.forEach = function (e, t) {
          for (var r in this.map) this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
        }, p.prototype.keys = function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push(r);
          }), f(e);
        }, p.prototype.values = function () {
          var e = [];
          return this.forEach(function (t) {
            e.push(t);
          }), f(e);
        }, p.prototype.entries = function () {
          var e = [];
          return this.forEach(function (t, r) {
            e.push([r, t]);
          }), f(e);
        }, n && (p.prototype[Symbol.iterator] = p.prototype.entries);
        var b = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function v(e, t) {
          var r,
            n,
            o = (t = t || {}).body;
          if (e instanceof v) {
            if (e.bodyUsed) throw new TypeError("Already read");
            this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new p(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
          } else this.url = String(e);
          if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (r = t.method || this.method || "GET", n = r.toUpperCase(), b.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
          this._initBody(o);
        }
        function _(e) {
          var t = new FormData();
          return e.trim().split("&").forEach(function (e) {
            if (e) {
              var r = e.split("="),
                n = r.shift().replace(/\+/g, " "),
                o = r.join("=").replace(/\+/g, " ");
              t.append(decodeURIComponent(n), decodeURIComponent(o));
            }
          }), t;
        }
        function A(e, t) {
          t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e);
        }
        v.prototype.clone = function () {
          return new v(this, {
            body: this._bodyInit
          });
        }, m.call(v.prototype), m.call(A.prototype), A.prototype.clone = function () {
          return new A(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new p(this.headers),
            url: this.url
          });
        }, A.error = function () {
          var e = new A(null, {
            status: 0,
            statusText: ""
          });
          return e.type = "error", e;
        };
        var E = [301, 302, 303, 307, 308];
        A.redirect = function (e, t) {
          if (-1 === E.indexOf(t)) throw new RangeError("Invalid status code");
          return new A(null, {
            status: t,
            headers: {
              location: e
            }
          });
        }, t.DOMException = e.DOMException;
        try {
          new t.DOMException();
        } catch (e) {
          t.DOMException = function (e, t) {
            this.message = e, this.name = t;
            var r = Error(e);
            this.stack = r.stack;
          }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
        }
        function $(e, r) {
          return new Promise(function (n, a) {
            var i = new v(e, r);
            if (i.signal && i.signal.aborted) return a(new t.DOMException("Aborted", "AbortError"));
            var s = new XMLHttpRequest();
            function c() {
              s.abort();
            }
            s.onload = function () {
              var e,
                t,
                r = {
                  status: s.status,
                  statusText: s.statusText,
                  headers: (e = s.getAllResponseHeaders() || "", t = new p(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                    var r = e.split(":"),
                      n = r.shift().trim();
                    if (n) {
                      var o = r.join(":").trim();
                      t.append(n, o);
                    }
                  }), t)
                };
              r.url = "responseURL" in s ? s.responseURL : r.headers.get("X-Request-URL");
              var o = "response" in s ? s.response : s.responseText;
              n(new A(o, r));
            }, s.onerror = function () {
              a(new TypeError("Network request failed"));
            }, s.ontimeout = function () {
              a(new TypeError("Network request failed"));
            }, s.onabort = function () {
              a(new t.DOMException("Aborted", "AbortError"));
            }, s.open(i.method, i.url, !0), "include" === i.credentials ? s.withCredentials = !0 : "omit" === i.credentials && (s.withCredentials = !1), "responseType" in s && o && (s.responseType = "blob"), i.headers.forEach(function (e, t) {
              s.setRequestHeader(t, e);
            }), i.signal && (i.signal.addEventListener("abort", c), s.onreadystatechange = function () {
              4 === s.readyState && i.signal.removeEventListener("abort", c);
            }), s.send(void 0 === i._bodyInit ? null : i._bodyInit);
          });
        }
        $.polyfill = !0, e.fetch || (e.fetch = $, e.Headers = p, e.Request = v, e.Response = A), t.Headers = p, t.Request = v, t.Response = A, t.fetch = $;
      }({});
    }(r), delete r.fetch.polyfill, (t = r.fetch).default = r.fetch, t.fetch = r.fetch, t.Headers = r.Headers, t.Request = r.Request, t.Response = r.Response, e.exports = t;
  }),
  require$$0 = getAugmentedNamespace(bufferEs6),
  querystring = createCommonjsModule(function (e, t) {
    var r = t,
      n = require$$0.Buffer;
    function o(e, t) {
      try {
        return decodeURIComponent(e);
      } catch (n) {
        return r.unescapeBuffer(e, t).toString();
      }
    }
    r.unescapeBuffer = function (e, t) {
      for (var r, o, a, i = new n(e.length), s = 0, c = 0, u = 0; c <= e.length; c++) {
        var l = c < e.length ? e.charCodeAt(c) : NaN;
        switch (s) {
          case 0:
            switch (l) {
              case 37:
                r = 0, o = 0, s = 1;
                break;
              case 43:
                t && (l = 32);
              default:
                i[u++] = l;
            }
            break;
          case 1:
            if (a = l, l >= 48 && l <= 57) r = l - 48;else if (l >= 65 && l <= 70) r = l - 65 + 10;else {
              if (!(l >= 97 && l <= 102)) {
                i[u++] = 37, i[u++] = l, s = 0;
                break;
              }
              r = l - 97 + 10;
            }
            s = 2;
            break;
          case 2:
            if (s = 0, l >= 48 && l <= 57) o = l - 48;else if (l >= 65 && l <= 70) o = l - 65 + 10;else {
              if (!(l >= 97 && l <= 102)) {
                i[u++] = 37, i[u++] = a, i[u++] = l;
                break;
              }
              o = l - 97 + 10;
            }
            i[u++] = 16 * r + o;
        }
      }
      return i.slice(0, u - 1);
    }, r.unescape = o;
    for (var a = new Array(256), i = 0; i < 256; ++i) a[i] = "%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase();
    r.escape = function (e) {
      "string" != typeof e && (e += "");
      for (var t = "", r = 0, n = 0; n < e.length; ++n) {
        var o = e.charCodeAt(n);
        if (!(33 === o || 45 === o || 46 === o || 95 === o || 126 === o || o >= 39 && o <= 42 || o >= 48 && o <= 57 || o >= 65 && o <= 90 || o >= 97 && o <= 122)) if (n - r > 0 && (t += e.slice(r, n)), o < 128) r = n + 1, t += a[o];else if (o < 2048) r = n + 1, t += a[192 | o >> 6] + a[128 | 63 & o];else if (o < 55296 || o >= 57344) r = n + 1, t += a[224 | o >> 12] + a[128 | o >> 6 & 63] + a[128 | 63 & o];else {
          var i;
          if (!(++n < e.length)) throw new URIError("URI malformed");
          i = 1023 & e.charCodeAt(n), r = n + 1, t += a[240 | (o = 65536 + ((1023 & o) << 10 | i)) >> 18] + a[128 | o >> 12 & 63] + a[128 | o >> 6 & 63] + a[128 | 63 & o];
        }
      }
      return 0 === r ? e : r < e.length ? t + e.slice(r) : t;
    };
    var s = function s(e) {
      return "string" == typeof e ? e : "number" == typeof e && isFinite(e) ? "" + e : "boolean" == typeof e ? e ? "true" : "false" : "";
    };
    function c(e, t) {
      try {
        return t(e);
      } catch (t) {
        return r.unescape(e, !0);
      }
    }
    r.stringify = r.encode = function (e, t, n, o) {
      t = t || "&", n = n || "=";
      var a = r.escape;
      if (o && "function" == typeof o.encodeURIComponent && (a = o.encodeURIComponent), null !== e && "object" == typeof e) {
        for (var i = Object.keys(e), c = i.length, u = c - 1, l = "", f = 0; f < c; ++f) {
          var p = i[f],
            h = e[p],
            y = a(s(p)) + n;
          if (Array.isArray(h)) {
            for (var d = h.length, g = d - 1, m = 0; m < d; ++m) l += y + a(s(h[m])), m < g && (l += t);
            d && f < u && (l += t);
          } else l += y + a(s(h)), f < u && (l += t);
        }
        return l;
      }
      return "";
    }, r.parse = r.decode = function (e, t, n, a) {
      t = t || "&", n = n || "=";
      var i = {};
      if ("string" != typeof e || 0 === e.length) return i;
      "string" != typeof t && (t += "");
      var s = n.length,
        u = t.length,
        l = 1e3;
      a && "number" == typeof a.maxKeys && (l = a.maxKeys);
      var f = 1 / 0;
      l > 0 && (f = l);
      var p = r.unescape;
      a && "function" == typeof a.decodeURIComponent && (p = a.decodeURIComponent);
      for (var h = p !== o, y = [], d = 0, g = 0, m = 0, b = "", v = "", _ = h, A = h, E = 0, $ = 0; $ < e.length; ++$) {
        var O = e.charCodeAt($);
        if (O !== t.charCodeAt(g)) {
          if (g = 0, A || (37 === O ? E = 1 : E > 0 && (O >= 48 && O <= 57 || O >= 65 && O <= 70 || O >= 97 && O <= 102) ? 3 == ++E && (A = !0) : E = 0), m < s) {
            if (O === n.charCodeAt(m)) {
              if (++m === s) d < (T = $ - m + 1) && (b += e.slice(d, T)), E = 0, d = $ + 1;
              continue;
            }
            m = 0, _ || (37 === O ? E = 1 : E > 0 && (O >= 48 && O <= 57 || O >= 65 && O <= 70 || O >= 97 && O <= 102) ? 3 == ++E && (_ = !0) : E = 0);
          }
          43 === O && (m < s ? ($ - d > 0 && (b += e.slice(d, $)), b += "%20", _ = !0) : ($ - d > 0 && (v += e.slice(d, $)), v += "%20", A = !0), d = $ + 1);
        } else if (++g === u) {
          var S,
            T = $ - g + 1;
          if (m < s ? d < T && (b += e.slice(d, T)) : d < T && (v += e.slice(d, T)), _ && (b = c(b, p)), A && (v = c(v, p)), -1 === y.indexOf(b)) i[b] = v, y[y.length] = b;else (S = i[b]) instanceof Array ? S[S.length] = v : i[b] = [S, v];
          if (0 == --f) break;
          _ = A = h, E = 0, b = v = "", d = $ + 1, g = m = 0;
        }
      }
      f > 0 && (d < e.length || m > 0) && (d < e.length && (m < s ? b += e.slice(d) : g < u && (v += e.slice(d))), _ && (b = c(b, p)), A && (v = c(v, p)), -1 === y.indexOf(b) ? (i[b] = v, y[y.length] = b) : (S = i[b]) instanceof Array ? S[S.length] = v : i[b] = [S, v]);
      return i;
    };
  });
function createErrorType(e, t) {
  function r() {
    Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack;
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
    this.message = r[0], t && t.apply(this, r);
  }
  return r.prototype = new Error(), r.prototype.name = e, r.prototype.constructor = r, r;
}
var traverse_1 = createCommonjsModule(function (e) {
    var t = e.exports = function (e) {
      return new r(e);
    };
    function r(e) {
      this.value = e;
    }
    function n(e, t, r) {
      var n = [],
        i = [],
        l = !0;
      return function e(f) {
        var p = r ? o(f) : f,
          h = {},
          y = !0,
          d = {
            node: p,
            node_: f,
            path: [].concat(n),
            parent: i[i.length - 1],
            parents: i,
            key: n.slice(-1)[0],
            isRoot: 0 === n.length,
            level: n.length,
            circular: null,
            update: function (e, t) {
              d.isRoot || (d.parent.node[d.key] = e), d.node = e, t && (y = !1);
            },
            delete: function (e) {
              delete d.parent.node[d.key], e && (y = !1);
            },
            remove: function (e) {
              s(d.parent.node) ? d.parent.node.splice(d.key, 1) : delete d.parent.node[d.key], e && (y = !1);
            },
            keys: null,
            before: function (e) {
              h.before = e;
            },
            after: function (e) {
              h.after = e;
            },
            pre: function (e) {
              h.pre = e;
            },
            post: function (e) {
              h.post = e;
            },
            stop: function () {
              l = !1;
            },
            block: function () {
              y = !1;
            }
          };
        if (!l) return d;
        function g() {
          if ("object" == typeof d.node && null !== d.node) {
            d.keys && d.node_ === d.node || (d.keys = a(d.node)), d.isLeaf = 0 == d.keys.length;
            for (var e = 0; e < i.length; e++) if (i[e].node_ === f) {
              d.circular = i[e];
              break;
            }
          } else d.isLeaf = !0, d.keys = null;
          d.notLeaf = !d.isLeaf, d.notRoot = !d.isRoot;
        }
        g();
        var m = t.call(d, d.node);
        return void 0 !== m && d.update && d.update(m), h.before && h.before.call(d, d.node), y ? ("object" != typeof d.node || null === d.node || d.circular || (i.push(d), g(), c(d.keys, function (t, o) {
          n.push(t), h.pre && h.pre.call(d, d.node[t], t);
          var a = e(d.node[t]);
          r && u.call(d.node, t) && (d.node[t] = a.node), a.isLast = o == d.keys.length - 1, a.isFirst = 0 == o, h.post && h.post.call(d, a), n.pop();
        }), i.pop()), h.after && h.after.call(d, d.node), d) : d;
      }(e).node;
    }
    function o(e) {
      if ("object" == typeof e && null !== e) {
        var t;
        if (s(e)) t = [];else if ("[object Date]" === i(e)) t = new Date(e.getTime ? e.getTime() : e);else if (function (e) {
          return "[object RegExp]" === i(e);
        }(e)) t = new RegExp(e);else if (function (e) {
          return "[object Error]" === i(e);
        }(e)) t = {
          message: e.message
        };else if (function (e) {
          return "[object Boolean]" === i(e);
        }(e)) t = new Boolean(e);else if (function (e) {
          return "[object Number]" === i(e);
        }(e)) t = new Number(e);else if (function (e) {
          return "[object String]" === i(e);
        }(e)) t = new String(e);else if (Object.create && Object.getPrototypeOf) t = Object.create(Object.getPrototypeOf(e));else if (e.constructor === Object) t = {};else {
          var r = e.constructor && e.constructor.prototype || e.__proto__ || {},
            n = function n() {};
          n.prototype = r, t = new n();
        }
        return c(a(e), function (r) {
          t[r] = e[r];
        }), t;
      }
      return e;
    }
    r.prototype.get = function (e) {
      for (var t = this.value, r = 0; r < e.length; r++) {
        var n = e[r];
        if (!t || !u.call(t, n)) {
          t = void 0;
          break;
        }
        t = t[n];
      }
      return t;
    }, r.prototype.has = function (e) {
      for (var t = this.value, r = 0; r < e.length; r++) {
        var n = e[r];
        if (!t || !u.call(t, n)) return !1;
        t = t[n];
      }
      return !0;
    }, r.prototype.set = function (e, t) {
      for (var r = this.value, n = 0; n < e.length - 1; n++) {
        var o = e[n];
        u.call(r, o) || (r[o] = {}), r = r[o];
      }
      return r[e[n]] = t, t;
    }, r.prototype.map = function (e) {
      return n(this.value, e, !0);
    }, r.prototype.forEach = function (e) {
      return this.value = n(this.value, e, !1), this.value;
    }, r.prototype.reduce = function (e, t) {
      var r = 1 === arguments.length,
        n = r ? this.value : t;
      return this.forEach(function (t) {
        this.isRoot && r || (n = e.call(this, n, t));
      }), n;
    }, r.prototype.paths = function () {
      var e = [];
      return this.forEach(function (t) {
        e.push(this.path);
      }), e;
    }, r.prototype.nodes = function () {
      var e = [];
      return this.forEach(function (t) {
        e.push(this.node);
      }), e;
    }, r.prototype.clone = function () {
      var e = [],
        t = [];
      return function r(n) {
        for (var i = 0; i < e.length; i++) if (e[i] === n) return t[i];
        if ("object" == typeof n && null !== n) {
          var s = o(n);
          return e.push(n), t.push(s), c(a(n), function (e) {
            s[e] = r(n[e]);
          }), e.pop(), t.pop(), s;
        }
        return n;
      }(this.value);
    };
    var a = Object.keys || function (e) {
      var t = [];
      for (var r in e) t.push(r);
      return t;
    };
    function i(e) {
      return Object.prototype.toString.call(e);
    }
    var s = Array.isArray || function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      },
      c = function c(e, t) {
        if (e.forEach) return e.forEach(t);
        for (var r = 0; r < e.length; r++) t(e[r], r, e);
      };
    c(a(r.prototype), function (e) {
      t[e] = function (t) {
        var n = [].slice.call(arguments, 1),
          o = new r(t);
        return o[e].apply(o, n);
      };
    });
    var u = Object.hasOwnProperty || function (e, t) {
      return t in e;
    };
  }),
  stringTag$4 = "[object String]";
function isString$1(e) {
  return "string" == typeof e || !isArray_1(e) && isObjectLike_1(e) && _baseGetTag(e) == stringTag$4;
}
var isString_1 = isString$1,
  freelyNamedKeyParents = ["properties"],
  nonFreelyNamedKeyGrandparents = ["properties"],
  freelyNamedPaths = ["definitions", "parameters", "responses", "securityDefinitions", "components/schemas", "components/responses", "components/parameters", "components/securitySchemes"],
  freelyNamedAncestors = ["schema/example", "items/example"];
function isFreelyNamed(e) {
  var t = e[e.length - 1],
    r = e[e.length - 2],
    n = e.join("/");
  return indexOf$3(freelyNamedKeyParents).call(freelyNamedKeyParents, t) > -1 && -1 === indexOf$3(nonFreelyNamedKeyGrandparents).call(nonFreelyNamedKeyGrandparents, r) || indexOf$3(freelyNamedPaths).call(freelyNamedPaths, n) > -1 || some$2(freelyNamedAncestors).call(freelyNamedAncestors, function (e) {
    return indexOf$3(n).call(n, e) > -1;
  });
}
function generateAbsoluteRefPatches(e, t) {
  var r,
    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    o = n.specmap,
    a = n.getBaseUrlForNodePath,
    i = void 0 === a ? function (e) {
      var r;
      return o.getContext(concat$2(r = []).call(r, toConsumableArray(t), toConsumableArray(e))).baseDoc;
    } : a,
    s = n.targetKeys,
    c = void 0 === s ? ["$ref", "$$ref"] : s,
    u = [];
  return forEach$4(r = traverse_1(e)).call(r, function () {
    if (includes$4(c).call(c, this.key) && isString_1(this.node)) {
      var e = this.path,
        r = concat$2(t).call(t, this.path),
        n = absolutifyPointer(this.node, i(e));
      u.push(o.replace(r, n));
    }
  }), u;
}
function absolutifyPointer(e, t) {
  var r,
    n = e.split("#"),
    o = slicedToArray(n, 2),
    a = o[0],
    i = o[1],
    s = Url.resolve(a || "", t || "");
  return i ? concat$2(r = "".concat(s, "#")).call(r, i) : s;
}
var ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = "application/json, application/yaml",
  ABSOLUTE_URL_REGEXP = new RegExp("^([a-z]+://|//)", "i"),
  JSONRefError = createErrorType("JSONRefError", function (e, t, r) {
    this.originalError = r, assign$4(this, t || {});
  }),
  docCache = {},
  specmapRefs = new weakMap$2(),
  skipResolutionTestFns = [function (e) {
    return "paths" === e[0] && "responses" === e[3] && "examples" === e[5];
  }, function (e) {
    return "paths" === e[0] && "responses" === e[3] && "content" === e[5] && "example" === e[7];
  }, function (e) {
    return "paths" === e[0] && "responses" === e[3] && "content" === e[5] && "examples" === e[7] && "value" === e[9];
  }, function (e) {
    return "paths" === e[0] && "requestBody" === e[3] && "content" === e[4] && "example" === e[6];
  }, function (e) {
    return "paths" === e[0] && "requestBody" === e[3] && "content" === e[4] && "examples" === e[6] && "value" === e[8];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[2] && "example" === e[4];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[3] && "example" === e[5];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[2] && "examples" === e[4] && "value" === e[6];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[3] && "examples" === e[5] && "value" === e[7];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[2] && "content" === e[4] && "example" === e[6];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[2] && "content" === e[4] && "examples" === e[6] && "value" === e[8];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[3] && "content" === e[4] && "example" === e[7];
  }, function (e) {
    return "paths" === e[0] && "parameters" === e[3] && "content" === e[5] && "examples" === e[7] && "value" === e[9];
  }],
  shouldSkipResolution = function shouldSkipResolution(e) {
    return some$2(skipResolutionTestFns).call(skipResolutionTestFns, function (t) {
      return t(e);
    });
  },
  plugin = {
    key: "$ref",
    plugin: function (e, t, r, n) {
      var o = n.getInstance(),
        a = slice$5(r).call(r, 0, -1);
      if (!isFreelyNamed(a) && !shouldSkipResolution(a)) {
        var i = n.getContext(r).baseDoc;
        if ("string" != typeof e) return new JSONRefError("$ref: must be a string (JSON-Ref)", {
          $ref: e,
          baseDoc: i,
          fullPath: r
        });
        var s,
          c,
          u,
          l = split$1(e),
          f = l[0],
          p = l[1] || "";
        try {
          s = i || f ? absoluteify(f, i) : null;
        } catch (t) {
          return wrapError(t, {
            pointer: p,
            $ref: e,
            basePath: s,
            fullPath: r
          });
        }
        if (pointerAlreadyInPath(p, s, a, n) && !o.useCircularStructures) {
          var h = absolutifyPointer(e, s);
          return e === h ? null : lib$1.replace(r, h);
        }
        if (null == s ? (u = jsonPointerToArray(p), void 0 === (c = n.get(u)) && (c = new JSONRefError("Could not resolve reference: ".concat(e), {
          pointer: p,
          $ref: e,
          baseDoc: i,
          fullPath: r
        }))) : c = null != (c = extractFromDoc(s, p)).__value ? c.__value : c.catch(function (t) {
          throw wrapError(t, {
            pointer: p,
            $ref: e,
            baseDoc: i,
            fullPath: r
          });
        }), c instanceof Error) return [lib$1.remove(r), c];
        var y = absolutifyPointer(e, s),
          d = lib$1.replace(a, c, {
            $$ref: y
          });
        if (s && s !== i) return [d, lib$1.context(a, {
          baseDoc: s
        })];
        try {
          if (!patchValueAlreadyInPath(n.state, d) || o.useCircularStructures) return d;
        } catch (e) {
          return null;
        }
      }
    }
  },
  mod = assign$4(plugin, {
    docCache: docCache,
    absoluteify: absoluteify,
    clearCache: clearCache,
    JSONRefError: JSONRefError,
    wrapError: wrapError,
    getDoc: getDoc,
    split: split$1,
    extractFromDoc: extractFromDoc,
    fetchJSON: fetchJSON,
    extract: extract,
    jsonPointerToArray: jsonPointerToArray,
    unescapeJsonPointerToken: unescapeJsonPointerToken
  });
function absoluteify(e, t) {
  if (!ABSOLUTE_URL_REGEXP.test(e)) {
    var r;
    if (!t) throw new JSONRefError(concat$2(r = "Tried to resolve a relative URL, without having a basePath. path: '".concat(e, "' basePath: '")).call(r, t, "'"));
    return Url.resolve(t, e);
  }
  return e;
}
function wrapError(e, t) {
  var r, n;
  e && e.response && e.response.body ? r = concat$2(n = "".concat(e.response.body.code, " ")).call(n, e.response.body.message) : r = e.message;
  return new JSONRefError("Could not resolve reference: ".concat(r), t, e);
}
function split$1(e) {
  return (e + "").split("#");
}
function extractFromDoc(e, t) {
  var r = docCache[e];
  if (r && !lib$1.isPromise(r)) try {
    var n = extract(t, r);
    return assign$4(promise$5.resolve(n), {
      __value: n
    });
  } catch (e) {
    return promise$5.reject(e);
  }
  return getDoc(e).then(function (e) {
    return extract(t, e);
  });
}
function clearCache(e) {
  var t;
  void 0 !== e ? delete docCache[e] : forEach$4(t = keys$6(docCache)).call(t, function (e) {
    delete docCache[e];
  });
}
function getDoc(e) {
  var t = docCache[e];
  return t ? lib$1.isPromise(t) ? t : promise$5.resolve(t) : (docCache[e] = mod.fetchJSON(e).then(function (t) {
    return docCache[e] = t, t;
  }), docCache[e]);
}
function fetchJSON(e) {
  return browserPonyfill.fetch(e, {
    headers: {
      Accept: ACCEPT_HEADER_VALUE_FOR_DOCUMENTS
    },
    loadSpec: !0
  }).then(function (e) {
    return e.text();
  }).then(function (e) {
    return jsYaml$1.safeLoad(e);
  });
}
function extract(e, t) {
  var r = jsonPointerToArray(e);
  if (r.length < 1) return t;
  var n = lib$1.getIn(t, r);
  if (void 0 === n) throw new JSONRefError("Could not resolve pointer: ".concat(e, " does not exist in document"), {
    pointer: e
  });
  return n;
}
function jsonPointerToArray(e) {
  var t;
  if ("string" != typeof e) throw new TypeError("Expected a string, got a ".concat(_typeof_1(e)));
  return "/" === e[0] && (e = e.substr(1)), "" === e ? [] : map$4(t = e.split("/")).call(t, unescapeJsonPointerToken);
}
function unescapeJsonPointerToken(e) {
  return "string" != typeof e ? e : querystring.unescape(e.replace(/~1/g, "/").replace(/~0/g, "~"));
}
function escapeJsonPointerToken(e) {
  return querystring.escape(e.replace(/~/g, "~0").replace(/\//g, "~1"));
}
function arrayToJsonPointer(e) {
  return 0 === e.length ? "" : "/".concat(map$4(e).call(e, escapeJsonPointerToken).join("/"));
}
var pointerBoundaryChar = function pointerBoundaryChar(e) {
  return !e || "/" === e || "#" === e;
};
function pointerIsAParent(e, t) {
  if (pointerBoundaryChar(t)) return !0;
  var r = e.charAt(t.length),
    n = slice$5(t).call(t, -1);
  return 0 === indexOf$3(e).call(e, t) && (!r || "/" === r || "#" === r) && "#" !== n;
}
function pointerAlreadyInPath(e, t, r, n) {
  var o,
    a,
    i = specmapRefs.get(n);
  i || (i = {}, specmapRefs.set(n, i));
  var s = arrayToJsonPointer(r),
    c = concat$2(o = "".concat(t || "<specmap-base>", "#")).call(o, e),
    u = s.replace(/allOf\/\d+\/?/g, "");
  if (t == n.contextTree.get([]).baseDoc && pointerIsAParent(u, e)) return !0;
  var l = "";
  if (some$2(r).call(r, function (e) {
    var t, r;
    return l = concat$2(t = "".concat(l, "/")).call(t, escapeJsonPointerToken(e)), i[l] && some$2(r = i[l]).call(r, function (e) {
      return pointerIsAParent(e, c) || pointerIsAParent(c, e);
    });
  })) return !0;
  i[u] = concat$2(a = i[u] || []).call(a, c);
}
function patchValueAlreadyInPath(e, t) {
  var r,
    n = [e];
  return reduce$2(r = t.path).call(r, function (e, t) {
    return n.push(e[t]), e[t];
  }, e), function e(t) {
    var r;
    return lib$1.isObject(t) && (indexOf$3(n).call(n, t) >= 0 || some$2(r = keys$6(t)).call(r, function (r) {
      return e(t[r]);
    }));
  }(t.value);
}
var mapTag$6 = "[object Map]",
  setTag$6 = "[object Set]",
  objectProto$g = Object.prototype,
  hasOwnProperty$g = objectProto$g.hasOwnProperty;
function isEmpty(e) {
  if (null == e) return !0;
  if (isArrayLike_1(e) && (isArray_1(e) || "string" == typeof e || "function" == typeof e.splice || isBuffer_1(e) || isTypedArray_1(e) || isArguments_1(e))) return !e.length;
  var t = _getTag(e);
  if (t == mapTag$6 || t == setTag$6) return !e.size;
  if (_isPrototype(e)) return !_baseKeys(e).length;
  for (var r in e) if (hasOwnProperty$g.call(e, r)) return !1;
  return !0;
}
var isEmpty_1 = isEmpty,
  allOf = {
    key: "allOf",
    plugin: function (e, t, r, n, o) {
      if (!o.meta || !o.meta.$$ref) {
        var a = slice$5(r).call(r, 0, -1);
        if (!isFreelyNamed(a)) {
          if (!isArray$8(e)) {
            var i = new TypeError("allOf must be an array");
            return i.fullPath = r, i;
          }
          var s = !1,
            c = o.value;
          if (forEach$4(a).call(a, function (e) {
            c && (c = c[e]);
          }), c = objectSpread2({}, c), !isEmpty_1(c)) {
            delete c.allOf;
            var u,
              l = [];
            if (l.push(n.replace(a, {})), forEach$4(e).call(e, function (e, t) {
              if (!n.isObject(e)) {
                if (s) return null;
                s = !0;
                var o = new TypeError("Elements in allOf must be objects");
                return o.fullPath = r, l.push(o);
              }
              l.push(n.mergeDeep(a, e));
              var i = generateAbsoluteRefPatches(e, slice$5(r).call(r, 0, -1), {
                getBaseUrlForNodePath: function (e) {
                  var o;
                  return n.getContext(concat$2(o = []).call(o, toConsumableArray(r), [t], toConsumableArray(e))).baseDoc;
                },
                specmap: n
              });
              l.push.apply(l, toConsumableArray(i));
            }), l.push(n.mergeDeep(a, c)), !c.$$ref) l.push(n.remove(concat$2(u = []).call(u, a, "$$ref")));
            return l;
          }
        }
      }
    }
  },
  parameters = {
    key: "parameters",
    plugin: function (e, t, r, n) {
      if (isArray$8(e) && e.length) {
        var o = assign$4([], e),
          a = slice$5(r).call(r, 0, -1),
          i = objectSpread2({}, lib$1.getIn(n.spec, a));
        return forEach$4(e).call(e, function (e, t) {
          try {
            o[t].default = n.parameterMacro(i, e);
          } catch (e) {
            var a = new Error(e);
            return a.fullPath = r, a;
          }
        }), lib$1.replace(r, o);
      }
      return lib$1.replace(r, e);
    }
  },
  properties = {
    key: "properties",
    plugin: function (e, t, r, n) {
      var o = objectSpread2({}, e);
      for (var a in e) try {
        o[a].default = n.modelPropertyMacro(o[a]);
      } catch (e) {
        var i = new Error(e);
        return i.fullPath = r, i;
      }
      return lib$1.replace(r, o);
    }
  },
  ContextTree = function () {
    function e(t) {
      classCallCheck(this, e), this.root = createNode(t || {});
    }
    return createClass(e, [{
      key: "set",
      value: function (e, t) {
        var r = this.getParent(e, !0);
        if (r) {
          var n = e[e.length - 1],
            o = r.children;
          o[n] ? updateNode(o[n], t, r) : o[n] = createNode(t, r);
        } else updateNode(this.root, t, null);
      }
    }, {
      key: "get",
      value: function (e) {
        if ((e = e || []).length < 1) return this.root.value;
        for (var t, r, n = this.root, o = 0; o < e.length && (r = e[o], (t = n.children)[r]); o += 1) n = t[r];
        return n && n.protoValue;
      }
    }, {
      key: "getParent",
      value: function (e, t) {
        var r;
        return !e || e.length < 1 ? null : e.length < 2 ? this.root : reduce$2(r = slice$5(e).call(e, 0, -1)).call(r, function (e, r) {
          if (!e) return e;
          var n = e.children;
          return !n[r] && t && (n[r] = createNode(null, e)), n[r];
        }, this.root);
      }
    }]), e;
  }();
function createNode(e, t) {
  return updateNode({
    children: {}
  }, e, t);
}
function updateNode(e, t, r) {
  var n;
  return e.value = t || {}, e.protoValue = r ? objectSpread2(objectSpread2({}, r.protoValue), e.value) : e.value, forEach$4(n = keys$6(e.children)).call(n, function (t) {
    var r = e.children[t];
    e.children[t] = updateNode(r, r.value, e);
  }), e;
}
var HARD_LIMIT = 100,
  SpecMap = function () {
    function e(t) {
      var r,
        n,
        o,
        a,
        i,
        s,
        c = this;
      classCallCheck(this, e), assign$4(this, {
        spec: "",
        debugLevel: "info",
        plugins: [],
        pluginHistory: {},
        errors: [],
        mutations: [],
        promisedPatches: [],
        state: {},
        patches: [],
        context: {},
        contextTree: new ContextTree(),
        showDebug: !1,
        allPatches: [],
        pluginProp: "specMap",
        libMethods: assign$4(create$4(this), lib$1, {
          getInstance: function () {
            return c;
          }
        }),
        allowMetaPatches: !1
      }, t), this.get = bind$2(r = this._get).call(r, this), this.getContext = bind$2(n = this._getContext).call(n, this), this.hasRun = bind$2(o = this._hasRun).call(o, this), this.wrappedPlugins = filter$4(a = map$4(i = this.plugins).call(i, bind$2(s = this.wrapPlugin).call(s, this))).call(a, lib$1.isFunction), this.patches.push(lib$1.add([], this.spec)), this.patches.push(lib$1.context([], this.context)), this.updatePatches(this.patches);
    }
    return createClass(e, [{
      key: "debug",
      value: function (e) {
        if (this.debugLevel === e) {
          for (var t, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];
          (t = console).log.apply(t, n);
        }
      }
    }, {
      key: "verbose",
      value: function (e) {
        if ("verbose" === this.debugLevel) {
          for (var t, r, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) o[a - 1] = arguments[a];
          (t = console).log.apply(t, concat$2(r = ["[".concat(e, "]   ")]).call(r, o));
        }
      }
    }, {
      key: "wrapPlugin",
      value: function (e, t) {
        var r,
          n,
          o,
          a = this.pathDiscriminator,
          i = null;
        return e[this.pluginProp] ? (i = e, r = e[this.pluginProp]) : lib$1.isFunction(e) ? r = e : lib$1.isObject(e) && (n = e, o = function (e, t) {
          return !isArray$8(e) || every$2(e).call(e, function (e, r) {
            return e === t[r];
          });
        }, r = regenerator.mark(function e(t, r) {
          var i, s, c, u, l, f;
          return regenerator.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                f = function (e, t, c) {
                  var u, l, p, h, y, d, g, m, b, v, _, A, E;
                  return regenerator.wrap(function (i) {
                    for (;;) switch (i.prev = i.next) {
                      case 0:
                        if (lib$1.isObject(e)) {
                          i.next = 6;
                          break;
                        }
                        if (n.key !== t[t.length - 1]) {
                          i.next = 4;
                          break;
                        }
                        return i.next = 4, n.plugin(e, n.key, t, r);
                      case 4:
                        i.next = 30;
                        break;
                      case 6:
                        u = t.length - 1, l = t[u], p = indexOf$3(t).call(t, "properties"), h = "properties" === l && u === p, y = r.allowMetaPatches && s[e.$$ref], d = 0, g = keys$6(e);
                      case 12:
                        if (!(d < g.length)) {
                          i.next = 30;
                          break;
                        }
                        if (m = g[d], b = e[m], v = concat$2(t).call(t, m), _ = lib$1.isObject(b), A = e.$$ref, y) {
                          i.next = 22;
                          break;
                        }
                        if (!_) {
                          i.next = 22;
                          break;
                        }
                        return r.allowMetaPatches && A && (s[A] = !0), i.delegateYield(f(b, v, c), "t0", 22);
                      case 22:
                        if (h || m !== n.key) {
                          i.next = 27;
                          break;
                        }
                        if (E = o(a, t), a && !E) {
                          i.next = 27;
                          break;
                        }
                        return i.next = 27, n.plugin(b, m, v, r, c);
                      case 27:
                        d++, i.next = 12;
                        break;
                      case 30:
                      case "end":
                        return i.stop();
                    }
                  }, i);
                }, i = regenerator.mark(f), s = {}, c = createForOfIteratorHelper(filter$4(t).call(t, lib$1.isAdditiveMutation)), e.prev = 4, c.s();
              case 6:
                if ((u = c.n()).done) {
                  e.next = 11;
                  break;
                }
                return l = u.value, e.delegateYield(f(l.value, l.path, l), "t0", 9);
              case 9:
                e.next = 6;
                break;
              case 11:
                e.next = 16;
                break;
              case 13:
                e.prev = 13, e.t1 = e.catch(4), c.e(e.t1);
              case 16:
                return e.prev = 16, c.f(), e.finish(16);
              case 19:
              case "end":
                return e.stop();
            }
          }, e, null, [[4, 13, 16, 19]]);
        })), assign$4(bind$2(r).call(r, i), {
          pluginName: e.name || t,
          isGenerator: lib$1.isGenerator(r)
        });
      }
    }, {
      key: "nextPlugin",
      value: function () {
        var e = this;
        return find_1$1(this.wrappedPlugins, function (t) {
          return e.getMutationsForPlugin(t).length > 0;
        });
      }
    }, {
      key: "nextPromisedPatch",
      value: function () {
        var e;
        if (this.promisedPatches.length > 0) return promise$5.race(map$4(e = this.promisedPatches).call(e, function (e) {
          return e.value;
        }));
      }
    }, {
      key: "getPluginHistory",
      value: function (e) {
        var t = this.constructor.getPluginName(e);
        return this.pluginHistory[t] || [];
      }
    }, {
      key: "getPluginRunCount",
      value: function (e) {
        return this.getPluginHistory(e).length;
      }
    }, {
      key: "getPluginHistoryTip",
      value: function (e) {
        var t = this.getPluginHistory(e);
        return t && t[t.length - 1] || {};
      }
    }, {
      key: "getPluginMutationIndex",
      value: function (e) {
        var t = this.getPluginHistoryTip(e).mutationIndex;
        return "number" != typeof t ? -1 : t;
      }
    }, {
      key: "updatePluginHistory",
      value: function (e, t) {
        var r = this.constructor.getPluginName(e);
        this.pluginHistory[r] = this.pluginHistory[r] || [], this.pluginHistory[r].push(t);
      }
    }, {
      key: "updatePatches",
      value: function (e) {
        var t,
          r = this;
        forEach$4(t = lib$1.normalizeArray(e)).call(t, function (e) {
          if (e instanceof Error) r.errors.push(e);else try {
            if (!lib$1.isObject(e)) return void r.debug("updatePatches", "Got a non-object patch", e);
            if (r.showDebug && r.allPatches.push(e), lib$1.isPromise(e.value)) return r.promisedPatches.push(e), void r.promisedPatchThen(e);
            if (lib$1.isContextPatch(e)) return void r.setContext(e.path, e.value);
            if (lib$1.isMutation(e)) return void r.updateMutations(e);
          } catch (e) {
            console.error(e), r.errors.push(e);
          }
        });
      }
    }, {
      key: "updateMutations",
      value: function (e) {
        "object" === _typeof_1(e.value) && !isArray$8(e.value) && this.allowMetaPatches && (e.value = objectSpread2({}, e.value));
        var t = lib$1.applyPatch(this.state, e, {
          allowMetaPatches: this.allowMetaPatches
        });
        t && (this.mutations.push(e), this.state = t);
      }
    }, {
      key: "removePromisedPatch",
      value: function (e) {
        var t,
          r,
          n = indexOf$3(t = this.promisedPatches).call(t, e);
        n < 0 ? this.debug("Tried to remove a promisedPatch that isn't there!") : splice$3(r = this.promisedPatches).call(r, n, 1);
      }
    }, {
      key: "promisedPatchThen",
      value: function (e) {
        var t = this;
        return e.value = e.value.then(function (r) {
          var n = objectSpread2(objectSpread2({}, e), {}, {
            value: r
          });
          t.removePromisedPatch(e), t.updatePatches(n);
        }).catch(function (r) {
          t.removePromisedPatch(e), t.updatePatches(r);
        }), e.value;
      }
    }, {
      key: "getMutations",
      value: function (e, t) {
        var r;
        return e = e || 0, "number" != typeof t && (t = this.mutations.length), slice$5(r = this.mutations).call(r, e, t);
      }
    }, {
      key: "getCurrentMutations",
      value: function () {
        return this.getMutationsForPlugin(this.getCurrentPlugin());
      }
    }, {
      key: "getMutationsForPlugin",
      value: function (e) {
        var t = this.getPluginMutationIndex(e);
        return this.getMutations(t + 1);
      }
    }, {
      key: "getCurrentPlugin",
      value: function () {
        return this.currentPlugin;
      }
    }, {
      key: "getLib",
      value: function () {
        return this.libMethods;
      }
    }, {
      key: "_get",
      value: function (e) {
        return lib$1.getIn(this.state, e);
      }
    }, {
      key: "_getContext",
      value: function (e) {
        return this.contextTree.get(e);
      }
    }, {
      key: "setContext",
      value: function (e, t) {
        return this.contextTree.set(e, t);
      }
    }, {
      key: "_hasRun",
      value: function (e) {
        return this.getPluginRunCount(this.getCurrentPlugin()) > (e || 0);
      }
    }, {
      key: "dispatch",
      value: function () {
        var e,
          t = this,
          r = this,
          n = this.nextPlugin();
        if (!n) {
          var o = this.nextPromisedPatch();
          if (o) return o.then(function () {
            return t.dispatch();
          }).catch(function () {
            return t.dispatch();
          });
          var a = {
            spec: this.state,
            errors: this.errors
          };
          return this.showDebug && (a.patches = this.allPatches), promise$5.resolve(a);
        }
        if (r.pluginCount = r.pluginCount || {}, r.pluginCount[n] = (r.pluginCount[n] || 0) + 1, r.pluginCount[n] > HARD_LIMIT) return promise$5.resolve({
          spec: r.state,
          errors: concat$2(e = r.errors).call(e, new Error("We've reached a hard limit of ".concat(HARD_LIMIT, " plugin runs")))
        });
        if (n !== this.currentPlugin && this.promisedPatches.length) {
          var i,
            s = map$4(i = this.promisedPatches).call(i, function (e) {
              return e.value;
            });
          return promise$5.all(map$4(s).call(s, function (e) {
            return e.then(noop_1, noop_1);
          })).then(function () {
            return t.dispatch();
          });
        }
        return function () {
          r.currentPlugin = n;
          var e = r.getCurrentMutations(),
            t = r.mutations.length - 1;
          try {
            if (n.isGenerator) {
              var o,
                a = createForOfIteratorHelper(n(e, r.getLib()));
              try {
                for (a.s(); !(o = a.n()).done;) {
                  c(o.value);
                }
              } catch (e) {
                a.e(e);
              } finally {
                a.f();
              }
            } else {
              c(n(e, r.getLib()));
            }
          } catch (e) {
            console.error(e), c([assign$4(create$4(e), {
              plugin: n
            })]);
          } finally {
            r.updatePluginHistory(n, {
              mutationIndex: t
            });
          }
          return r.dispatch();
        }();
        function c(e) {
          e && (e = lib$1.fullyNormalizeArray(e), r.updatePatches(e, n));
        }
      }
    }], [{
      key: "getPluginName",
      value: function (e) {
        return e.pluginName;
      }
    }, {
      key: "getPatchesOfType",
      value: function (e, t) {
        return filter$4(e).call(e, t);
      }
    }]), e;
  }();
function mapSpec(e) {
  return new SpecMap(e).dispatch();
}
var plugins = {
    refs: mod,
    allOf: allOf,
    parameters: parameters,
    properties: properties
  },
  toLower = function toLower(e) {
    return String.prototype.toLowerCase.call(e);
  },
  escapeString$1 = function escapeString$1(e) {
    return e.replace(/[^\w]/gi, "_");
  };
function isOAS3(e) {
  var t = e.openapi;
  return !!t && startsWith_1(t, "3");
}
function opId(e, t) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
    n = (arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}).v2OperationIdCompatibilityMode;
  return e && "object" === _typeof_1(e) ? (e.operationId || "").replace(/\s/g, "").length ? escapeString$1(e.operationId) : idFromPathMethod(t, r, {
    v2OperationIdCompatibilityMode: n
  }) : null;
}
function idFromPathMethod(e, t) {
  var r;
  if ((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).v2OperationIdCompatibilityMode) {
    var n,
      o,
      a = concat$2(n = "".concat(t.toLowerCase(), "_")).call(n, e).replace(/[\s!@#$%^&*()_+=[{\]};:<>|./?,\\'""-]/g, "_");
    return (a = a || concat$2(o = "".concat(e.substring(1), "_")).call(o, t)).replace(/((_){2,})/g, "_").replace(/^(_)*/g, "").replace(/([_])*$/g, "");
  }
  return concat$2(r = "".concat(toLower(t))).call(r, escapeString$1(e));
}
function legacyIdFromPathMethod(e, t) {
  var r;
  return concat$2(r = "".concat(toLower(t), "-")).call(r, e);
}
function getOperationRaw(e, t) {
  return e && e.paths ? findOperation(e, function (e) {
    var r,
      n = e.pathName,
      o = e.method,
      a = e.operation;
    if (!a || "object" !== _typeof_1(a)) return !1;
    var i = a.operationId,
      s = opId(a, n, o),
      c = legacyIdFromPathMethod(n, o);
    return some$2(r = [s, c, i]).call(r, function (e) {
      return e && e === t;
    });
  }) : null;
}
function findOperation(e, t) {
  return eachOperation(e, t, !0) || null;
}
function eachOperation(e, t, r) {
  if (!e || "object" !== _typeof_1(e) || !e.paths || "object" !== _typeof_1(e.paths)) return null;
  var n = e.paths;
  for (var o in n) for (var a in n[o]) if ("PARAMETERS" !== a.toUpperCase()) {
    var i = n[o][a];
    if (i && "object" === _typeof_1(i)) {
      var s = {
          spec: e,
          pathName: o,
          method: a.toUpperCase(),
          operation: i
        },
        c = t(s);
      if (r && c) return s;
    }
  }
}
function normalizeSwagger(e) {
  var t = e.spec,
    r = t.paths,
    n = {};
  if (!r || t.$$normalized) return e;
  for (var o in r) {
    var a = r[o];
    if (isObject_1(a)) {
      var i = a.parameters,
        s = function s(e) {
          var r = a[e];
          if (!isObject_1(r)) return "continue";
          var s = opId(r, o, e);
          if (s) {
            n[s] ? n[s].push(r) : n[s] = [r];
            var c = n[s];
            if (c.length > 1) forEach$4(c).call(c, function (e, t) {
              var r;
              e.__originalOperationId = e.__originalOperationId || e.operationId, e.operationId = concat$2(r = "".concat(s)).call(r, t + 1);
            });else if (void 0 !== r.operationId) {
              var u = c[0];
              u.__originalOperationId = u.__originalOperationId || r.operationId, u.operationId = s;
            }
          }
          if ("parameters" !== e) {
            var l = [],
              f = {};
            for (var p in t) "produces" !== p && "consumes" !== p && "security" !== p || (f[p] = t[p], l.push(f));
            if (i && (f.parameters = i, l.push(f)), l.length) {
              var h,
                y = createForOfIteratorHelper(l);
              try {
                for (y.s(); !(h = y.n()).done;) {
                  var d = h.value;
                  for (var g in d) if (r[g]) {
                    if ("parameters" === g) {
                      var m,
                        b = createForOfIteratorHelper(d[g]);
                      try {
                        var _v = function v() {
                          var e,
                            t = m.value;
                          some$2(e = r[g]).call(e, function (e) {
                            return e.name && e.name === t.name || e.$ref && e.$ref === t.$ref || e.$$ref && e.$$ref === t.$$ref || e === t;
                          }) || r[g].push(t);
                        };
                        for (b.s(); !(m = b.n()).done;) _v();
                      } catch (e) {
                        b.e(e);
                      } finally {
                        b.f();
                      }
                    }
                  } else r[g] = d[g];
                }
              } catch (e) {
                y.e(e);
              } finally {
                y.f();
              }
            }
          }
        };
      for (var c in a) s(c);
    }
  }
  return t.$$normalized = !0, e;
}
function makeFetchJSON(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = t.requestInterceptor,
    n = t.responseInterceptor,
    o = e.withCredentials ? "include" : "same-origin";
  return function (t) {
    return e({
      url: t,
      loadSpec: !0,
      requestInterceptor: r,
      responseInterceptor: n,
      headers: {
        Accept: ACCEPT_HEADER_VALUE_FOR_DOCUMENTS
      },
      credentials: o
    }).then(function (e) {
      return e.body;
    });
  };
}
function clearCache$1() {
  plugins.refs.clearCache();
}
function resolve(e) {
  var t = e.fetch,
    r = e.spec,
    n = e.url,
    o = e.mode,
    a = e.allowMetaPatches,
    i = void 0 === a || a,
    s = e.pathDiscriminator,
    c = e.modelPropertyMacro,
    u = e.parameterMacro,
    l = e.requestInterceptor,
    f = e.responseInterceptor,
    p = e.skipNormalization,
    h = e.useCircularStructures,
    y = e.http,
    d = e.baseDoc;
  return d = d || n, y = t || y || http, r ? g(r) : makeFetchJSON(y, {
    requestInterceptor: l,
    responseInterceptor: f
  })(d).then(g);
  function g(e) {
    d && (plugins.refs.docCache[d] = e), plugins.refs.fetchJSON = makeFetchJSON(y, {
      requestInterceptor: l,
      responseInterceptor: f
    });
    var t = [plugins.refs];
    return "function" == typeof u && t.push(plugins.parameters), "function" == typeof c && t.push(plugins.properties), "strict" !== o && t.push(plugins.allOf), mapSpec({
      spec: e,
      context: {
        baseDoc: d
      },
      plugins: t,
      allowMetaPatches: i,
      pathDiscriminator: s,
      parameterMacro: u,
      modelPropertyMacro: c,
      useCircularStructures: h
    }).then(p ? function () {
      var e = asyncToGenerator(regenerator.mark(function e(t) {
        return regenerator.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", t);
            case 1:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }() : normalizeSwagger);
  }
}
function resolveSubtree(e, t) {
  return _resolveSubtree.apply(this, arguments);
}
function _resolveSubtree() {
  return _resolveSubtree = asyncToGenerator(regenerator.mark(function e(t, r) {
    var n,
      o,
      a,
      i,
      s,
      c,
      u,
      l,
      f,
      p,
      h,
      y,
      d = arguments;
    return regenerator.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return o = (n = d.length > 2 && void 0 !== d[2] ? d[2] : {}).returnEntireTree, a = n.baseDoc, i = n.requestInterceptor, s = n.responseInterceptor, c = n.parameterMacro, u = n.modelPropertyMacro, l = n.useCircularStructures, f = {
            pathDiscriminator: r,
            baseDoc: a,
            requestInterceptor: i,
            responseInterceptor: s,
            parameterMacro: c,
            modelPropertyMacro: u,
            useCircularStructures: l
          }, p = normalizeSwagger({
            spec: t
          }), h = p.spec, e.next = 6, resolve(objectSpread2(objectSpread2({}, f), {}, {
            spec: h,
            allowMetaPatches: !0,
            skipNormalization: !0
          }));
        case 6:
          return y = e.sent, !o && isArray$8(r) && r.length && (y.spec = get_1(y.spec, r) || null), e.abrupt("return", y);
        case 9:
        case "end":
          return e.stop();
      }
    }, e);
  })), _resolveSubtree.apply(this, arguments);
}
var nullFn = function nullFn() {
    return null;
  },
  normalizeArray$1 = function normalizeArray$1(e) {
    return isArray$8(e) ? e : [e];
  },
  self$2 = {
    mapTagOperations: mapTagOperations,
    makeExecute: makeExecute
  };
function makeExecute() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return function (t) {
    var r = t.pathName,
      n = t.method,
      o = t.operationId;
    return function (t) {
      var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return e.execute(objectSpread2(objectSpread2({
        spec: e.spec
      }, pick_1(e, "requestInterceptor", "responseInterceptor", "userFetch")), {}, {
        pathName: r,
        method: n,
        parameters: t,
        operationId: o
      }, a));
    };
  };
}
function makeApisTagOperation() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = self$2.makeExecute(e);
  return {
    apis: self$2.mapTagOperations({
      v2OperationIdCompatibilityMode: e.v2OperationIdCompatibilityMode,
      spec: e.spec,
      cb: t
    })
  };
}
function mapTagOperations(e) {
  var t = e.spec,
    r = e.cb,
    n = void 0 === r ? nullFn : r,
    o = e.defaultTag,
    a = void 0 === o ? "default" : o,
    i = e.v2OperationIdCompatibilityMode,
    s = {},
    c = {};
  return eachOperation(t, function (e) {
    var r = e.pathName,
      o = e.method,
      u = e.operation,
      l = u.tags ? normalizeArray$1(u.tags) : [a];
    forEach$4(l).call(l, function (e) {
      if ("string" == typeof e) {
        c[e] = c[e] || {};
        var a,
          l = c[e],
          f = opId(u, r, o, {
            v2OperationIdCompatibilityMode: i
          }),
          p = n({
            spec: t,
            pathName: r,
            method: o,
            operation: u,
            operationId: f
          });
        if (s[f]) s[f] += 1, l[concat$2(a = "".concat(f)).call(a, s[f])] = p;else if (void 0 !== l[f]) {
          var h,
            y,
            d = s[f] || 1;
          s[f] = d + 1, l[concat$2(h = "".concat(f)).call(h, s[f])] = p;
          var g = l[f];
          delete l[f], l[concat$2(y = "".concat(f)).call(y, d)] = g;
        } else l[f] = p;
      }
    });
  }), c;
}
var indexOf$4 = indexOf_1,
  indexOf$5 = indexOf$4;
function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = {},
    a = keys$3(e);
  for (n = 0; n < a.length; n++) r = a[n], indexOf$5(t).call(t, r) >= 0 || (o[r] = e[r]);
  return o;
}
var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var r,
    n,
    o = objectWithoutPropertiesLoose(e, t);
  if (getOwnPropertySymbols$2) {
    var a = getOwnPropertySymbols$2(e);
    for (n = 0; n < a.length; n++) r = a[n], indexOf$5(t).call(t, r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
var objectWithoutProperties = _objectWithoutProperties,
  objectTag$4 = "[object Object]",
  funcProto$2 = Function.prototype,
  objectProto$h = Object.prototype,
  funcToString$2 = funcProto$2.toString,
  hasOwnProperty$h = objectProto$h.hasOwnProperty,
  objectCtorString = funcToString$2.call(Object);
function isPlainObject(e) {
  if (!isObjectLike_1(e) || _baseGetTag(e) != objectTag$4) return !1;
  var t = _getPrototype(e);
  if (null === t) return !0;
  var r = hasOwnProperty$h.call(t, "constructor") && t.constructor;
  return "function" == typeof r && r instanceof r && funcToString$2.call(r) == objectCtorString;
}
var isPlainObject_1 = isPlainObject,
  parse_1 = parse$4,
  serialize_1 = serialize,
  decode$1 = decodeURIComponent,
  encode$2 = encodeURIComponent,
  pairSplitRegExp = /; */,
  fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
function parse$4(e, t) {
  if ("string" != typeof e) throw new TypeError("argument str must be a string");
  for (var r = {}, n = t || {}, o = e.split(pairSplitRegExp), a = n.decode || decode$1, i = 0; i < o.length; i++) {
    var s = o[i],
      c = s.indexOf("=");
    if (!(c < 0)) {
      var u = s.substr(0, c).trim(),
        l = s.substr(++c, s.length).trim();
      '"' == l[0] && (l = l.slice(1, -1)), null == r[u] && (r[u] = tryDecode(l, a));
    }
  }
  return r;
}
function serialize(e, t, r) {
  var n = r || {},
    o = n.encode || encode$2;
  if ("function" != typeof o) throw new TypeError("option encode is invalid");
  if (!fieldContentRegExp.test(e)) throw new TypeError("argument name is invalid");
  var a = o(t);
  if (a && !fieldContentRegExp.test(a)) throw new TypeError("argument val is invalid");
  var i = e + "=" + a;
  if (null != n.maxAge) {
    var s = n.maxAge - 0;
    if (isNaN(s) || !isFinite(s)) throw new TypeError("option maxAge is invalid");
    i += "; Max-Age=" + Math.floor(s);
  }
  if (n.domain) {
    if (!fieldContentRegExp.test(n.domain)) throw new TypeError("option domain is invalid");
    i += "; Domain=" + n.domain;
  }
  if (n.path) {
    if (!fieldContentRegExp.test(n.path)) throw new TypeError("option path is invalid");
    i += "; Path=" + n.path;
  }
  if (n.expires) {
    if ("function" != typeof n.expires.toUTCString) throw new TypeError("option expires is invalid");
    i += "; Expires=" + n.expires.toUTCString();
  }
  if (n.httpOnly && (i += "; HttpOnly"), n.secure && (i += "; Secure"), n.sameSite) switch ("string" == typeof n.sameSite ? n.sameSite.toLowerCase() : n.sameSite) {
    case !0:
      i += "; SameSite=Strict";
      break;
    case "lax":
      i += "; SameSite=Lax";
      break;
    case "strict":
      i += "; SameSite=Strict";
      break;
    case "none":
      i += "; SameSite=None";
      break;
    default:
      throw new TypeError("option sameSite is invalid");
  }
  return i;
}
function tryDecode(e, t) {
  try {
    return t(e);
  } catch (t) {
    return e;
  }
}
var cookie = {
    parse: parse_1,
    serialize: serialize_1
  },
  SWAGGER2_PARAMETER_BUILDERS = {
    body: bodyBuilder,
    header: headerBuilder,
    query: queryBuilder,
    path: pathBuilder,
    formData: formDataBuilder
  };
function bodyBuilder(e) {
  var t = e.req,
    r = e.value;
  t.body = r;
}
function formDataBuilder(e) {
  var t = e.req,
    r = e.value,
    n = e.parameter;
  (r || n.allowEmptyValue) && (t.form = t.form || {}, t.form[n.name] = {
    value: r,
    allowEmptyValue: n.allowEmptyValue,
    collectionFormat: n.collectionFormat
  });
}
function headerBuilder(e) {
  var t = e.req,
    r = e.parameter,
    n = e.value;
  t.headers = t.headers || {}, void 0 !== n && (t.headers[r.name] = n);
}
function pathBuilder(e) {
  var t = e.req,
    r = e.value,
    n = e.parameter;
  t.url = t.url.split("{".concat(n.name, "}")).join(encodeURIComponent(r));
}
function queryBuilder(e) {
  var t,
    r = e.req,
    n = e.value,
    o = e.parameter;
  if (r.query = r.query || {}, !1 === n && "boolean" === o.type && (n = "false"), 0 === n && indexOf$3(t = ["number", "integer"]).call(t, o.type) > -1 && (n = "0"), n) r.query[o.name] = {
    collectionFormat: o.collectionFormat,
    value: n
  };else if (o.allowEmptyValue && void 0 !== n) {
    var a = o.name;
    r.query[a] = r.query[a] || {}, r.query[a].allowEmptyValue = !0;
  }
}
function serialize$1(e, t) {
  return includes$4(t).call(t, "application/json") ? "string" == typeof e ? e : stringify$3(e) : e.toString();
}
function path$1(e) {
  var t = e.req,
    r = e.value,
    n = e.parameter,
    o = n.name,
    a = n.style,
    i = n.explode,
    s = n.content;
  if (s) {
    var c = keys$6(s)[0];
    t.url = t.url.split("{".concat(o, "}")).join(encodeDisallowedCharacters(serialize$1(r, c), {
      escape: !0
    }));
  } else {
    var u = stylize({
      key: n.name,
      value: r,
      style: a || "simple",
      explode: i || !1,
      escape: !0
    });
    t.url = t.url.split("{".concat(o, "}")).join(u);
  }
}
function query(e) {
  var t = e.req,
    r = e.value,
    n = e.parameter;
  if (t.query = t.query || {}, n.content) {
    var o = keys$6(n.content)[0];
    t.query[n.name] = serialize$1(r, o);
  } else if (!1 === r && (r = "false"), 0 === r && (r = "0"), r) t.query[n.name] = {
    value: r,
    serializationOption: pick_1(n, ["style", "explode", "allowReserved"])
  };else if (n.allowEmptyValue && void 0 !== r) {
    var a = n.name;
    t.query[a] = t.query[a] || {}, t.query[a].allowEmptyValue = !0;
  }
}
var PARAMETER_HEADER_BLACKLIST = ["accept", "authorization", "content-type"];
function header(e) {
  var t = e.req,
    r = e.parameter,
    n = e.value;
  if (t.headers = t.headers || {}, !(indexOf$3(PARAMETER_HEADER_BLACKLIST).call(PARAMETER_HEADER_BLACKLIST, r.name.toLowerCase()) > -1)) if (r.content) {
    var o = keys$6(r.content)[0];
    t.headers[r.name] = serialize$1(n, o);
  } else void 0 !== n && (t.headers[r.name] = stylize({
    key: r.name,
    value: n,
    style: r.style || "simple",
    explode: void 0 !== r.explode && r.explode,
    escape: !1
  }));
}
function cookie$1(e) {
  var t = e.req,
    r = e.parameter,
    n = e.value;
  t.headers = t.headers || {};
  var o = _typeof_1(n);
  if (r.content) {
    var a,
      i = keys$6(r.content)[0];
    t.headers.Cookie = concat$2(a = "".concat(r.name, "=")).call(a, serialize$1(n, i));
  } else if ("undefined" !== o) {
    var s = "object" === o && !isArray$8(n) && r.explode ? "" : "".concat(r.name, "=");
    t.headers.Cookie = s + stylize({
      key: r.name,
      value: n,
      escape: !1,
      style: r.style || "form",
      explode: void 0 !== r.explode && r.explode
    });
  }
}
var OAS3_PARAMETER_BUILDERS = Object.freeze({
    __proto__: null,
    path: path$1,
    query: query,
    header: header,
    cookie: cookie$1
  }),
  btoa = createCommonjsModule(function (e) {
    e.exports = function (e) {
      return (e instanceof Buffer ? e : Buffer.from(e.toString(), "binary")).toString("base64");
    };
  });
function buildRequest(e, t) {
  var r = e.operation,
    n = e.requestBody,
    o = e.securities,
    a = e.spec,
    i = e.attachContentTypeForEmptyPayload,
    s = e.requestContentType;
  t = applySecurities({
    request: t,
    securities: o,
    operation: r,
    spec: a
  });
  var c = r.requestBody || {},
    u = keys$6(c.content || {}),
    l = s && indexOf$3(u).call(u, s) > -1;
  if (n || i) {
    if (s && l) t.headers["Content-Type"] = s;else if (!s) {
      var f = u[0];
      f && (t.headers["Content-Type"] = f, s = f);
    }
  } else s && l && (t.headers["Content-Type"] = s);
  if (n) if (s) {
    if (indexOf$3(u).call(u, s) > -1) if ("application/x-www-form-urlencoded" === s || "multipart/form-data" === s) {
      if ("object" === _typeof_1(n)) {
        var p,
          h = (c.content[s] || {}).encoding || {};
        t.form = {}, forEach$4(p = keys$6(n)).call(p, function (e) {
          t.form[e] = {
            value: n[e],
            encoding: h[e] || {}
          };
        });
      } else t.form = n;
    } else t.body = n;
  } else t.body = n;
  return t;
}
function applySecurities(e) {
  var t = e.request,
    r = e.securities,
    n = void 0 === r ? {} : r,
    o = e.operation,
    a = void 0 === o ? {} : o,
    i = e.spec,
    s = assign_1({}, t),
    c = n.authorized,
    u = void 0 === c ? {} : c,
    l = a.security || i.security || [],
    f = u && !!keys$6(u).length,
    p = get_1(i, ["components", "securitySchemes"]) || {};
  return s.headers = s.headers || {}, s.query = s.query || {}, keys$6(n).length && f && l && (!isArray$8(a.security) || a.security.length) ? (forEach$4(l).call(l, function (e) {
    var t;
    forEach$4(t = keys$6(e)).call(t, function (e) {
      var t = u[e],
        r = p[e];
      if (t) {
        var n = t.value || t,
          o = r.type;
        if (t) if ("apiKey" === o) "query" === r.in && (s.query[r.name] = n), "header" === r.in && (s.headers[r.name] = n), "cookie" === r.in && (s.cookies[r.name] = n);else if ("http" === o) {
          if (/^basic$/i.test(r.scheme)) {
            var a,
              i = n.username || "",
              c = n.password || "",
              l = btoa(concat$2(a = "".concat(i, ":")).call(a, c));
            s.headers.Authorization = "Basic ".concat(l);
          }
          /^bearer$/i.test(r.scheme) && (s.headers.Authorization = "Bearer ".concat(n));
        } else if ("oauth2" === o || "openIdConnect" === o) {
          var f,
            h = t.token || {},
            y = h[r["x-tokenName"] || "access_token"],
            d = h.token_type;
          d && "bearer" !== d.toLowerCase() || (d = "Bearer"), s.headers.Authorization = concat$2(f = "".concat(d, " ")).call(f, y);
        }
      }
    });
  }), s) : t;
}
function buildRequest$1(e, t) {
  var r,
    n,
    o = e.spec,
    a = e.operation,
    i = e.securities,
    s = e.requestContentType,
    c = e.attachContentTypeForEmptyPayload;
  if ((t = applySecurities$1({
    request: t,
    securities: i,
    operation: a,
    spec: o
  })).body || t.form || c) {
    if (s) t.headers["Content-Type"] = s;else if (isArray$8(a.consumes)) {
      var u = slicedToArray(a.consumes, 1);
      t.headers["Content-Type"] = u[0];
    } else if (isArray$8(o.consumes)) {
      var l = slicedToArray(o.consumes, 1);
      t.headers["Content-Type"] = l[0];
    } else a.parameters && filter$4(r = a.parameters).call(r, function (e) {
      return "file" === e.type;
    }).length ? t.headers["Content-Type"] = "multipart/form-data" : a.parameters && filter$4(n = a.parameters).call(n, function (e) {
      return "formData" === e.in;
    }).length && (t.headers["Content-Type"] = "application/x-www-form-urlencoded");
  } else if (s) {
    var f,
      p,
      h = a.parameters && filter$4(f = a.parameters).call(f, function (e) {
        return "body" === e.in;
      }).length > 0,
      y = a.parameters && filter$4(p = a.parameters).call(p, function (e) {
        return "formData" === e.in;
      }).length > 0;
    (h || y) && (t.headers["Content-Type"] = s);
  }
  return t;
}
function applySecurities$1(e) {
  var t = e.request,
    r = e.securities,
    n = void 0 === r ? {} : r,
    o = e.operation,
    a = void 0 === o ? {} : o,
    i = e.spec,
    s = assign_1({}, t),
    c = n.authorized,
    u = void 0 === c ? {} : c,
    l = n.specSecurity,
    f = void 0 === l ? [] : l,
    p = a.security || f,
    h = u && !!keys$6(u).length,
    y = i.securityDefinitions;
  return s.headers = s.headers || {}, s.query = s.query || {}, keys$6(n).length && h && p && (!isArray$8(a.security) || a.security.length) ? (forEach$4(p).call(p, function (e) {
    var t;
    forEach$4(t = keys$6(e)).call(t, function (e) {
      var t = u[e];
      if (t) {
        var r = t.token,
          n = t.value || t,
          o = y[e],
          a = o.type,
          i = o["x-tokenName"] || "access_token",
          c = r && r[i],
          l = r && r.token_type;
        if (t) if ("apiKey" === a) {
          var f = "query" === o.in ? "query" : "headers";
          s[f] = s[f] || {}, s[f][o.name] = n;
        } else if ("basic" === a) {
          if (n.header) s.headers.authorization = n.header;else {
            var p,
              h = n.username || "",
              d = n.password || "";
            n.base64 = btoa(concat$2(p = "".concat(h, ":")).call(p, d)), s.headers.authorization = "Basic ".concat(n.base64);
          }
        } else if ("oauth2" === a && c) {
          var g;
          l = l && "bearer" !== l.toLowerCase() ? l : "Bearer", s.headers.authorization = concat$2(g = "".concat(l, " ")).call(g, c);
        }
      }
    });
  }), s) : t;
}
var arrayOrEmpty = function arrayOrEmpty(e) {
    return isArray$8(e) ? e : [];
  },
  OperationNotFoundError = createErrorType("OperationNotFoundError", function (e, t, r) {
    this.originalError = r, assign$4(this, t || {});
  }),
  findParametersWithName = function findParametersWithName(e, t) {
    return filter$4(t).call(t, function (t) {
      return t.name === e;
    });
  },
  deduplicateParameters = function deduplicateParameters(e) {
    var t,
      r = {};
    forEach$4(e).call(e, function (e) {
      r[e.in] || (r[e.in] = {}), r[e.in][e.name] = e;
    });
    var n = [];
    return forEach$4(t = keys$6(r)).call(t, function (e) {
      var t;
      forEach$4(t = keys$6(r[e])).call(t, function (t) {
        n.push(r[e][t]);
      });
    }), n;
  },
  self$3 = {
    buildRequest: buildRequest$2
  };
function execute(e) {
  var t = e.http,
    r = e.fetch,
    n = e.spec,
    o = e.operationId,
    a = e.pathName,
    i = e.method,
    s = e.parameters,
    c = e.securities,
    u = objectWithoutProperties(e, ["http", "fetch", "spec", "operationId", "pathName", "method", "parameters", "securities"]),
    l = t || r || http;
  a && i && !o && (o = legacyIdFromPathMethod(a, i));
  var f = self$3.buildRequest(objectSpread2({
    spec: n,
    operationId: o,
    parameters: s,
    securities: c,
    http: l
  }, u));
  return f.body && (isPlainObject_1(f.body) || isArray_1(f.body)) && (f.body = stringify$3(f.body)), l(f);
}
function buildRequest$2(e) {
  var t,
    r,
    n = e.spec,
    o = e.operationId,
    a = e.responseContentType,
    i = e.scheme,
    s = e.requestInterceptor,
    c = e.responseInterceptor,
    u = e.contextUrl,
    l = e.userFetch,
    f = e.server,
    p = e.serverVariables,
    h = e.http,
    y = e.parameters,
    d = e.parameterBuilders,
    g = isOAS3(n);
  d || (d = g ? OAS3_PARAMETER_BUILDERS : SWAGGER2_PARAMETER_BUILDERS);
  var m = {
    url: "",
    credentials: h && h.withCredentials ? "include" : "same-origin",
    headers: {},
    cookies: {}
  };
  s && (m.requestInterceptor = s), c && (m.responseInterceptor = c), l && (m.userFetch = l);
  var b = getOperationRaw(n, o);
  if (!b) throw new OperationNotFoundError("Operation ".concat(o, " not found"));
  var v = b.operation,
    _ = void 0 === v ? {} : v,
    A = b.method,
    E = b.pathName;
  if (m.url += baseUrl({
    spec: n,
    scheme: i,
    contextUrl: u,
    server: f,
    serverVariables: p,
    pathName: E,
    method: A
  }), !o) return delete m.cookies, m;
  m.url += E, m.method = "".concat(A).toUpperCase(), y = y || {};
  var $ = n.paths[E] || {};
  a && (m.headers.accept = a);
  var O = deduplicateParameters(concat$2(t = concat$2(r = []).call(r, arrayOrEmpty(_.parameters))).call(t, arrayOrEmpty($.parameters)));
  forEach$4(O).call(O, function (e) {
    var t,
      r,
      o = d[e.in];
    if ("body" === e.in && e.schema && e.schema.properties && (t = y), void 0 === (t = e && e.name && y[e.name])) t = e && e.name && y[concat$2(r = "".concat(e.in, ".")).call(r, e.name)];else if (findParametersWithName(e.name, O).length > 1) {
      var a;
      console.warn(concat$2(a = "Parameter '".concat(e.name, "' is ambiguous because the defined spec has more than one parameter with the name: '")).call(a, e.name, "' and the passed-in parameter values did not define an 'in' value."));
    }
    if (null !== t) {
      if (void 0 !== e.default && void 0 === t && (t = e.default), void 0 === t && e.required && !e.allowEmptyValue) throw new Error("Required parameter ".concat(e.name, " is not provided"));
      if (g && e.schema && "object" === e.schema.type && "string" == typeof t) try {
        t = JSON.parse(t);
      } catch (e) {
        throw new Error("Could not parse object parameter value string as JSON");
      }
      o && o({
        req: m,
        parameter: e,
        value: t,
        operation: _,
        spec: n
      });
    }
  });
  var S = objectSpread2(objectSpread2({}, e), {}, {
    operation: _
  });
  if ((m = g ? buildRequest(S, m) : buildRequest$1(S, m)).cookies && keys$6(m.cookies).length) {
    var T,
      w = reduce$2(T = keys$6(m.cookies)).call(T, function (e, t) {
        var r = m.cookies[t];
        return e + (e ? "&" : "") + cookie.serialize(t, r);
      }, "");
    m.headers.Cookie = w;
  }
  return m.cookies && delete m.cookies, mergeInQueryOrForm(m), m;
}
var stripNonAlpha = function stripNonAlpha(e) {
  return e ? e.replace(/\W/g, "") : null;
};
function baseUrl(e) {
  return isOAS3(e.spec) ? oas3BaseUrl(e) : swagger2BaseUrl(e);
}
function oas3BaseUrl(e) {
  var t = e.spec,
    r = e.pathName,
    n = e.method,
    o = e.server,
    a = e.contextUrl,
    i = e.serverVariables,
    s = void 0 === i ? {} : i,
    c = get_1(t, ["paths", r, (n || "").toLowerCase(), "servers"]) || get_1(t, ["paths", r, "servers"]) || get_1(t, ["servers"]),
    u = "",
    l = null;
  if (o && c && c.length) {
    var f = map$4(c).call(c, function (e) {
      return e.url;
    });
    indexOf$3(f).call(f, o) > -1 && (u = o, l = c[indexOf$3(f).call(f, o)]);
  }
  if (!u && c && c.length) {
    u = c[0].url;
    var p = slicedToArray(c, 1);
    l = p[0];
  }
  if (indexOf$3(u).call(u, "{") > -1) {
    var h = getVariableTemplateNames(u);
    forEach$4(h).call(h, function (e) {
      if (l.variables && l.variables[e]) {
        var t = l.variables[e],
          r = s[e] || t.default,
          n = new RegExp("{".concat(e, "}"), "g");
        u = u.replace(n, r);
      }
    });
  }
  return buildOas3UrlWithContext(u, a);
}
function buildOas3UrlWithContext() {
  var e,
    t,
    r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
    o = r && n ? Url.parse(Url.resolve(n, r)) : Url.parse(r),
    a = Url.parse(n),
    i = stripNonAlpha(o.protocol) || stripNonAlpha(a.protocol) || "",
    s = o.host || a.host,
    c = o.pathname || "";
  i && s ? e = concat$2(t = "".concat(i, "://")).call(t, s + c) : e = c;
  return "/" === e[e.length - 1] ? slice$5(e).call(e, 0, -1) : e;
}
function getVariableTemplateNames(e) {
  for (var t, r = [], n = /{([^}]+)}/g; t = n.exec(e);) r.push(t[1]);
  return r;
}
function swagger2BaseUrl(e) {
  var t,
    r,
    n = e.spec,
    o = e.scheme,
    a = e.contextUrl,
    i = void 0 === a ? "" : a,
    s = Url.parse(i),
    c = isArray$8(n.schemes) ? n.schemes[0] : null,
    u = o || c || stripNonAlpha(s.protocol) || "http",
    l = n.host || s.host || "",
    f = n.basePath || "";
  u && l ? t = concat$2(r = "".concat(u, "://")).call(r, l + f) : t = f;
  return "/" === t[t.length - 1] ? slice$5(t).call(t, 0, -1) : t;
}
function Swagger(e) {
  var t = this,
    r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if ("string" == typeof e ? r.url = e : r = e, !(this instanceof Swagger)) return new Swagger(r);
  assign_1(this, r);
  var n = this.resolve().then(function () {
    return t.disableInterfaces || assign_1(t, Swagger.makeApisTagOperation(t)), t;
  });
  return n.client = this, n;
}
Swagger.http = http, Swagger.makeHttp = bind$2(makeHttp).call(makeHttp, null, Swagger.http), Swagger.resolve = resolve, Swagger.resolveSubtree = resolveSubtree, Swagger.execute = execute, Swagger.serializeRes = serializeRes, Swagger.serializeHeaders = serializeHeaders, Swagger.clearCache = clearCache$1, Swagger.makeApisTagOperation = makeApisTagOperation, Swagger.buildRequest = buildRequest$2, Swagger.helpers = {
  opId: opId
}, Swagger.getBaseUrl = baseUrl, Swagger.prototype = {
  http: http,
  execute: function (e) {
    return this.applyDefaults(), Swagger.execute(objectSpread2({
      spec: this.spec,
      http: this.http,
      securities: {
        authorized: this.authorizations
      },
      contextUrl: "string" == typeof this.url ? this.url : void 0,
      requestInterceptor: this.requestInterceptor || null,
      responseInterceptor: this.responseInterceptor || null
    }, e));
  },
  resolve: function () {
    var e = this,
      t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return Swagger.resolve(objectSpread2({
      spec: this.spec,
      url: this.url,
      http: this.http || this.fetch,
      allowMetaPatches: this.allowMetaPatches,
      useCircularStructures: this.useCircularStructures,
      requestInterceptor: this.requestInterceptor || null,
      responseInterceptor: this.responseInterceptor || null
    }, t)).then(function (t) {
      return e.originalSpec = e.spec, e.spec = t.spec, e.errors = t.errors, e;
    });
  }
}, Swagger.prototype.applyDefaults = function () {
  var e = this.spec,
    t = this.url;
  if (t && startsWith_1(t, "http")) {
    var r = Url.parse(t);
    e.host || (e.host = r.host), e.schemes || (e.schemes = [r.protocol.replace(":", "")]), e.basePath || (e.basePath = "/");
  }
};
export default Swagger;